const translations = {
    123: "123",
    2323: "4234",
    cancel: "取消",
    "workFlow.categoryList.placeholderSort": "请输入排序",
    "custmerForm.viewHistory.tableCurrentVersion": "当前版本",
    "workFlow.roams.nodeType": "节点类型：",
    "editorModule.alignLeft": "左边对齐",
    "companyManager.tabApprovalRole": "审批角色",
    "workFlow.Bpmn.titleShrink": "收缩侧边栏",
    mobileFunctionOrder: "移动端功能排序",
    "fileManagement.titleRename": "重命名",
    "workFlow.Process.placeholderFIcon": "请填写功能图标",
    "user.setting": "个人设置（用户）",
    "workFlow.Process.optionTwo": "候选审批人包含上一节点审批人",
    "custmerForm.disableFormBtn": "禁用表单",
    "mobileDev.functionDesignStepThree.formPage": "表单页面",
    "language.translation.hinrEnter": "请输入",
    addedMobileFunction: "新增移动功能",
    ten: "十",
    counterCannotLessThanMin: "计数器默认值不能小于最小值",
    "orgDepartManagement.roleConfiguration.hintRName":
        "请输入角色名称",
    "code.codeStepFour.titleFastImport": "快速导入配置",
    "workFlow.Process.labelApproval": "审批中",
    "workFlow.WFMonitor.tabGrade": "等级",
    "workFlow.User.radioUseDirectly": "直接使用签章",
    curProgress: "当前进度",
    "dataItem.dialogInstall.labelName": "分类名称",
    "mobileDev.functionDesignStepFour.timeQuery": "时间查询",
    "BI.components.gauge.labelTSize": "指标字号",
    cannotExceed2Characters: "不能超过2个字符",
    "workFlow.zh.listeners": "监听器",
    "menuManagement.editModal.tabName": "名称",
    "mobileDev.homeRightSide.title": "标题",
    fillOutputObjectParmName: "请填写输出对象参数名称",
    "workFlow.selectAuthority.hintAddSuccess":
        "添加模板权限人成功！",
    left: "靠左",
    mustSelectMostChildLevel: "必须选择到最子级",
    "workFlow.appointUser.labelCurrent": "【当前】",
    "code.leftScrollbar.hintTypeNotEmpty": "生成类型不能为空",
    "workFlow.WFLaunch.stampCategory": "模板分类",
    "code.codeStepThree.tabType": "查询类别",
    "mobileDev.loginCenterContainer.phoneLogin": "手机号登录",
    "mobileDev.homeRightSide.dataShow":
        "根据默认显示数量取数据集数据进行显示",
    "workFlow.User.allowOption": "允许",
    "mobileDev.homeRightSide.labelCarouselType": "轮播图类型",
    "BI.echart.video": "Video",
    "databaseManage.dataSource.testViewBtn": "测试查看",
    "workFlow.zh.documents": "文档",
    "mobileDev.functionDesignStepFive.titleSetFName":
        "列表字段名设置",
    "workFlow.zh.scriptFormat": "脚本格式",
    inputUserName: "请输入用户名",
    "workFlow.zh.timerDefinition": "定时器定义",
    "databaseManage.databaseTable.openDataTableModalTitle":
        "打开表数据",
    "BI.components.main.labelFontSize": "字体大小",
    "workFlow.Process.noteFive":
        "5. 平台版本小于“V2.0.2.1”之前的版本，“系统表单”需要对代码进行微调方可使用此功能。",
    "workFlow.Approver.roleCompanyBtn": "审批角色（公司）",
    enterCorrectQQNumber: "请输入正确的QQ号",
    "code.codeStepFour.hintBindBtn": "请选择绑定按钮",
    "code.rightPanel.right": "右侧",
    "mobileDev.functionDesignStepFour.DataFieldQ": "数据字段查询",
    "mobileDev.functionDesignStepSeven.fixedStoActClass":
        "仓储实现类",
    "BI.echart.pictorialBar": "象形图",
    "workFlow.zh.error": "错误",
    "mobileDev.loginRightSide.labelUserHintInfor": "用户名提示信息",
    "editorModule.code": "代码",
    "code.codeForm.saveBtn": "保存模板",
    "orgRoleManagement.databaseAuth.sysFunction": "系统功能",
    "workFlow.Process.noteThree":
        "3. 点击“发起审批”按钮会自动使用选择的列表数据填充相应表单，如果流程不存在选择的表单，则不进行任何处理。",
    failedModifyPost: "修改岗位失败！",
    "workFlow.zh.signalThrow": "信号中间抛出事件",
    webOwnSuperior: "web端所属上级",
    deleteVersion: "删除版本",
    userId: "用户编号",
    the: "第",
    "databaseManage.dataLink.writeDatabasePort": "请填写数据库端口",
    "mobileDev.loginDesignStepOne.tabNum": "#",
    "workFlow.zh.collapsedPool": "折叠池",
    "BI.group.top.hintNoModified": "模版例子不能修改",
    "mobileDev.listRightSide.optionNo": "否",
    "importAndExport.importForm.tabName": "名称",
    "editorModule.edit": "编辑",
    "workFlow.Process.processTemplateName": "流程模板名称",
    "code.codeStepOne.relationField": "关联表对应字段",
    currentProcess: "当前流程",
    "code.rightPanel.validationModel": "校验模型",
    interfaceNameOrInterfaceCode: "输入接口名称或接口地址进行查询",
    configVariableValues: "请配置变量值",
    "crud.editBtn": "编辑",
    "forme.editModal.quickImportBtn": "快速导入",
    "workFlow.zh.evenGateway": "Complex gateway",
    "login.password": "请输入密码",
    "workFlow.filedConfig.priority": "等级",
    "workFlow.historyList.tabCreateDate": "创建时间",
    "messageIndex.hintAllReadFailed": "全部设置消息已读失败",
    "navbar.userinfo": "个人信息",
    "workFlow.Process.labelApproved": "审批通过",
    "companyManager.companyFormDialog.placeholderComName":
        "请填写公司名称",
    "dataItem.addModal.placeholderRemarks": "请填写备注",
    "taskScheduling.taskDesign.addModal.radioFrequencyFour":
        "表达式设置",
    fieldAssociatedTable: "的关联表对应字段",
    "codeRule.tableCreateTime": "创建时间",
    processDesignModificationFailed: "流程设计修改失败！",
    "databaseManage.databaseTable.addSheet.tableDataType":
        "数据类型",
    "taskScheduling.taskDesign.addFrequencyModal.unitWeek": "周",
    "mobileDev.listRightSide.optionItalicBold": "斜体加粗",
    assignmentConfig: "赋值配置",
    "mobileDev.homeRightSide.mnualConfig": "手动配置",
    "code.rightPanel.popupSize": "弹窗尺寸",
    "editorModule.newWindow": "在新窗口打开",
    subtable: "子表",
    "taskScheduling.taskDesign.tableOverTime": "结束时间",
    whseNumber: "出库编号",
    "editorModule.replaceWith": "替换为",
    "sponsor'sCompanyId": "发起人所属公司ID",
    assType: "赋值类型",
    "BI.components.main.labelOrient": "布局朝向",
    "withdrawalSuccessfulRe-initiated": "撤回成功，已重新发起！",
    "deletePrompt.savedFailure": "保存失败!",
    "editorModule.search": "搜索",
    "mobileDev.formRightSide.pictureBox": "图片框",
    "mobileDev.functionDesignForm.stepThree": "移动端表单",
    "mobileDev.tableSet.tabAlign": "对齐",
    "fileManagement.buildFileBtn": "新建文件夹",
    "mobileDev.loginRightSide.clearBtn": "清除",
    "BI.Build.bottomAlign": "底对齐",
    selectApiParameterValue: "请选择api参数值",
    "deletePrompt.initiatingProcess": "发起流程中",
    invalidOutputParameterEncodingInterfaceVariable:
        "接口变量中有使用无效的输出参数编码，请先修改再下一步",
    "taskScheduling.taskDesign.stopBtn": "暂停任务",
    "Log.tableNumber": "#",
    "companyManager.modalSelectContentPrompt": "请选择一行再操作！",
    "editorModule.disc": "实心圆",
    "code.leftScrollbar.component.timeRange": "时间范围",
    "workFlow.WFDesign.exportFlowBtn": "导出流程",
    "forme.addModal.tableHeaderWidth": "宽度(单位：px)",
    "user.info.twoPassword": "二次输入密码不一致",
    "code.rightPanel.btnText": "按钮文字",
    "code.leftScrollbar.placeholderFileName": "请输入文件名",
    "language.languageCategory.cs-CZ": "捷克语",
    multiply: "乘",
    "orgUserManagement.addModal.placeholTelephone": "请填写电话",
    DataOptionForTheDataDictionaryNotSelected:
        "数据字典的数据选项未选择",
    "code.rightPanel.placeholderRate": "请输入税率",
    "form.empty": "清空",
    enterShowName: "请输入显示名称",
    "workFlow.zh.lassoTool": "激活套索工具",
    "code.codeStepTwoListStructure.hintDataFormat":
        "请输入数据格式",
    "menuManagement.tableFileAddress": "文件地址",
    noRequestModeSpecified: "没有填写请求方式",
    "reportModule.reportRelease.labelMenuName": "菜单名称",
    "dataItem.dialogInstall.labelEfficient": "有效",
    "code.codeStepSix.placeholderFounder": "请填写创建人",
    "workFlow.privateStampInfo.hintStopSuccess": "停用成功！",
    basicSet: "基础设置",
    "code.leftScrollbar.component.radioGroup": "单选框组",
    assignVariablesUsingApi: "使用API赋值变量",
    "enterInterfaceName/AddrQuery":
        "输入接口名称或接口地址进行查询",
    "mobileDev.loginDesTitle": "登录页面设计",
    "editorModule.mediumPurple": "中紫色",
    "workFlow.zh.cancelEnd": "取消结束事件",
    fillInClickConfigCustomOutputParamters:
        "请填写或点击配置自定义出参值",
    "editorModule.insertDateTime": "插入日期/时间",
    "mobileDev.functionDesignStepSix.hintFunctionN":
        "请填写功能类名，只能输入英文数字下划线，不大于20个字符",
    "databaseManage.dataLink.tableDatabaseAccount": "数据库账号",
    "workFlow.searchConfig.placeholderEg":
        "例如：创建时间、修改时间等",
    "mobileDev.loginRightSide.labelGradientTwo": "按钮背景渐变色2",
    "workFlow.userButtonSetting.btnName": "按钮名称",
    "databaseManage.databaseField.tableDescribe": "描述",
    "user.info.Company": "公司：",
    "crud.tipEndTitle": "项",
    "deletePrompt.importComplete": "导入完成！",
    "code.codeStepTwoListStructure.hintTableName": "请输入表名",
    "route.api": "全局函数",
    "code.rightPanel.characterLength": "请输入字符长度",
    "forme.editModal.addBtn": "新增",
    "mobileDev.functionDesignStepFive.titleNotShown":
        "未显示到列表字段",
    "deletePrompt.hintBatchDelete": "确定要批量删除所选项吗？",
    "mobileDev.functionDesignForm.stepOne": "选择模板",
    "withdrawalSuccessfulGoTo-doTaskView":
        "撤回成功，请去待办任务进行查看！",
    "selectPost.titleSelectPost": "选择岗位",
    "editorModule.type": "类型",
    "code.codeStepTwoListStructure.hintEditData": "编辑数据",
    "codeRule.addModal.tableStep": "步长",
    "editorModule.none": "无",
    "editorModule.imageDescr": "图片描述",
    "importAndExport.importForm.selectData": "选择数据源",
    "editorModule.cediSign": "塞地符号",
    "code.codeStepFour.editBtn": "编辑",
    "mobileDev.mobileSchema.tabIcon": "图标",
    "mobileDev.homeRightSide.six": "六",
    "code.codeStepTwoListStructure.integer": "整数",
    businessPlatform: "业务平台",
    "editorModule.help": "帮助",
    "mobileDev.homeRightSide.descrField": "说明字段",
    keepAtLeastOneOption: "至少保留一个选项",
    "messageIndex.labelNews": "新闻",
    "subSystemForm.placeholderDescription": "请输入描述",
    "custmerForm.classifiedManagement.Hint.formName":
        "请填写表单名称",
    "taskScheduling.taskDesign.addModal.taskRestartFive": "次",
    "dataItem.addModal.modalTitle": "添加字典",
    "workFlow.createFLow.hintInfor": "消息",
    "mobileDev.homeRightSide.labelLink": "更多指向链接",
    "code.leftScrollbar.component.cascadeSelect": "级联选择",
    enterTheVersionNameVersionNumberToQuery:
        "输入版本名称或版本编号进行查询",
    "workFlow.processTasks.transposeBtn": "转办",
    "BI.echart.img": "图片",
    "subSystem.tableDescription": "描述",
    "code.codeStepThree.line4": "1/4行",
    "code.codeStepThree.line3": "1/3行",
    "deletePrompt.prompEmpty": "确定要清空吗？",
    "code.codeStepThree.line2": "1/2行",
    "code.codeStepThree.line1": "1/1行",
    "workFlow.categoryList.placeholderRemark": "请输入备注",
    "importAndExport.excelImport.tableFounder": "创建人",
    "orgRoleManagement.databaseAuth.radioComSubcom":
        "仅查看本公司及所有下属公司",
    "databaseManage.dataSource.addModalTitle": "添加数据库",
    "code.codeStepThree.line6": "1/6行",
    "mobileDev.functionDesignStepTwo.fixedTitle": "数据库列表",
    "workFlow.addStamp.generatedBtn": "生成",
    product: "产品类",
    exampleStackBarChart: "堆叠条形图示例",
    "forme.addModal.placeholderSelect": "请选择",
    "databaseManage.databaseTable.addSheet.launchSuccessful":
        "发布成功！",
    "workFlow.printCurrentPage.labelUnderline": "下划线风格",
    "BI.group.loading": "加载中...",
    "workFlow.User.associatedComponent": "关联表单意见框组件",
    "workFlow.Process.whetherInherit":
        "用户任务是否继承开始节点表单",
    "code.codeStepEight.hint": "(非专业人员请勿勾选此项！)",
    "user.info.Role": "角色：",
    "workFlow.createFLow.hintLoading": "加载中...",
    "orgDepartManagement.tabName": "部门名称",
    "workFlow.User.optionOrder": "顺序执行",
    selectFunctionIcon: "请选择功能图标",
    "selectUser.hintOnlyOne": "只可以选择一个，不可以多选",
    "code.rightPanel.placeholderPrompt": "占位提示",
    thousand: "千",
    "BI.Build.Hide": "隐藏",
    "editorModule.robots": "机器人",
    "route.logs": "日志监控",
    "BI.listIndex.Published": "已发布",
    "wel.welIndex.lastMouthEnergyCons": "上月吨水能耗：",
    interfaceVariables: "接口变量",
    "orgDepartManagement.departmentFormDialog.placeholderManager":
        "请填写负责人",
    "workFlow.zh.expression": "表达式",
    "code.rightPanel.compSize": "组件尺寸",
    "editorModule.darkGreen": "深绿色",
    "companyManager.orgList.labelRoleName": "角色名称",
    "code.rightPanel.placeholderPeriod": "请输入时间段",
    "workFlow.WFMonitor.hintWhetherHangUp": "是否确认挂起？",
    twoRandomDigit: "2位随机数",
    noConfigParameters: "没有配置参数",
    "taskScheduling.taskDesign.tableDescription": "说明",
    "importAndExport.importForm.labelShowField": "显示字段",
    subprocessDoesNotHaveInitiatorSelected: "子流程没有选择发起人",
    "codeRule.addModal.placeholderNumber": "请填写编码编号",
    "BI.components.flop.labelXSpace": "X间距",
    "workFlow.WFMenu.tagFormField": "查看列表显示表单字段",
    "editorModule.style": "样式",
    "databaseManage.dataSource.addModalName": "名称",
    "code.codeStepSix.titleAdd": "新增字典项",
    "editorModule.advanced": "高级",
    "BI.listIndex.deleteIcon": "删除",
    "login.msgText": "发送验证码",
    "editorModule.contrast": "对比度",
    "Notice.tabNum": "#",
    "language.dataDictionary.hintTitle": "删除提示",
    "code.codeForm.Hint.sameNameError":
        "当前功能类名已存在，相同功能类名会引起系统功能出错！",
    "editorModule.flipHorizontally": "水平翻转",
    moveToRecycleBinFailed: "移入回收站失败！",
    "editorModule.zoomOut": "缩小",
    "code.leftScrollbar.component.timeSelect": "时间选择",
    "importAndExport.importForm.tabNum": "#",
    "wel.welIndex.lastMonthCapacity": "上月处理量：",
    "workFlow.zh.escalationEnd": "定时结束事件",
    "editorModule.alternativeSource": "镜像",
    "wechatAndDingTalk.userManagement.Hint.Loading": "加载中...",
    selectCustomOutputCategoryBeforeProceed:
        "请先选择自定义出参类别后再进行操作",
    "companyManager.orgList.labelDeparName": "部门名称",
    "code.codeStepFour.dataSourceSelect": "数据源选择",
    "databaseManage.dataSource.addModalWriteName": "请填写名称",
    "forgetPass.submitBtn": "提交",
    "navbar.bugs": "条错误日志",
    "workFlow.WFDesign.agree": "同意",
    "code.rightPanel.hintDataConfig": "-联想数据配置",
    "BI.Build.bgColor": "背景颜色",
    "orgUserManagement.Hint.userEnabled": "该用户是启用状态！",
    "buttonModule.batchDeletionBtn": "批量删除",
    "databaseManage.dataLink.anotherName": "别名",
    "workFlow.User.selectAssociatedComponent":
        "==请选择需要关联的组件==",
    formComponentSelect: "表单组件选择",
    "reportModule.reportRelease.labelFuncDesc": "功能描述",
    "code.leftScrollbar.selectModule": "选择型组件",
    "databaseManage.dataSource.addModalWriteSQLstatement":
        "请填写sql语句",
    selectVariable: "选择变量",
    "fileManagement.Hint.uploadFailed": "上传失败！",
    "orgRoleManagement.setAuthorizeModal.Modal.Title":
        "复用已有权限",
    "workFlow.Step1.placeholderIcon": "请填写图标",
    "mobileDev.functionDesignStepEight.placeholderSelect": "请选择",
    "editorModule.premiumPlugins": "优秀插件：",
    "interfaceManage.addModal.placeholderName": "请填写接口名称",
    "Notice.tabStatus": "发布状态",
    newConfig: "新增配置",
    "orgRoleManagement.addModal.Efficient": "有效",
    "workFlow.zh.changeType": "修改类型",
    "orgUserManagement.addModal.placeholderSelect": "请选择",
    addFlowParaParaValueSql: "添加流程参数参数值SQL语句",
    "code.codeStepThree.timeInq": "时间查询",
    "mobileDev.functionDesignStepSeven.fixedStoLayer": "仓储层",
    "mobileDev.formRightSide.placeholderMaxImg":
        "请输入最多可选图片数",
    invalidVariableParameterCustomParameterAssignment:
        "自定义出参赋值有使用无效的变量参数，请先修改再下一步",
    "editorModule.height": "高",
    "companyManager.companyFormDialog.labelFax": "传真",
    "importAndExport.importForm.optionJump": "跳过",
    dataSelect: "数据选择",
    "BI.Build.scrWidth": "大屏宽度",
    "codeRule.addModal.modalTitle": "添加单据编码",
    "editorModule.symbols": "符号",
    "workFlow.zh.terminateEnd": "终止结束事件",
    "orgRoleManagement.databaseAuth.radioEnable": "启用",
    compName: "组件名称",
    "code.leftScrollbar.component.dateSelect": "日期选择",
    circulate: "传阅",
    "editorModule.blue": "蓝色",
    "code.codeStepSix.placeholderSelect": "请选择",
    "taskScheduling.taskDesign.addModal.completeBtn": "完成",
    "companyManager.companyFormDialog.placeholderFoundedTime":
        "请填写成立时间",
    "mobileDev.functionDesignStepSeven.headTitle": "代码预览",
    "wechatAndDingTalk.departmentManagement.tableAbbreviation":
        "部门简称",
    "mobileDev.formRightSide.optionTime": "当前时间",
    "mobileDev.homeRightSide.bar": "柱状图",
    "workFlow.filedConfig.alignRight": "右对齐",
    表单信息: "表单信息",
    "mobileDev.homeRightSide.defaultNum": "默认显示数量",
    "workFlow.WFMenu.dialogTitle.editMenu": "编辑专项菜单",
    "orgRoleManagement.setAuthorizeModal.btnAuthority": "按钮权限",
    "workFlow.userButtonSetting.database": "数据库",
    "interfaceManage.addModal.hintFieldType": "请选择字段类型",
    "code.rightPanel.suffix": "后缀",
    "mobileDev.functionDesignStepSeven.fixedForm": "表单页",
    "editorModule.noColor": "无",
    "BI.listIndex.copySuccess": "复制成功",
    "language.languageCategory.zh-TW": "繁体中文",
    "databaseManage.databaseTable.addSheet.tableIsnullable":
        "允许空",
    "companyManager.companyFormDialog.labelInnerPhone": "分机号",
    "code.leftScrollbar.component.rate": "税率组件",
    exampleFunnelPlot: "漏斗图示例",
    listTitle: "列表标题",
    "workFlow.selectAuthority.authorityBtn": "取模板权限人",
    "code.leftScrollbar.component.checkboxGroup": "多选框组",
    "workFlow.roams.approval": "审批",
    chartComp: "图表组件",
    "code.leftScrollbar.hint": "从左侧拖入或点选组件进行表单设计",
    "code.rightPanel.formBtn": "表单按钮",
    "BI.components.table.titleHeaderSet": "表头设置",
    "editorModule.kipSign": "老挝基普符号",
    "code.rightPanel.endOccupy": "结束占位",
    "workFlow.schemeFormDialog.formPreview": "表单预览",
    "crud.editTitle": "编辑",
    "messageIndex.labelWorkflow": "工作流",
    "code.codeStepTwoListStructure.hintDatabaseTable":
        "请选择数据库表",
    "taskScheduling.taskDesign.addFrequencyModal.September": "九月",
    "workFlow.Step1.placeholderFName": "请填写功能名称",
    cannotExceed3Characters: "不能超过3个字符",
    "workFlow.categoryList.tabNum": "#",
    two: "二",
    "editorModule.scope": "范围",
    "forme.addModal.stepTwo": "查询配置",
    "BI.components.datetime.labelCustomize": "自定义格式",
    "Notice.labelInforSou": "信息来源",
    editVersion: "编辑版本",
    "workFlow.Circulate.labelType": "类型",
    updateFormData: "更新表单数据",
    "workFlow.Process.placeholderTimeoutTime":
        "请填写超时时间(小时)",
    "taskScheduling.taskDesign.tableRunning": "运行中",
    "editorModule.dollarSign": "美元符号",
    reportReleaseAddedSuccessfully: "报表发布新增成功！",
    "BI.components.text.titleLinkSet": "超链设置",
    "formDesign.labelSort": "表单分类",
    "BI.components.flop.titleBorderSet": "边框设置",
    "editorModule.link": "连接",
    "editorModule.quotations": "引用",
    "BI.listMap.mapData": "地图数据",
    "mobileDev.homeDesignStepTwo.indexBtn": "首页",
    "code.codeStepSix.applyWF": "是否适用于工作流",
    showNodeInfor: "显示节点信息",
    "workFlow.Process.SuperiorFunction": "上级功能",
    "editorModule.showBlocks": "显示区块边框",
    "mobileDev.formRightSide.optionUriOrNull": "网址格式或空！",
    "interfaceManage.addModal.tableNumber": "#",
    "workFlow.filedConfig.alignLeft": "左对齐",
    "orgRoleManagement.tabFounder": "创建人",
    "editorModule.top": "顶部对齐",
    "deletePrompt.failedDeleted": "删除失败！",
    "reportModule.reportRelease.labelSort": "排序",
    "workFlow.processTasks.placeholderSerialNum": "请输入流水号",
    "code.leftScrollbar.component.optionOne": "选项一",
    "wel.welIndex.titleCost": "成本(元)",
    "code.leftScrollbar.emptyBtn": "清空",
    sponsorId: "发起人ID",
    "BI.echart.radar": "雷达图",
    "mobileDev.tableSet.tabTotal": "合计",
    dataCustomParameterCannotEmpty:
        "自定义出参的各项数据不能为空！",
    "mobileDev.mobileSchema.funcList": "功能列表",
    "workFlow.zh.configConnector": "必须配置连接器",
    "BI.Build.refreshBtn": "刷新",
    "BI.Build.dataValue": "数据值",
    "workFlow.zh.activateTool": "激活全局连接工具",
    "editorModule.activity": "活动",
    "route.info": "个人信息",
    "crud.hide": "隐藏",
    editInterfaceCategories: "编辑接口分类",
    "route.test": "测试页面",
    "deletePrompt.disableSuccessful": "禁用成功!",
    targetParameterVariable: "目标参数变量",
    "buttonModule.exportBtn": "导出",
    "workFlow.addStamp.radioUpload": "上传照片",
    "reportModule.reportRelease.hintParMenu": "请填写父级菜单",
    "mobileDev.formCenterContainer.boxUpload": "点击上传",
    "mobileDev.workflow": "工作流",
    fourRandomDigits: "4位随机数",
    "orgDepartManagement.departmentFormDialog.labelParentDep":
        "上级部门",
    newsCenter: "新闻中心",
    "editorModule.lightGreen": "浅绿色",
    "messageIndex.allReadBtn": "全部设置已读",
    "code.leftScrollbar.component.option1": "选项1",
    page: "页面",
    removeOptionSub: "是否删除该选项以及子选项?",
    "workFlow.WFDesign.hintFlowEnabled": "该流程已启用！",
    completedExpired: "完成/过期",
    "language.translation.tagNameSearch":
        "输入翻译标记名称进行查询",
    "workFlow.addStamp.hintuploadImg": "请上传图片",
    "workFlow.schemeFormIndex.tabFormID": "表单ID",
    "BI.components.map.labelAreaColor": "区域颜色",
    noLimit: "不限制",
    "orgDepartManagement.departmentFormDialog.labelDepCode":
        "部门编码",
    "mobileDev.formRightSide.optionFax": "必须为传真格式！",
    "code.codeForm.previousBtn": "上一步",
    "code.rightPanel.placeholderFormModel": "请输入数据模型",
    selectNodeWithdraw: "请选择撤回到的节点",
    "mobileDev.loginRightSide.labelUserIcon": "用户名图标",
    "custmerForm.classifiedManagement.tableWhetherEffective":
        "是否有效",
    "workFlow.WFDelegate.tabEndDate": "结束时间",
    "forme.addModal.functionOrder": "功能排序",
    "menuManagement.addModal.iconModal.modalTitle": "选择图标",
    noSqlFill: "没有填写sql语句",
    "editorModule.copy": "复制",
    "workFlow.schemeFormIndex.tabFormName": "表单名称",
    selectMobileFunctionIcon: "请选择移动端功能图标",
    equal: "等于",
    outboundOverview: "出库总览",
    "-dataSourceConfiguration": "-数据源配置",
    "importAndExport.excelImport.tableCreateTime": "创建时间",
    "language.languageCategory.tr-TR": "土耳其语",
    processPerformedOrderOperationAcoidError:
        "过程处理会按照操作的顺序执行，为避免出错，请严格制定操作顺序。拖动顺序列即可进行排序操作。",
    "mobileDev.functionDesignStepFour.mobileListTitle":
        "移动端列表页面标题",
    "mobileDev.loginRightSide.labelBorderSize": "边框大小",
    "mobileDev.loginDesignStepOne.tabName": "登录页设计名称",
    operateConfig: "操作配置",
    whetherUpdateVersion: "确认是否进行流程版本更新",
    internalInterface: "内部接口",
    "BI.components.pie.labelRing": "设置为环形",
    fillInClickConfigVariableValues: "请填写或点击配置变量值",
    "workFlow.zh.intermediateThrow": "创建中间抛出事件/边界事件",
    "orgRoleManagement.setAuthorizeModal.formAuthority": "表单权限",
    "BI.listIndex.Modal.Group": "分组",
    "workFlow.Process.placeholderFDescr": "请输入功能描述",
    three: "三",
    "code.codeStepFour.importBtn": "快速导入",
    "code.leftScrollbar.component.currencyUnit": "货币单位",
    "code.leftScrollbar.workflow": "工作流程",
    "mobileDev.listRightSide.fontSize": "字体大小",
    "workFlow.Process.placeholderOwnSys": "请选择所属系统",
    "language.languageType.addModal.addTitle": "添加语言类型",
    "BI.components.tabs.titleHighlightSet": "高亮设置",
    "forme.tableHeaderNumber": "#",
    "reportModule.reportRelease.tabRemark": "备注",
    "mobileDev.listRightSide.optionDefaultStyle": "默认样式",
    "editorModule.openLink": "链接打开位置...",
    "BI.group.top.Redo": "重做",
    "forgetPass.hintSentSuccess": "短信消息发送成功",
    receiptDate: "收款日期",
    "mobileDev.formRightSide.optionMobileOrPhoneOrNull":
        "电话格式或手机格式或空！",
    "workFlow.WFDesign.tabCode": "编码",
    "codeRule.tableObjectName": "对象名称",
    "editorModule.focusToolbar": "移动焦点到工具栏",
    "workFlow.Process.namingRule": "流程任务命名规则配置",
    "code.rightPanel.delimiter": "分隔符",
    "BI.listIndex.Modal.selectIcon": "请选择图标",
    "BI.components.main.labelLegend": "图例",
    "wel.welIndex.yuanLin": "缘林水务",
    "mobileDev.functionDesignStepSeven.fixedEntityClass": "实体类",
    originatorName: "发起人员名称",
    "searchModule.endDatePlaceholder": "结束日期",
    log: "日志",
    "BI.Build.Size": "大小",
    "editorModule.mediumGray": "中灰色",
    "Notice.hintSelectNotTyle": "请选择公告类别",
    "code.codeStepFive.showResult": "效果展示(展示数据为模拟数据)",
    "forgetPass.resetPWD": "请输入重置密码",
    "Log.tableFunction": "系统功能",
    "editorModule.cut": "剪切",
    "mobileDev.listRightSide.fontStyle": "字体样式",
    "taskScheduling.taskDesign.addFrequencyModal.minuteError":
        "请填写0-59以内的数字",
    uploader: "上传人员",
    "mobileDev.tableSet.placeholderFieldTitle": "请输入字段标题",
    "editorModule.dropImageHere": "拖放一张图像至此",
    "editorModule.clearFormat": "清除格式",
    "tagsView.closeOthers": "关闭其它",
    settleWay: "结算方式",
    "code.leftScrollbar.component.defaultDepart": "系统默认(部门)",
    "editorModule.poweredByZero": "由{0}驱动",
    "workFlow.zh.taskPriority": "任务优先级",
    "workFlow.historyList.tabCurVersion": "当前版本",
    "mobileDev.loginRightSide.phoneLogin": "手机号登录",
    "menuManagement.tableDescription": "描述",
    "Schedule.deleteBtn": "删除",
    "workFlow.processTasks.todoTasks": "待办任务",
    "taskScheduling.taskDesign.addFrequencyModal.December":
        "十二月",
    "codeRule.addModal.labelDescription": "编码说明",
    "workFlow.processTasks.hintUnselected":
        "您未选择任何转办审批人",
    "fileManagement.Hint.fromSubmitFailed": "表单提交失败!",
    "editorModule.permanentPenOne": "永久笔属性",
    "workFlow.zh.conditionalBoundary": "条件边界事件",
    "Exclusive Gateway": "互斥网关",
    "code.rightPanel.period": "时间段",
    useApiAssignCharacterTypeParameters: "使用API赋值字符类型出参",
    "menuManagement.hintEditFailed": "编辑失败",
    "codeRule.addModal.labelName": "编码名称",
    "searchModule.startPlaceholder": "开始时间",
    "code.codeStepSix.hintOutArea": "请选择输出区域",
    "editorModule.strikeThrough": "删除线",
    "companyManager.companyFormDialog.labelComCode": "公司编码",
    "BI.listCategory.hintModifySuccess": "修改成功",
    "workFlow.WFMonitor.examinerBtn": "指派审核人",
    "BI.Build.staticData": "静态数据",
    "mobileDev.functionDesignStepSeven.fixedSerActClass":
        "服务实现类",
    "workFlow.WFChange.tabCreateDate": "创建时间",
    systemComp: "系统组件",
    "workFlow.menuForm.titleQueryDeploy": "查询配置",
    "language.translation.placeholderTagCode": "请输入翻译标记编码",
    pleaseEnterVersionNumber: "请输入版本编号",
    "Create parallel-gateway-event": "并行网关",
    fillSqlEg:
        "请填写SQL语句（只支持查询语句），输入格式如：select * from table",
    "PCDevGuide.kanbanDesign": "看板设计",
    "editorModule.lightBlue": "浅蓝色",
    MainSystem: "开发平台",
    "Log.fixedLogin": "登录日志",
    "wel.welIndex.Rank": "排名",
    "workFlow.WFChange.moveTrashBtn": "移入回收站",
    "wel.welIndex.waterVolume": "水量",
    "News.placeholderNewsSection": "请选择新闻栏目",
    done: "已办",
    "workFlow.WFDesign.printing": "打印",
    "taskScheduling.taskDesign.addModal.radioStartTimeOne":
        "配置结束立即执行",
    selectInterfaceInputParamterOutputParamter:
        "请选择一个接口入参作为输出参数",
    "databaseManage.databaseTable.importLists.commonFieldsCreateDate":
        "创建时间",
    "BI.components.main.titleTitleSet": "标题设置",
    "workFlow.zh.continuous": "持续",
    "workFlow.printCurrentPage.hintAbnormal":
        "表单配置异常，请检查数据格式",
    fillInInterfaceCode: "请填写接口编码",
    "orgUserManagement.addModal.labelName": "姓名",
    "code.rightPanel.showDiscontinuity": "显示间断点",
    "BI.listIndex.Modal.editTitle": "编辑大屏",
    "databaseManage.databaseTable.selectDataPrompt.promptDatabase":
        "请选择数据库",
    "orgPostManagement.addMemberTitle": "添加成员",
    "taskScheduling.taskDesign.addFrequencyModal.August": "八月",
    "mobileDev.homeRightSide.linkField": "链接字段",
    "Notice.Tab.offShelfBtn": "下架",
    exampleReturningJson:
        '返回json举例：{"success":"true","msg":"获取成功","data":{"CompanyInfo":{"CompanyID":"70bb614e-0c4a-4979-af12-94b120c70178"}}}',
    "workFlow.Bpmn.textEnlarge": "放大",
    "orgUserManagement.tabAccount": "账户",
    "taskScheduling.taskDesign.addExpressionModal.expressionEleven":
        "每月最后一天10:15分运行",
    processTaskID: "流程任务ID",
    "mobileDev.loginDesignForm.Hint.codeSuccess": "代码生成成功！",
    hintFormAss: "表单赋值：在节点流转前将变量参数值赋值给表单",
    apiParameterAssignComponentData: "API出参赋值组件数据",
    "BI.echart.progress": "进度条",
    "BI.group.customBind.hintSelectData": "请先选择数据源",
    "PCDevGuide.roleManagement": "角色管理",
    "BI.components.main.labelShowLine": "显示网格线",
    fillInWidth: "请填写宽度",
    "mobileDev.tableSet.tabFieldName": "字段项名称",
    "orgDepartManagement.staffingModal.modalTitle": "添加人员",
    ownComponent: "所属组件",
    displayFieldOfDataSourceIsNotSelected: "数据源的显示字段未选择",
    "mobileDev.homeRightSide.funnel": "漏斗图",
    "orgUserManagement.addModal.placeholderPassword": "请填写密码",
    "forme.addModal.stepThree": "列表配置",
    "Schedule.labelSchedule": "日程内容",
    "BI.group.contentMenu.moveDown": "下移一层",
    "orgDepartManagement.departmentFormDialog.labelShortName":
        "部门简称",
    "editorModule.preferences": "首选项",
    "codeRule.addModal.tablePrefix": "前缀",
    "editorModule.anchor": "锚点...",
    "editorModule.align": "对齐",
    "user.setting.searchVal": "输入首页名称",
    "workFlow.filedConfig.tabCName": "列名",
    "workFlow.WFDesign.classifyManageBtn": "分类管理",
    "code.codeStepFour.dataOrigin": "数据源",
    pleaseClickToConfigure: "请点击进行配置",
    "workFlow.searchConfig.dataFieldQ": "数据字段查询",
    addComponents: "添加组件",
    "mobileDev.functionDesignStepEight.hintFunType":
        "请填写功能分类",
    bind: "请绑定",
    "language.languageCategory.lt": "立陶宛语",
    "language.languageCategory.lv": "拉脱维亚语",
    "code.codeStepFour.hintShowField": "请选择显示字段",
    "code.rightPanel.bigScreen": "大",
    "taskScheduling.taskDesign.addFrequencyModal.January": "一月",
    "editorModule.gray": "灰色",
    "BI.Build.Parameter": "参数",
    "code.codeStepTwoListStructure.tableName": "表名",
    "workFlow.zh.businessKey": "业务Key",
    "BI.listIndex.Modal.functionDescr": "功能描述",
    "editorModule.horizontalLine": "水平分割线",
    "selectUser.companyDepart": "公司部门",
    "databaseManage.databaseTable.addSheet.hintNameNoChinese":
        "列名不能为中文！",
    "forme.addModal.formTopHight": "表单框距顶部高度",
    postClickEvents: "点击后事件",
    "fileManagement.Hint.moveFailed": "移动文件失败！",
    "language.languageCategory.kz": "哈萨克斯坦语",
    "menuManagement.addModal.labelUrlAddress": "URL地址",
    "mobileDev.homeRightSide.hintFindOut": "该SQL语句只查出了",
    "code.codeStepFour.hintDataOrigin": "请选择数据源",
    "mobileDev.formRightSide.labelDateFormat": "日期格式",
    "navbar.dashboard": "首页",
    buyer: "采购人员",
    "orgPostManagement.tabNum": "#",
    "companyManager.companyFormDialog.labelComAbbr": "公司简称",
    "language.languageCategory.ku": "库尔德语",
    "mobileDev.functionDesignStepSeven.fixedEntity": "实体",
    "code.codeStepFour.hintConfirmConfig":
        "请点击确定按钮确认结构树的配置项是否准确",
    "importAndExport.importForm.titleDataFField": "数据表字段",
    "language.languageCategory.km": "高棉语",
    operateClass: "操作类别",
    "language.languageCategory.ko": "韩语",
    "mobileDev.mobileSchema.titleSelectIcon": "选择图标",
    "workFlow.Process.myTask": "我的任务",
    "buttonModule.modalCloseBtn": "关闭",
    average: "平均数",
    "code.codeIndex.title": "在线代码生成器 并自动创建代码",
    "wel.welIndex.monthComRate": "月出水达标率",
    languageTypeMaintenanceFailed: "语言类型维护修改失败！",
    "workFlow.schemeFormIndex.tabEdit": "编辑",
    "language.languageCategory.kg": "吉尔吉斯语",
    "forgetPass.errorVerCode": "请输入6位数的验证码",
    "login.code": "请输入验证码",
    "mobileDev.homeRightSide.gonggeMenu": "宫格菜单",
    "workFlow.Start.hint":
        "备注：发起人设置请不要选择子流程之后的节点作为发起人！（无法获取到发起人，子流程将无法进行）",
    "importAndExport.importForm.placeholderTName": "请填写模板名称",
    "importAndExport.importForm.tabField": "字段",
    "BI.Build.contentDeploy": "配置",
    "editorModule.shortcut": "快捷键",
    "mobileDev.listRightSide.optionYes": "是",
    "reportModule.reportRelease.dialogTitle.selectIconTitle":
        "选择图标",
    "PCDevGuide.processDesign": "流程设计",
    "orgUserManagement.addModal.labelMobile": "手机",
    procPara: "流程参数",
    "taskScheduling.taskDesign.addModal.labelInterfaceType":
        "接口类型",
    "fileManagement.Fixed.allFile": "所有文件",
    "language.languageCategory.ja": "日语",
    "workFlow.User.approvalComponent": "审批意见框组件",
    "reportModule.reportRelease.placeholderSystemId":
        "请选择所属系统",
    "workFlow.zh.signalBoundaryUnblock": "信号边界事件（非中断）",
    "orgDepartManagement.addModal.tabRoleInfor": "角色信息",
    "workFlow.zh.eventType": "事件类型",
    "workFlow.WFDesign.titleImportFlowDes": "导入流程设计",
    "workFlow.WFChange.read": "已阅",
    right: "靠右",
    "workFlow.menuForm.titleDeploy": "模板配置",
    "sub-processNodesAndExternalProcessNodesYouCannotUsePreviousNodeSpecifyApprovers":
        "存在子流程节点和外部流程节点，不能使用上一节点指定审批人",
    "BI.echart.color": "颜色块",
    generateMobileCode: "是否生成移动端代码",
    "subSystem.printBtn": "打印",
    "custmerForm.viewHistory.tableFormal": "正式",
    "workFlow.approvalFLow.labelApprovalInfor": "审批信息",
    "language.languageCategory.it": "意大利语",
    "fileManagement.Fixed.recycleBin": "回收站",
    newDataSource: "新增数据源",
    hintSureDisableInterface: "确认停用此接口吗？",
    "workFlow.categoryList.tabSimpleSpe": "简拼",
    "BI.echart.media": "媒体",
    totalPur: "采购总额",
    selectSet: "选择设置",
    "Notice.hintSuccess": "成功！",
    "editorModule.darkRed": "深红色",
    "wel.welIndex.Effluent": "出水",
    "workFlow.WFMenu.dialogTitle.viewTemplate": "查看所属模板",
    "mobileDev.appDevIndex.homeDesignTitle": "移动应用-首页设计",
    "taskScheduling.taskDesign.addFrequencyModal.June": "六月",
    "mobileDev.formRightSide.optionUri": "必须为网址格式！",
    "editorModule.wordsZero": "字数：{0}",
    outputParameterDestination: "输出参数目标位置",
    "editorModule.or": "或",
    "workFlow.zh.createSubProcess": "创建扩展子过程",
    "mobileDev.homeRightSide.labelDatabase": "数据库",
    publicParameters: "公共参数",
    "editorModule.ok": "确定",
    "code.codeStepTwoListStructure.length": "长度（默认50字节）",
    whseOverview: "入库总览",
    "workFlow.Circulate.roleBtn": "角色",
    "editorModule.borderStyle": "边框样式",
    "orgPostManagement.addModal.labelDepartID": "所属部门",
    apiConfigNoteOne:
        "备注：在“加载表单”过程之前添加的出参赋值组件数据仅适用于“新增”功能，因为“编辑”功能会获取数据库数据后覆盖表单组件数据，赋值将失效。",
    "Notice.labelContent": "内容",
    "code.codeStepThree.Eg200": "例如：200",
    "menuManagement.tableSystem": "所属系统",
    "reportModule.reportManage.labelRType": "报表类型",
    "codeSchema.titleTwo":
        "在线代码生成器 并自动创建代码（表单代码生成器）",
    "menuManagement.tableTarget": "目标",
    "wel.welIndex.tonDrugCons": "吨水药耗",
    "language.languageCategory.pt": "葡萄牙语",
    "dataItem.addModal.labelName": "项目名",
    "code.rightPanel.hintCounterMin":
        "计数器最小值只能小于等于最大值",
    "code.rightPanel.placeholderRegular": "请输入正则",
    "language.languageCategory.pl": "波兰语",
    "workFlow.processTasks.relaunchProcess": "重新发起流程",
    fanyi: "代码生成器",
    levDataConfig: "级数据源的配置",
    "editorModule.no": "否",
    "login.title": "登录",
    "workFlow.privateStampInfo.labelStop": "停用",
    "dataItem.addModal.placeholderName": "请填写项目名",
    "workFlow.privateStampInfo.setDefaultBtn": "设置默认签章",
    inputVaildEmail: "请输入正确的邮箱",
    "wel.welIndex.totalCost": "总成本",
    erpComp: "ERP组件",
    "workFlow.WFMenu.dialogTitle.addMenu": "新增专项菜单",
    "workFlow.zh.parameter": "参数",
    paraNameNoEmpty: "参数名称不能为空",
    "orgUserManagement.addModal.Hint.passworldLength":
        "长度6-16个字符",
    "databaseManage.dataLink.writeAnotherName": "请填写别名",
    "editorModule.rupeeSign": "卢比符号",
    "mobileDev.functionDesignStepEight.placeholderFunctioName":
        "请填写功能名称",
    "workFlow.WFDesign.finish": "结束",
    encodingRuleNotSelected: "编码规则未选择",
    "workFlow.User.tabCirculator": "传阅人",
    "orgPostManagement.viewMemberTitle": "查看角色成员",
    "Notice.placeholderNotTyle": "请填写公告类别",
    "route.hotfunc": "热门功能",
    "mobileDev.loginRightSide.labelEnableBorder": "启用边框",
    title: "LEARUNSOFT通用管理系统快速开发框架",
    "PCDevGuide.dataPermission": "数据权限",
    "databaseManage.databaseTable.addSheet.draftSavedSuccessfully":
        "草稿保存成功！",
    addedMobileMenuSuccessfully: "新增移动端菜单成功！",
    "mobileDev.homeRightSide.two": "二",
    failedToAddMobileMenu: "新增移动端菜单失败！",
    "code.codeForm.Hint.reloginPrompt":
        "代码生成成功，请退出系统重新登录！",
    "workFlow.privateStampInfo.tabDefaStamp": "默认签章",
    "language.languageCategory.nl": "荷兰语",
    company: "公司",
    "orgUserManagement.addModal.labelJobNum": "工号",
    "editorModule.findWholeWordsOnly": "全字匹配",
    "code.rightPanel.listType": "列表类型",
    "user.info.hintNewPassword": "请输入新密码",
    "BI.echart.tabs": "选项卡",
    "forme.tableHeaderFunctionName": "功能名称",
    "deletePrompt.hinrEnterSpace": "请输入",
    "taskScheduling.taskDesign.addModal.labelStartTime": "开始时间",
    "editorModule.cellSpacing": "单元格外间距",
    "BI.components.common.labelList": "配置列表",
    "workFlow.User.allowProhibit": "禁止",
    "BI.components.bar.labelMaxWidth": "最大宽度",
    "workFlow.Process.radioShow": "显示",
    "forme.addModal.tableHeaderAlignment": "对齐",
    "code.codeStepTwoListStructure.dataFormat":
        "数据格式（默认varchar）",
    "dataItem.tableName": "项目名",
    "importAndExport.importForm.tabDescribe": "描述",
    "language.languageCategory.mn": "蒙古语",
    "mobileDev.loginDesignForm.saveBtn": "保存模板",
    "BI.group.customBind.verifyBtn": "验证语句",
    "importAndExport.importConfiguration.hintDataOption":
        "请选择数据选项",
    "code.rightPanel.seeDocument": "查看组件文档",
    "mobileDev.homeRightSide.dialogTitle.selectIcon": "选择图标",
    "orgImport.importBtn": "快速导入",
    "mobileDev.loginRightSide.placeholderDistance": "请输入距离",
    "code.leftScrollbar.component.selectArea": "行政区域",
    "code.rightPanel.defaults": "默认",
    "workFlow.Start.nodeName": "节点名称",
    "workFlow.addStamp.placeholderSName": "请填写印章名称",
    "workFlow.End.shortMessage": "短信",
    "mobileDev.loginCenterContainer.verCodeBtn": "发送验证码",
    "mobileDev.homeDesignStepTwo.Explain":
        "已配置的元素可拖出配置区域进行删除",
    "code.codeStepOne.hintSelectTable": "请先选择关联表",
    enterCorrectPhoneNumber: "请输入正确的电话号码",
    "forme.addModal.placeholderFunctionNumber": "请填写功能编号",
    "companyManager.companyFormDialog.placeholderOuterPhone":
        "请填写电话号",
    "workFlow.zh.historyTime": "历史的生存时间",
    "workFlow.zh.historyConfig": "历史配置",
    "mobileDev.listRightSide.whetherAddBg": "是否添加背景标签",
    formAssignment: "表单赋值",
    "BI.components.pictorialbar.labelAFontColor": "轴字体颜色",
    supplier: "供货单位",
    "language.languageCategory.ua": "乌克兰语",
    selectParameterCotegoryBeforeProceeding:
        "请先选择参数类别后再进行操作",
    userDefinedNode: "用户自定义节点",
    "custmerForm.classifiedManagement.Hint.formCategoryName":
        "请填写表单分类名称",
    "taskScheduling.taskDesign.tableStatus": "状态",
    "language.languageCategory.tk": "土库曼语",
    "workFlow.Process.placeholderFNum": "请填写功能编号",
    "taskScheduling.taskDesign.addFrequencyModal.Hour": "时",
    "codeSchema.tableName": "模板名称",
    "interfaceManage.addModal.hintFieldPostil": "请输入字段注释",
    "workFlow.callActivity.tabInputParameters": "输入参数",
    parentIcon: "父级图标",
    "mobileDev.functionDesignStepSix.labelPhysLayer":
        "实体层输出目录",
    templateInfor: "模板信息",
    "BI.echart.imgBorder": "图片框",
    "topLock.hintPWD": "锁屏密码不能为空",
    "workFlow.processTasks.hintTips": "温馨提示",
    "code.codeStepFour.labelBtnName": "按钮名称",
    "language.languageCategory.th": "泰语",
    "workFlow.categoryList.placeholderName": "请输入流程分类名称",
    "language.languageCategory.ta": "泰米尔语",
    "language.languageCategory.sr": "塞尔维亚语",
    pleaseChooseEnterVersionNumber: "请选择输入版本编号",
    "BI.group.contentMenu.Compose": "组合分组",
    "BI.echart.gauge": "仪表盘",
    "workFlow.Step1.titleSelectIcon": "选择功能图标",
    "orgRoleManagement.tabRoleName": "角色名称",
    "workFlow.zh.timerBoundary": "定时边界事件",
    "forme.addModal.placeholderSuperiorFunction": "请选择上级功能",
    "mobileDev.functionDesignStepSix.headTitle": "功能信息配置",
    "language.languageCategory.sl": "斯洛文尼亚语",
    "language.languageCategory.sk": "斯洛伐克语",
    "workFlow.historyList.hintRenewSuccess": "更新到此版本成功",
    "editorModule.spesmiloSign": "spesmilo符号",
    "code.codeStepSix.entityOutputList": "实体层输出目录",
    "databaseManage.dataLink.databaseIP": "数据库IP",
    "workFlow.filedConfig.noPagination": "不分页",
    "code.codeStepThree.noSet": "不可设置",
    "workFlow.zh.excGatEvent": "互斥网关",
    "custmerForm.classifiedManagement.addModal.titleEditForm":
        "编辑表单分类",
    "workFlow.WFDesign.titleImportFlow": "导入流程",
    "BI.echart.textBorder": "文本框",
    "PCDevGuide.titlePermissionSettings": "权限设置",
    "mobileDev.homeRightSide.three": "三",
    "language.languageCategory.ro": "罗马尼亚语",
    selectOperationType: "请选择操作类别",
    "editorModule.next": "下一个",
    newLanguageTypeMaintenanceFailed: "语言类型维护新增失败！",
    "deletePrompt.Complete": "完成",
    "workFlow.zh.resource": "资源",
    "mobileDev.loginRightSide.placeholderBgImg": "请上传图片",
    auditStatus: "审核状态",
    "mobileDev.formRightSide.dateRangeBox": "日期区间框",
    newPostFailed: "新增岗位失败！",
    "code.rightPanel.dataSourceConfig": "联想数据源配置",
    "workFlow.WFDesign.hintDownload": "下载中",
    "menuManagement.addModal.labelSuperior": "上级",
    "editorModule.removeLink": "删除链接",
    documentCode: "单据编码",
    "mobileDev.functionDesignStepSix.placeholderSelect": "请选择",
    "editorModule.italic": "斜体",
    whetherCache: "是否缓存",
    "workFlow.selectLaunch.labelSelect": "请选择",
    "workFlow.selectAuthority.hintNoAccess": "没有模板权限人！",
    selectValue: "请选择值",
    "editorModule.tengeSign": "坚戈符号",
    FormPage: "表单页面",
    "fileManagement.Fixed.Image": "图片",
    "mobileDev.functionDesignStepThree.hintDragComponent":
        "从左侧拖入组件进行表单设计",
    defaultByFirstDate: "默认取显示字段的第一个数据",
    "workFlow.WFChange.low": "低级",
    "deletePrompt.updateFailure": "更新失败!",
    specialPostTwoLevels: "上二级",
    "fileManagement.placeholderFileName": "请填写文件名",
    longText: "长文本",
    "mobileDev.loginRightSide.selectYes": "是",
    "BI.components.wordCloud.labelSpace": "间隙",
    "workFlow.zh.createRemoveTool": "激活创建/删除空间工具",
    "editorModule.address": "地址",
    "editorModule.yuanCharacterVariant": "元字样（大写）",
    "taskScheduling.taskDesign.addExpressionModal.expressionEight":
        "3月每周三的14:10分到14:44，每分钟运行一次",
    "workFlow.Approver.roleDepartBtn": "审批角色（部门）",
    "BI.listIndex.hintDeletePerm": "是否确认永久删除?",
    "mobileDev.mobileSchema.tabNum": "#",
    equipment: "设备",
    "buttonModule.addBtn": "新增",
    "databaseManage.dataLink.databaseAccount": "数据库账号",
    formAssEmpty: "表单赋值为空",
    invalidInputParameterCustomParameterAssignment:
        "自定义出参赋值有使用无效的入参参数，请先修改再下一步",
    "workFlow.Step3.completeBtn": "完成",
    "mobileDev.formRightSide.labelVisualState": "可视状态",
    "BI.Build.alignRight": "右对齐",
    "editorModule.finish": "完成",
    "BI.group.contentMenu.Copy": "复制图层",
    "workFlow.User.tableName": "名称",
    "codeRule.addModal.Hint.initialValueLength":
        "初始值的长度需跟格式保持一致，例如：格式为000，初始值就为001，不能超过长度",
    "orgUserManagement.addModal.labelAccount": "账号",
    "workFlow.userButtonSetting.editBtn": "点击进行编辑",
    tenantCode: "租户码",
    "workFlow.zh.elementDocuments": "元素文档",
    "editorModule.id": "标识符",
    "workFlow.WFMonitor.hintTips": "温馨提示",
    "BI.components.flop.labelPrecision": "精度",
    dataFirst: "数据优先",
    "code.rightPanel.backIcon": "后图标",
    "workFlow.zh.signalStart": "信号开始事件",
    "taskScheduling.taskDesign.addModal.radioEndTimeOne": "无期限",
    "importAndExport.addQuickExport": "添加快速导出",
    sponsorsDepartmentId: "发起人所属部门ID",
    "workFlow.zh.variableEvent": "Variable name",
    "News.placeholderTagLabel": "请填写Tag标签",
    "workFlow.WFDelegate.tabCreateDate": "创建时间",
    "custmerForm.classifiedManagement.tableSimpleSpelling": "简拼",
    "workFlow.WFMenu.hintSuccess": "成功！",
    "code.codeStepOne.placeholderFormName": "请输入要查询的表名",
    "login.faceLogin": "刷脸登录",
    "mobileDev.formRightSide.optionDataDic": "数据字典",
    "mobileDev.formRightSide.placeholderTipContent":
        "请输入提示内容",
    "BI.components.gauge.labelShow": "显示刻度值",
    "language.languageCategory.vi": "越南语",
    "workFlow.createFLow.hintFailed": "提交失败",
    "workFlow.Step1.hintMName": "请填写专项菜单名称",
    deleteRole: "删除角色",
    "navbar.setting": "个人设置",
    "mobileDev.functionDesignStepSix.addAreaBtn": "新增区域",
    apiParmName: "API参数名称",
    "code.rightPanel.placeholderFileSize": "请输入文件大小",
    "fileManagement.Hint.completeDeleteSuccess": "彻底删除成功！",
    "mobileDev.homeDesignStepTwo.rightTitle": "属性设置",
    "wel.welIndex.titleTrendAnaly": "趋势分析",
    "mobileDev.homeDesignStepTwo.functionBtn": "功能",
    "workFlow.callActivity.tabOutputParameters": "输出参数",
    "mobileDev.homeRightSide.maxLabelNum": "最大标签数",
    "workFlow.zh.config": "配置",
    "databaseManage.dataSource.addModalWriteRemark": "请填写备注",
    "code.rightPanel.hintMustPlus": "上传文件大小必须输入正数",
    "editorModule.saveActivated": "保存(如果保存插件已激活)",
    "editorModule.needAddHttp":
        "你所填写的URL地址属于外部链接，需要加上http://:前缀吗？",
    "code.codeStepThree.tabTField": "绑定时间字段",
    "workFlow.processTasks.hintMoveTrash":
        "确定要将此项移入回收站吗？",
    "codeRule.tableNumber": "#",
    viewInterface: "查看接口",
    "dataItem.dialogInstall.hintSortName": "请输入分类名称",
    "fileManagement.dialogTitle.renameFolderTitle": "重命名文件夹",
    valueType: "值类型",
    selectApiParameterValueType: "请选择API参数值类型",
    interfaceSource: "接口来源",
    "workFlow.selectSql.queryResultsBtn": "查询测试SQL语句返回结果",
    "editorModule.right": "右对齐",
    "editorModule.shiftEnter": "按Shitf+Enter键打开对话框",
    newTableName: "新表表名",
    TableStructurete: "数据表设置",
    externalProcessNotSelectCallingElementExternalProcessNotSelectInitiator:
        "外部流程没有选择调用元素,以及外部流程没有选择发起人",
    "editorModule.insertRowBefore": "在上方插入",
    "code.rightPanel.placeholderErrorPrompt": "请输入错误提示",
    appVersionName: "APP版本名称",
    "deletePrompt.setSuccessfully": "设置成功!",
    "orgUserManagement.setAutModal.modalTitle": "功能授权",
    syncSuccess: "同步成功",
    "BI.components.flop.labelSuffixCon": "后缀内容",
    highest: "最高级",
    preloadDataSourceNotSelected: "未选择预加载数据源",
    "BI.components.line.labelPointSize": "点的大小",
    "workFlow.Process.radioHide": "隐藏",
    "orgUserManagement.addModal.labelEmail": "邮箱",
    verifyStatementSuccessBindFieldCannotCorrectlyObtainedInputParameter:
        "请先验证语句成功之后再选择绑定字段，如果使用接口入参无法正确获取SQL返回值，则可以手动填写绑定字段名。",
    "BI.group.top.hintSuccessSaved":
        "保存成功大屏配置, 是否打开预览?",
    "workFlow.userButtonSetting.placeholderSelect": "请选择",
    "BI.listIndex.Modal.slectSystem": "请选择所属系统",
    "mobileDev.formRightSide.labelAreaHeight": "区域高度",
    "importAndExport.importForm.valueUnrelated": "无关联",
    "orgUserManagement.addModal.Hint.nameLength":
        "长度不能超过16字符",
    "code.rightPanel.formModel": "表单模型",
    "forme.addModal.placeholderFunctioName": "请填写功能名称",
    "BI.group.contentMenu.Disband": "解散分组",
    "workFlow.printCurrentPage.labelYse": "是",
    copyFailure: "复制失败",
    "workFlow.createFLow.frontTask": "前置任务",
    "code.codeStepFour.addhBtn": "新增",
    "workFlow.delegateForm.hintEndDate": "请填写结束时间",
    varConfig: "变量配置",
    "code.codeForm.saveTemplateModal.placeholderDescription":
        "请填写模板描述",
    selectTriggerEvent: "请选择触发事件",
    "importAndExport.importForm.titleDatabaseForm": "数据库表",
    interfacePermissions: "接口权限",
    "orgDepartManagement.fixedTitle": "公司信息",
    templateNote: "模板备注",
    "crud.addBtn": "新增",
    amountSold: "已销金额",
    "code.rightPanel.bottom": "底部",
    "menuManagement.editModal.modalTitle": "编辑功能",
    "user.info.Department": "部门：",
    "code.leftScrollbar.component.password": "密码",
    "mobileDev.loginRightSide.placeholderHintInfor":
        "请输入提示信息",
    "mobileDev.homeRightSide.Img": "图片",
    verifyStatementSuccessAfterSelectBoundField:
        "请先验证语句成功之后再选择绑定字段",
    "workFlow.schemeFormDialog.formSelect": "表单选择",
    "code.rightPanel.regularCheck": "正则校验",
    "code.rightPanel.btn": "按钮",
    "workFlow.WFMonitor.tabTitle": "标题",
    "workFlow.zh.transport": "转运",
    "code.codeStepFour.tableHeaderWidth": "宽度(单位：px)",
    "orgRoleManagement.setAuthorizeModal.sysFunction": "系统功能",
    "workFlow.Approver.personnelBtn": "人员",
    parameterAss: "参数赋值",
    apiConfig: "API配置",
    "workFlow.Process.placeholderSuperior": "请选择上级",
    originatorToken: "发起人员Token",
    "workFlow.User.optionSynchronize": "同步执行",
    "deletePrompt.hardLoading": "拼命加载中",
    "workFlow.formInitiationProcessDialog.selectForm": "请选择表单",
    xAxis: "X轴",
    "workFlow.processTasks.fixedTitle": "流程任务状态",
    "workFlow.userButtonSetting.optionAllow":
        "允许驳回至任一流转过的节点",
    "custmerForm.viewHistory.modalTitle": "历史记录",
    "code.codeStepFour.hintExportName": "请填写导出名称",
    seven: "七",
    "orgUserManagement.addModal.labelWeChat": "微信",
    "workFlow.zh.conditionalBoundaryUnblock":
        "条件边界事件（非中断）",
    "mobileDev.homeRightSide.labelXField": "x轴对应字段",
    "editorModule.copyRow": "复制行",
    "workFlow.zh.linkCatch": "链接中间捕获事件",
    variableAssign: "变量赋值",
    "mobileDev.formRightSide.placeholderDataSource":
        "请选择数据来源",
    "workFlow.menuForm.titleFieldAccess": "字段权限",
    "orgRoleManagement.databaseAuth.radioDepSubdep":
        "仅查看本部门及所有下属部门",
    "BI.components.imgBorder.labelImgTra": "图片透明度",
    "code.codeStepSix.frontEndOutputList": "前端文件输出目录",
    "workFlow.selectAuthority.personnelBtn": "人员",
    "interfaceAPI.idName": "力软信息",
    "navbar.theme": "主题",
    "code.leftScrollbar.hintFieldCopy": "代码复制失败",
    "workFlow.createFLow.hintAbnormal": "捕获提交异常",
    "mobileDev.homeRightSide.placeholderRefreshT": "请输入刷新时间",
    "workFlow.zh.hintEgOne":
        "跟踪日期必须符合EL表达式，如： ${someDate} ,或者一个ISO标准日期，如：2015-06-26T09:54:00",
    cannotExceed1600Characters: "不能超过1600个字符",
    "taskScheduling.taskDesign.addFrequencyModal.ExecutionTime":
        "执行时间",
    "mobileDev.homeRightSide.addrField": "地址字段",
    "importAndExport.importForm.hintSelectShowField":
        "请选择显示字段",
    "editorModule.preformatted": "预先格式化的",
    "Log.emptyModal.optionTwo": "保留近一个月",
    "workFlow.approvalFLow.labelStampPassword": "签章密码",
    inputVerCode: "请输入短信验证码",
    "databaseManage.dataLink.writeDescribe": "请填写描述",
    enterRoleNameSearch: "请输入角色名称进行搜索",
    "code.codeForm.saveTemplateModal.placeholderName":
        "请填写模板名称",
    "mobileDev.functionDesignStepTwo.tabNum": "#",
    "workFlow.messagePusherPeople.companyRole": "公司角色",
    "code.codeStepFour.createApprovalBtn": "发起审批",
    "mobileDev.functionDesignStepSix.labelFounder": "创建人",
    "forme.tableHeaderEditTime": "编辑时间",
    "workFlow.zh.connectAssociation": "使用关联连接",
    "forgetPass.twoResetPWD": "请二次输入重置密码",
    "messageIndex.titleApproval": "流程审批",
    "code.codeStepFour.placeholderSelect": "请选择",
    "code.leftScrollbar.component.defaultCompany": "系统默认(公司)",
    "orgDepartManagement.departmentFormDialog.placeholderDepName":
        "请填写部门名称",
    "workFlow.WFDesign.labelEnable": "启用",
    "mobileDev.functionDesignStepTwo.tabLinkForm": "关联表",
    addedSubform: "添加的子表单",
    "databaseManage.dataLink.writeDatabaseAccount":
        "请填写数据库账号",
    "BI.components.datetime.labelBg": "字体背景",
    "reportList.createTime": "创建时间",
    "custmerForm.classifiedManagement.modalTitle": "表单分类管理",
    "orgRoleManagement.setAuthorizeBtn": "功能授权",
    multiSelectLayerSelectRecord: "多选弹层记录",
    webFileList: "web端前端文件输出目录",
    "workFlow.selectLaunch.selectedTemplate": "已选模板",
    "mobileDev.mobileSchema.tabFunName": "功能名称",
    "workFlow.Start.nodeDescr": "节点描述",
    "mobileDev.functionDesignStepSix.nextTitle": "输出目录",
    "code.codeStepSix.labelOutArea": "输出区域",
    noConfigNameTypeValue: "没有配置正确参数名称、参数类型、参数值",
    approvedNode: "已审批节点",
    "workFlow.selectAuthority.hintAddFailed":
        "添加模板权限人失败！",
    "crud.showBtn": "显隐",
    "login.userLogin": "账号密码",
    "code.leftScrollbar.hintNotSupport":
        "该组件不支持于子表单中使用",
    "language.translation.labelTagCode": "翻译标记编码",
    "taskScheduling.taskDesign.addModal.taskRestartOne":
        "重启频率:每隔",
    paymentDate: "付款日期",
    "orgDepartManagement.Hint.modifyDepart": "修改部门",
    "workFlow.zh.fieldInject": "字段注入",
    "topLock.placeholderPWD": "请输入锁屏密码",
    "companyManager.companyFormDialog.placeholderRemark":
        "请填写备注",
    "user.setting.hintChangeSuccess": "更改成功",
    "BI.group.customBind.notYet": "暂无",
    "searchModule.searchState": "请选择执行结果",
    syncFailure: "同步失败",
    "code.rightPanel.formGrid": "表单栅格",
    "selectPost.labelRole": "角色",
    "BI.echart.pie": "饼图",
    "workFlow.schemeFormIndex.tabMustFill": "必填",
    fillMaxLines: "请填写最大行数",
    "workFlow.roams.userNode": "用户节点",
    "editorModule.poster": "封面",
    "BI.group.placeholderSelect": "请选择",
    "language.languageCategory.de": "德语",
    "orgUserManagement.tabMobile": "手机",
    positiveSequence: "升序",
    "workFlow.zh.inputParameter": "输入参数",
    "workFlow.zh.value": "值",
    "BI.Build.positionY": "Y位置",
    "mobileDev.mobileSchema.hintFixedMuse": "固定菜单不可拖拽排序",
    "BI.Build.positionX": "X位置",
    "tip.input": "请输入",
    "language.languageCategory.da": "丹麦语",
    changelog: "更新日志",
    "mobileDev.homeRightSide.verifState": "验证语句",
    purelyFictitious: "纯属虚构",
    "code.rightPanel.fullScreen": "全屏",
    "workFlow.Step1.placeholderOrder": "请填写排序",
    "code.codeStepFive.tabBindSheet": "绑定表",
    "workFlow.Bpmn.textLoading": "加载xml",
    "Log.tableAccount": "操作用户",
    "editorModule.mergeCells": "合并单元格",
    "language.languageCategory.ca": "加泰罗尼亚语",
    "orgDepartManagement.addModal.tabBasicInfor": "基本信息",
    "editorModule.darkGray": "深灰色",
    "mobileDev.formRightSide.optionDate": "必须为日期格式！",
    "orgDepartManagement.departmentFormDialog.labelRemark": "备注",
    "code.rightPanel.compProperty": "组件属性",
    "BI.components.bar.labelMinHigh": "最小高度",
    "workFlow.createFLow.hintLaunchFlow": "发起流程",
    "mobileDev.tableSet.tabCount": "统计",
    "forme.editModal.approvalComplete": "审批完成",
    "PCDevGuide.customFormPermissions": "自定义表单权限",
    "workFlow.userButtonSetting.optionSelect": "==请选择==",
    "deletePrompt.promptTitle": "提示",
    companyNumber: "公司编号",
    "editorModule.matchCase": "区分大小写",
    "mobileDev.functionDesignStepSix.titleAddDic": "新增字典项",
    "BI.listIndex.Modal.iconSelector": "图标选择器",
    parameterValueTypeParameterValueCannotNull:
        "参数值类型和参数值不能为空",
    singleInstance: "单实例",
    createNewTable: "创建新表（重新生成表名）",
    "mobileDev.searchRightSide.placeholderCompany": "当前公司",
    "language.languageCategory.bg": "保加利亚语",
    "workFlow.searchConfig.tabFieldName": "字段项名称",
    include: "包含",
    "custmerForm.classifiedManagement.addModal.Code":
        "表单分类编码",
    "News.labelEdit": "编辑",
    "mobileDev.homeRightSide.vidTitField": "视频标题字段",
    "code.rightPanel.placeholderDelimiter": "请输入分隔符",
    urgencyDegree: "紧急程度",
    multipleInstances: "多实例",
    "language.languageCategory.ar": "阿拉伯语",
    "workFlow.zh.handTool": "激活抓手工具",
    "orgDepartManagement.viewRoleTitle": "查看角色",
    "mobileDev.homeRightSide.dialogTitle.setTab": "表格配置",
    "workFlow.publicStampInfo.hintAssignFailed":
        "指定维护人员失败!",
    "taskScheduling.taskDesign.addFrequencyModal.July": "七月",
    "topTheme.nameDarkTheme": "深色主题",
    "user.info.email": "邮箱",
    "workFlow.zh.externalTask": "扩展任务配置",
    selectedData: "已选记录",
    interfaceCodeOlnyCustom: "接口编码(仅自定义接口)",
    selectData: "选择数据",
    "mobileDev.formRightSide.textArea": "文本区",
    "language.languageCategory.id": "印尼语",
    "code.rightPanel.layoutMode": "布局模式",
    "PCDevGuide.databaseLinks": "数据库连接",
    "language.languageCategory.hy": "亚美尼亚语",
    "BI.listIndex.Modal.fillWidth": "请输入宽度",
    clickCustomizeSqlEditEg:
        "添加格式例如：update table_name set col_name = '``模板信息.模板编号``' where col2_name = '``模板信息.模板名称``'",
    "Notice.hintFailure": "失败！",
    optionRecord: "- 选择记录",
    "PCDevGuide.kanbanRelease": "看板发布",
    associatedFields: "的关联字段",
    "editorModule.colorSwatch": "颜色样本",
    "language.languageCategory.hr": "克罗地亚",
    "workFlow.Process.radioAllMembers": "所有成员",
    "BI.components.text.labelLineHigh": "字体行高",
    "language.languageCategory.hu": "匈牙利语",
    parameterSet: "参数设置",
    "orgDepartManagement.departmentFormDialog.labelDepNature":
        "部门性质",
    outputObjParmName: "输出对象参数名称",
    upperTwoLevels: "上两级",
    "code.rightPanel.rate": "税率",
    "Schedule.placeholderSchedule": "请输入日程内容",
    "databaseManage.databaseTable.addSheet.copyTableBtn": "复制表",
    "BI.components.common.editBtn": "编辑",
    "workFlow.zh.remove": "移除",
    addFunction: "添加功能",
    "editorModule.insertColumnAfter": "在右侧插入",
    "companyManager.companyFormDialog.labelHigherCom": "上级公司",
    "language.languageCategory.he": "希伯来语",
    "route.crudForm": "表格表单",
    "menuManagement.addModal.labelFileAddress": "文件地址",
    "custmerForm.female": "女",
    "reportModule.reportManage.labelRCode": "报表编码",
    "menuManagement.tableOpen": "展开",
    "code.rightPanel.smallScreen": "小",
    "codeRule.addModal.addDialog.labelStep": "步长",
    receiptNo: "入库单号",
    "workFlow.createFLow.hintFormfailed": "表单提交失败",
    "workFlow.zh.infor": "消息",
    "editorModule.bgColor": "背景色",
    "BI.echart.dateTime": "实时时间",
    "workFlow.roams.otherNode": "其他节点",
    "workFlow.schemeFormIndex.tabFieldID": "字段ID",
    "code.rightPanel.codeRules": "编码规则",
    "mobileDev.formRightSide.title": "标题",
    "workFlow.zh.loop": "循环",
    "orgPostManagement.tabDepartID": "所属部门",
    "mobileDev.loginDesignForm.previousBtn": "上一步",
    "subSystemForm.placeholderCode": "请输入编码",
    sameTableStructure: "表结构相同",
    "News.tabNewsTitle": "新闻标题",
    paymentAmount: "付款金额",
    "mobileDev.formRightSide.optionPhone": "必须电话格式！",
    "taskScheduling.taskDesign.addModal.radioFrequencyTwo":
        "简单重复执行",
    "editorModule.wordCount": "字数",
    "language.languageCategory.fr": "法语",
    "taskScheduling.taskDesign.addModal.checkboxTaskRestart":
        "任务中断按以下频率重新启动",
    "workFlow.userButtonSetting.hintAddPValueSuccess":
        "添加参数值成功！",
    "language.languageCategory.fi": "芬兰语",
    "workFlow.createFLow.hintSaveFailed": "保存草稿失败",
    "fileManagement.Hint.returnFailed": "还原文件失败！",
    searchBoxHeight: "搜索框高度",
    "language.languageCategory.fa": "波斯语",
    "mobileDev.loginRightSide.labelShadow": "阴影",
    "mobileDev.formRightSide.optionNoVal": "不验证",
    "mobileDev.loginRightSide.labelVerifyHintInfor":
        "验证码提示信息",
    "interfaceManage.addModal.modalTitle": "新增接口",
    "mobileDev.functionDesignStepTwo.tabName": "表名",
    "BI.components.img.labelTransparency": "透明度",
    "editorModule.permanentPen": "记号笔",
    "language.languageCategory.es": "西班牙语",
    "language.languageCategory.eu": "巴斯克语",
    "workFlow.Start.initiatorSet": "发起人设置",
    "workFlow.zh.mark": "标识",
    "language.languageCategory.el": "希腊语",
    "language.languageCategory.en": "英语",
    "workFlow.addStamp.labelSType": "签章类型",
    "workFlow.User.optionNull": "无",
    "wechatAndDingTalk.userManagement.fixedTitle": "公司信息",
    "language.languageCategory.eo": "世界语",
    "workFlow.WFDesign.tabCreateDate": "创建时间",
    "language.languageCategory.ee": "爱沙尼亚语",
    "workFlow.zh.appendType": "添加 {type}",
    "code.codeStepFour.assocField": "关联字段",
    selectChildIcon: "请选择子级图标",
    addProParaParaValueApiConfig: "添加流程参数参数值API配置",
    customOutputCategory: "自定义出参类别",
    selectWebFunctionOrder: "请选择web端功能排序",
    "workFlow.WFMonitor.fixedTitle": "流程监控状态",
    "editorModule.flipVertically": "垂直翻转",
    "editorModule.deleteTable": "删除表格",
    "workFlow.Step1.nextStepBtn": "下一步",
    "workFlow.Bpmn.hintTemplateName": "请填写模板名称!",
    "orgRoleManagement.Hint.notSet": "超级管理员角色不能设置无效！",
    "workFlow.zh.messageEnd": "消息结束事件",
    "orgRoleManagement.addModal.labelRoleNum": "角色编号",
    "editorModule.imageOptions": "图片选项",
    "BI.group.customBind.linkViewMore": "查看完整数据表>>",
    failedToModifyDatabaseConnection: "修改数据库连接失败！",
    "workFlow.privateStampInfo.labelEnable": "启用",
    "menuManagement.addModal.placeholderFileAddress":
        "请填写文件地址",
    whetherShowNum: "是否显示序号",
    "mobileDev.functionDesignStepTwo.headTitle": "数据表选择",
    "wel.welIndex.projectName": "项目名称",
    "orgRoleManagement.indexAuth.tabSelected": "已选择",
    "taskScheduling.taskDesign.addExpressionModal.expressionThree":
        "在2020年的每天10：15运行",
    "editorModule.millSign": "密尔符号",
    "workFlow.printCurrentPage.prinBtn": "打印",
    "code.rightPanel.hintOnlySubtable":
        "子表单的子组件只能使用副表！",
    "databaseManage.dataSource.addModalRemark": "备注",
    "wel.welIndex.lastMonthMud": "上月总排泥：",
    "editorModule.replaceAll": "全部替换",
    docAmount: "单据金额",
    "Append EndEvent": "结束事件",
    "code.codeStepTwoListStructure.hintAdding": "正在添加，请稍后",
    "buttonModule.modalSureBtn": "确定",
    "PCDevGuide.reportDesign": "报表设计",
    APIConfigInterfaceConfigurationNotSelected:
        "API配置接口配置未选择",
    "searchModule.searchReset": "重置",
    "taskScheduling.taskDesign.addModal.simpleRepetitionOne":
        "每隔",
    "workFlow.zh.conditionalCatch": "条件中间捕获事件",
    "workFlow.WFDesign.hintFailure": "失败！",
    webPreview: "Web预览",
    "BI.components.map.labelMapSelect": "地图选择",
    "workFlow.zh.adHoc": "即席",
    "workFlow.Circulate.userBtn": "人员",
    "databaseManage.databaseField.addModalSelectDateType":
        "请选择数据类型",
    agree_: "同意",
    "login.phone": "请输入手机号",
    "workFlow.addStamp.emptyBtn": "清空",
    addedMenuSucceeded: "新增菜单成功！",
    "dataItem.tableSimpleSpelling": "简拼",
    "workFlow.categoryList.placeholderCode": "请输入流程分类编码",
    "mobileDev.tableSet.leftAlign": "左对齐",
    "code.leftScrollbar.component.multipleLayer": "多选弹层",
    "code.leftScrollbar.component.score": "评分",
    "workFlow.WFDelegate.tabStartDate": "开始时间",
    dataSourceFieldName: "数据源字段名",
    "BI.echart.custom": "自定义",
    enterInterfaceCategoryNameQuery: "输入接口分类名称进行查询",
    "workFlow.WFDesign.tabFlowState": "流程状态",
    "editorModule.apply": "应用",
    "(brackets": "(括号",
    "Create start-event": "开始",
    simpleTemplate: "简易模板",
    systemInterface: "系统接口",
    "code.leftScrollbar.component.tab1": "选项卡1",
    "code.leftScrollbar.component.tab2": "选项卡2",
    "code.leftScrollbar.component.tab3": "选项卡3",
    accessoryName: "附件名称",
    "orgPostManagement.addModal.labelParentId": "上级岗位",
    APIConfigSaveFieldIsNotSelected: "API配置保存字段未选择",
    curPersonToken: "当前人员Token",
    "workFlow.categoryList.efficient": "有效",
    "workFlow.Process.optionThree": "候选审批人在此流程中审批过",
    "BI.components.pie.labelAutoSort": "自动排序",
    variableEncoding: "变量编码(仅支持英文及下划线)",
    "language.translation.hintTagCode":
        "翻译标记编码只能由字母、数字、下划线组成，且数字不能开头",
    "user.setting.Title": "首页配置",
    "login.submit": "登录",
    noDatabaseSelect: "没有选择数据库",
    "BI.components.video.labelAddress": "地址",
    "mobileDev.formRightSide.optionHide": "隐藏",
    "code.rightPanel.btnPosition": "按钮位置",
    "workFlow.importFlow.hintRefresh": "上传超时，请刷新重试",
    "dataItem.hintNoChinese": "不能输入汉字!",
    "BI.listCategory.labelMValue": "模块值",
    "workFlow.WFChange.tabState": "状态",
    "user.authorizeInfor.titleSysFunction": "系统功能",
    "editorModule.ignoreAll": "全部忽略",
    trigEvent: "触发事件",
    "editorModule.restoreDraft": "恢复上次的草稿",
    "workFlow.Step1.placeholderSystemId": "请选择所属系统",
    "BI.group.top.Save": "保存",
    "mobileDev.formRightSide.labelDataOptions": "数据选项",
    "editorModule.blockquote": "引文区块",
    "code.leftScrollbar.hintMust": "必须要多表才能使用子表格组件!",
    "News.labelNewsSection": "新闻栏目",
    "editorModule.find": "查找",
    "workFlow.zh.serviceTask": "服务任务",
    "Notice.hintOffShelf": "下架",
    dataOptionsForTheDataSourceAreNotSelected:
        "数据源的数据选项未选择",
    "code.rightPanel.closeColor": "关闭颜色",
    apiConfigNoteTwo:
        "备注：在“加载表单”过程之后添加的出参赋值组件数据适用于“新增”、“编辑”两种功能，但“编辑”功能获取的原本表单组件数据会被API出参数据所覆盖。",
    "mobileDev.functionDesignStepTwo.setFTitle":
        "关联字段配置（选择数据表后可进行关联）",
    associativeTable: "的关联表",
    "taskScheduling.taskDesign.addFrequencyModal.Day": "每日",
    "workFlow.roams.approvalInfor": "审批信息：",
    orderNum: "订单数量",
    "editorModule.learnMore": "了解更多...",
    "areaManager.addModal.labelName": "名称",
    "BI.listIndex.Modal.labelNumber": "#",
    "navbar.bug": "没有错误日志",
    "workFlow.filedConfig.placeholderEg": "例如：400",
    "BI.components.wordCloud.labelWhirl": "旋转",
    "editorModule.darkOrange": "深橙色",
    owningNode: "所属节点",
    webMenuOption: "web端菜单选项",
    showName: "显示名称",
    "workFlow.Process.functionNum": "功能编号",
    "BI.listIndex.editBtn": "编辑",
    "code.leftScrollbar.component.switchs": "开关",
    "editorModule.printMore": "打印...",
    "editorModule.vAlign": "垂直对齐",
    "databaseManage.dataLink.selectLibraryType": "请选择库类型",
    "workFlow.Bpmn.hintTemplateNum": "请填写模板编号!",
    "mobileDev.appDevIndex.functionDesignTitle":
        "移动应用-功能设计",
    "BI.listIndex.Modal.selectGroup": "请选择分组",
    "databaseManage.databaseTable.addSheet.tableRemark": "说明",
    "editorModule.file": "文件",
    pieceLabelConfigItemIsNotFilledIn: "个标签配置项未填写",
    "mobileDev.listRightSide.Alignment": "对齐方式",
    "editorModule.action": "操作",
    "workFlow.Step1.labelMCode": "菜单编码",
    salesperson: "销售人员",
    "forgetPass.returnLogin": "返回登录",
    "workFlow.Bpmn.saveModelBtn": "保存模型",
    "BI.group.customBind.localDatabase": "本地数据库",
    "workFlow.filedConfig.selectCName": "请选择列名",
    "code.rightPanel.formProperty": "表单属性",
    selectWebTempClass: "请选择web端模板分类",
    "editorModule.newSheqelSign": "新谢克尔符号",
    "BI.components.table.labelStimes": "滚动行数",
    "editorModule.subscript": "下标",
    "route.desktop": "我的桌面",
    "workFlow.WFChange.approved": "已审批",
    assignmentSource: "赋值来源",
    "taskScheduling.taskDesign.addExpressionModal.expressionTwelve":
        "每月最后一个星期五10:15分运行",
    "workFlow.Circulate.labelName": "名称",
    "News.placeholderEdit": "请填写编辑",
    formInitialize: "表单初始化",
    tabStrConfigCompRes: "表结构配置对比结果",
    "databaseManage.databaseTable.addSheet.placeholderWrite":
        "请填写",
    "tableOperationModule.deleteBtn": "删除",
    "orgUserManagement.addModal.placeholderAccount": "请填写账号",
    "mobileDev.loginDesignStepThree.headTitle": "代码预览",
    "mobileDev.loginRightSide.labelPasswordHintInfor":
        "密码提示信息",
    "workFlow.zh.inforName": "消息名称",
    selectActionCategoryBeforeConfigAction:
        "请先选择操作类别后再进行操作配置",
    "workFlow.zh.linkName": "链接名称",
    "Notice.labelNotTitle": "公告标题",
    "workFlow.zh.dataObject": "数据对象参考",
    "workFlow.WFChange.hintTips": "温馨提示",
    "mobileDev.homeRightSide.hintDatabase": "请选择数据库",
    "code.codeStepOne.datasheetSelect": "数据表选择",
    "tableOperationModule.editorBtn": "编辑",
    "databaseManage.databaseTable.addSheet.commonFieldsBtn":
        "常用字段",
    "BI.listIndex.newBigScreenBtn": "新建大屏",
    "BI.components.datetime.labelThickness": "文字粗细",
    "workFlow.zh.jobConfig": "工作配置",
    "workFlow.User.signatureVerify": "电子签章验证",
    "companyManager.companyFormDialog.labelManager": "负责人",
    "taskScheduling.taskDesign.addExpressionModal.expressionTen":
        "每月15日10:15分运行",
    "mobileDev.loginRightSide.labelBtnBorderRound": "按钮边框圆角",
    "workFlow.selectNodes.fieldType": "字段类型",
    "mobileDev.loginRightSide.selectNo": "否",
    "workFlow.historyList.tabState": "状态",
    "BI.components.flop.titlePrefixSet": "前缀设置",
    "workFlow.User.tableType": "类型",
    "Create inclusive-gateway-event": "相容网关",
    "editorModule.indianRupeeSign": "印度卢比",
    "fileManagement.uploadFileBtn": "上传文件",
    accessoryFormat: "附件格式",
    "orgDepartManagement.departmentFormDialog.placeholderRemark":
        "请填写备注",
    "navbar.logOut": "退出登录",
    "wechatAndDingTalk.departmentManagement.tableDepNumber":
        "部门编号",
    "subSystem.searchTitle": "名称",
    "orgUserManagement.searchSelectPart": "请选择部门",
    "mobileDev.functionDesignStepFour.CustomTimeQ":
        "自定义时间查询",
    submitText: "确定",
    "workFlow.zh.formKey": "表单Key",
    "BI.listMap.hintMapName": "请输入地图名称",
    bindForm: "绑定表单",
    "formDesign.labelName": "表单名称",
    "BI.echart.wordCloud": "字符云",
    "reportModule.reportRelease.tabParMenu": "父级菜单",
    "mobileDev.loginDesignForm.saveTemplateModal.placeholderName":
        "请填写模板名称",
    "searchModule.startDatePlaceholder": "开始日期",
    "mobileDev.loginDesignStepOne.headTitle": "模板列表",
    "workFlow.searchConfig.tabHight": "时间搜索框高度",
    "workFlow.zh.eventSubflow": "事件子流程",
    "workFlow.Bpmn.textAdaptive": "自适应屏幕",
    "BI.listIndex.Modal.fillSrcSize": "请输入大屏尺寸",
    "databaseManage.databaseField.tableName": "名称",
    "menuManagement.addModal.optionLabelNewform": "新窗体打开",
    "crud.showTitle": "列显隐",
    "orgRoleManagement.viewMemberModal.modalTitle": "查看角色成员",
    "workFlow.WFMonitor.hangUpBtn": "挂起",
    "user.info": "个人信息（用户）",
    "workFlow.Approver.tabName": "名称",
    "workFlow.addStamp.radioHandwrit": "手写签名",
    "workFlow.Bpmn.textNarrow": "缩小",
    "workFlow.Process.templateNum": "模板编号",
    "workFlow.callActivity.radioSynchronize": "同步",
    "orgRoleManagement.appSetAuthorizeModal.modalTitle": "APP授权",
    purchaseApply: "采购申请",
    "workFlow.privateStampInfo.tabStatus": "状态",
    "mobileDev.functionDesignStepFive.titleShown":
        "已显示到列表字段",
    withdrawalFailed: "撤回失败！",
    "code.leftScrollbar.component.counter": "计数器",
    "Schedule.editModalTitle": "编辑",
    "user.info.nameEmpty": "姓名不能为空",
    "code.codeStepOne.tabAssoTable": "关联表",
    "editorModule.hongKongTaiwan": "元字样（港台地区）",
    "deletePrompt.Enable": "启用",
    "taskScheduling.taskDesign.addModal.placeholderDatabase":
        "请选择数据库",
    associativePopupSelectRecord: "联想弹层记录",
    "workFlow.User.personnelList":
        "人员列表（会签人员名单与审批人名单一致，如需修改请调整审批人名单）",
    "topTheme.nameSimpleTheme": "简约主题",
    Notice: "通知公告",
    "editorModule.history": "历史",
    hintAfterSelectBoundField:
        "选择绑定字段后，会返回查询结果对应字段的第一行数据作为变量数据",
    "codeRule.tableCreateUser": "创建用户",
    "editorModule.lightGray": "浅灰色",
    "code.codeStepFour.configTreeBtn": "配置结构树",
    "workFlow.zh.formField": "表单字段",
    "areaManager.tableSimpleSpelling": "简拼",
    "workFlow.Start.tabBasicConfig": "基础配置",
    "dataItem.dialogInstall.hintEditFail": "修改失败！",
    "wel.welIndex.titleEquAnaly": "设备分析",
    "mobileDev.tableSet.tabTitle": "标题",
    "mobileDev.functionDesignStepFive.Preview": "预览",
    "custmerForm.batchDeletionBtn": "批量删除",
    interfaceAuthorization: "接口授权",
    "code.rightPanel.closeValue": "关闭值",
    "editorModule.notFindSpecifiedString": "未找到搜索内容.",
    "dataItem.dialogInstall.hintSortCode": "请输入分类编码",
    "mobileDev.functionDesignStepSix.labelContrLayer":
        "控制器层输出目录",
    "fileManagement.titleRestoreFile": "还原文件",
    "workFlow.Process.placeholderNum": "请填写序号",
    hintNewTableNameNoEmpty: "新表表名不能为空，否则无法创建数据表",
    "areaManager.addModal.placeholderSimpleSpelling": "请填写简拼",
    codeGenTemCat: "代码生成模板类别",
    modifiedMobileMenuSuccessfully: "修改移动端菜单成功！",
    "workFlow.End.systemInfor": "系统消息",
    uploadImgMaxSize: "上传图片大小不能超过2MB!",
    "workFlow.Process.placeholderSelectRule": "请选择自动同意规则",
    "deletePrompt.stopFailure": "暂停失败!",
    "workFlow.zh.divideThree": "分割成三个道",
    "code.leftScrollbar.copyJsonBtn": "复制JSON",
    "workFlow.zh.linkThrow": "链接中间抛出事件",
    "BI.echart.table": "表格",
    "code.rightPanel.minRows": "最小行数",
    "menuManagement.addModal.nextStepBtn": "下一步",
    "codeRule.addModal.addDialog.labelFormat": "格式",
    "mobileDev.homeRightSide.labelCTextBgC": "轮播文字背景色",
    "databaseManage.dataSource.tableDatabase": "数据库",
    "editorModule.pastePlain":
        "当前为纯文本粘贴模式，再次点击可以回到普通粘贴模式。",
    "taskScheduling.taskDesign.addFrequencyModal.unitHours": "小时",
    "workFlow.WFDesign.labelStop": "停用",
    "code.codeStepThree.dataFInq": "数据字段查询",
    "route.detail": "详情页",
    "deletePrompt.hintSuccess": "成功！",
    "workFlow.WFMenu.hintFailure": "失败，提示信息：",
    "editorModule.format": "格式",
    editMobileFunction: "编辑移动功能",
    "areaManager.tableName": "名称",
    "selectUser.labelName": "姓名",
    "interfaceManage.addModal.labelName": "接口名称",
    "taskScheduling.taskDesign.tableWaiting": "待执行",
    "language.translation.tableNumber": "#",
    "deletePrompt.modifiedSuccessfully": "修改成功!",
    "workFlow.roams.externalNode": "外部流程节点",
    "orgUserManagement.tabNum": "#",
    "orgUserManagement.disUserBtn": "禁用账户",
    selectDataBaseFillSql: "请选择数据库以及填写sql语句",
    "workFlow.WFMenu.tabFuncName": "功能名称",
    "forme.tableHeaderEditor": "编辑人",
    dataSourceNotSelected: "数据来源未选择",
    "code.formList.description": "设置生成单表或多表的增删改查功能",
    "workFlow.zh.createType": "创建 {type}",
    "code.rightPanel.hintSpecifyData": "请先指定数据源",
    "workFlow.createFLow.titleLaunch": "发起",
    "mobileDev.loginRightSide.labelWordSize": "按钮名称字大小",
    "databaseManage.dataLink.tableName": "名称",
    "mobileDev.functionDesignStepSeven.fixedListDto": "列表页Dto",
    parallelExecution: "并行执行",
    "orgRoleManagement.Hint.addFailed": "添加人员失败!",
    "code.codeIndex.stepNameOne": "表结构配置",
    discountAmount: "优惠金额",
    "workFlow.Step1.hintMCode": "请填写专项菜单编码",
    "databaseManage.databaseTable.addTableBtn": "新建表",
    "workFlow.addStamp.placeholderSort": "请填写排序",
    "code.rightPanel.placeholderSuffix": "请输入后缀",
    "taskScheduling.taskDesign.addModal.placeholderFunctionDescription":
        "请填写功能描述",
    "orgUserManagement.addModal.labelPassword": "密码",
    "mobileDev.functionDesignForm.hintMinOne":
        "请至少配置一个表单元素",
    "workFlow.launchList.fixedTitle": "流程分类",
    "code.leftScrollbar.hintError": "错误",
    "workFlow.historyList.renewBtn": "更新到此版本",
    "BI.Build.bgImage": "背景图片",
    newDesktop: "新建桌面",
    "taskScheduling.taskDesign.addFrequencyModal.unitMinute":
        "分钟",
    "workFlow.WFDesign.titlePreview": "预览-",
    "workFlow.menuForm.titleAccess": "模板权限",
    "code.codeForm.saveTemplateModal.labelName": "模板名称",
    "taskScheduling.taskDesign.addFrequencyModal.March": "三月",
    "mobileDev.homeRightSide.moreCard": "多列卡片",
    "code.leftScrollbar.hintFormatError": "JSON格式错误，请检查",
    "interfaceManage.addModal.tableFieldType": "字段类型",
    sortOrder: "排序顺序",
    succeededDeletingPost: "删除岗位成功！",
    "areaManager.editModalTitle": "编辑区域",
    "code.codeStepTwoListStructure.hintDataNum": "数据序号",
    selectJumpFunction: "请选择跳转功能",
    "databaseManage.dataSource.addModalDatabase": "数据库",
    assignVariablesUsingSqlStatements: "使用SQL语句赋值变量",
    "BI.configBI.colorTwo": "渐变色",
    "workFlow.Step1.placeholderMCode": "请填写菜单编码",
    "mobileDev.loginRightSide.labelPasswordIcon": "密码图标",
    "deletePrompt.hintLoading": "正在加载中，请稍后",
    "menuManagement.addModal.checkboxMenu": "菜单",
    enterFunctionName: "请输入功能名称",
    "databaseManage.dataLink.tableNumber": "#",
    cancelText: "取消",
    "News.placeholderWriter": "请填写作者",
    "orgRoleManagement.editModal.modalTitle": "编辑信息",
    userAccessSourceSite: "某站点用户访问来源",
    "workFlow.Process.selectForm": "选择表单",
    dataSet: "数据设置",
    "Create subprocess-expanded-event": "子流程",
    "code.rightPanel.colorValue": "颜色值",
    hintRequestTimeout: "请求 错误/超时 请联系系统管理员！",
    "mobileDev.formRightSide.placeholderSelectField": "请选择字段",
    quoteApi: "引用API",
    "dataItem.addModal.placeholderValue": "请填写编码",
    "editorModule.cutRow": "剪切行",
    "mobileDev.formRightSide.optionMobileOrPhone":
        "电话格式或手机格式！",
    retract: "撤回",
    "ifTheSub-processExecutedAsynchronouslyCompletionConditionComparisonWillNotPerformed":
        "备注：如果是异步执行子流程，则不会进行完成条件比对。",
    "editorModule.general": "普通",
    "mobileDev.formRightSide.optionEmail": "必须为E-mail格式！",
    "user.aboutDialog.modalTitle": "关于",
    "workFlow.User.approvalDisplay": "审批意见展示",
    "mobileDev.loginDesignStepOne.tabModifyDate": "最后修改时间",
    "BI.components.datetime.labelSize": "字体大小",
    "workFlow.schemeFormDialog.previewBtn": "预览表单",
    "customI/FMgt": "自定义接口管理",
    logoutTip: "退出系统, 是否继续?",
    "mobileDev.homeDesignStepOne.tabName": "首页设计名称",
    "taskScheduling.taskDesign.addModal.labelTaskRestart":
        "任务重启",
    "menuManagement.addModal.stepTwo": "按钮信息",
    circulationTask: "传阅任务",
    "workFlow.publicStampInfo.addMemberBtn": "添加成员",
    "editorModule.resize": "调整大小",
    "workFlow.userButtonSetting.scriptTask": "脚本任务",
    "code.rightPanel.placeholderFrontIcon": "请选择前图标",
    "workFlow.userButtonSetting.tabFunctionBtn": "功能按钮",
    "workFlow.WFDesign.transfer": "转办",
    "code.codeStepFour.refreshBtn": "刷新",
    "editorModule.author": "作者",
    "workFlow.callActivity.variableSourceSub":
        "变量来源 ( 子流程 )",
    "mobileDev.functionDesignStepEight.labelFunType": "功能分类",
    "orgUserManagement.addModal.labelBirthday": "生日",
    newCompany: "新增公司",
    warehouseNum: "入库编号",
    "code.codeStepFive.tabBindField": "绑定字段",
    "editorModule.dongSign": "越南盾符号",
    "BI.echart.scroll": "跑马灯",
    "searchModule.searchFilter": "输入关键字进行过滤",
    "code.rightPanel.optionStyle": "选项样式",
    "databaseManage.databaseTable.importLists.copyTableHeaderTitleIndexSize":
        "索引使用大小",
    "wel.welIndex.xTimes": "次数",
    "formDesign.titleDataTableConfiguration": "数据表配置",
    "subSystemForm.resetBtn": "重置",
    iconBgColor: "图标背景色",
    "importAndExport.importForm.tabColName": "Excel列名",
    submit: "提交",
    "code.rightPanel.btnType": "按钮类型",
    "mobileDev.formRightSide.optionShow": "显示",
    "BI.Build.alignCenter": "居中对齐",
    "workFlow.WFDesign.titleAddFlow": "新增流程设计",
    button: "按钮",
    "taskScheduling.taskDesign.addModal.placeholderInterfaceAddress":
        "请填写接口地址",
    "mobileDev.loginDesignForm.saveTemplateModal.labelName":
        "模板名称",
    "language.languageType.Hint.titlePrompt": "确认提示",
    "workFlow.WFMenu.tagBelTem": "查看所属模板",
    "workFlow.Process.inforInterval": "消息间隔(小时)",
    "workFlow.printCurrentPage.labelDefault": "默认风格",
    "menuManagement.addModal.placeholderUrlAddress":
        "请填写URL地址",
    "code.rightPanel.stepCount": "步数",
    news: "新闻类",
    customOutParameterValue: "自定义出参值",
    "customI/F": "自定义接口",
    "orgImport.uploadLink": "点击上传",
    wan: "万",
    "route.form": "表单",
    "workFlow.WFChange.tabTitle": "标题",
    "code.rightPanel.gridInterval": "栅格间隔",
    "mobileDev.functionDesignStepEight.titleSelectIcon": "选择图标",
    basicComp: "基础组件",
    "code.leftScrollbar.copyCodeBtn": "复制代码",
    "code.rightPanel.placeholderLabelWidth": "请输入标签宽度",
    "wechatAndDingTalk.userManagement.tableInfor": "同步信息",
    "workFlow.Process.automaticRule":
        "自动同意规则 (“自动同意规则”与“上一节点指定审批人”不能同时启用)",
    "orgPostManagement.tabEnCode": "岗位编号",
    OutputConfiguration: "输出配置",
    "orgRoleManagement.indexAuth.inquireBtn": "查询",
    "workFlow.schemeFormIndex.tabFieldName": "字段名",
    "mobileDev.homeRightSide.hintOverNoShow":
        "条数据，超出数量无法显示",
    settleAccount: "结算账号",
    "reportModule.reportRelease.tabNum": "#",
    "taskScheduling.taskDesign.addExpressionModal.expressionTwo":
        "每天10:15运行",
    clickCustomizeConfigEdit:
        "点击进行自定义API参数配置编辑可点击左侧变量到此处进行变量添加，",
    "orgDepartManagement.departmentFormDialog.labelInnerPhone":
        "分机号",
    "code.rightPanel.placeholderFontSize": "请输入字体大小",
    "editorModule.lowercase": "小写",
    noteApiParameterValueTypeFormData:
        "备注：如果“API参数值类型”使用了表单数据，该组件在“列表页”数据当中将不会加载API数据源，显示数据以保存至数据库中数据为准。",
    "companyManager.tabManager": "负责人",
    "forme.editModal.createFormFlowBtn": "发起临时流程",
    productName: "商品名称",
    "editorModule.wonSign": "韩元符号",
    callType: "调用类型",
    "workFlow.zh.general": "常规",
    "mobileDev.functionDesignStepThree.Hint":
        "数据表没有设置副表，子表单不允许拖拽！",
    "workFlow.WFDesign.hintFlowStop": "该流程已停用！",
    "code.codeIndex.stepNameEight": "绑定菜单",
    "workFlow.WFDesign.tabCreateUser": "创建人",
    "code.rightPanel.placeholderFormName": "请输入表单名（ref）",
    newPostSuccess: "新增岗位成功！",
    "taskScheduling.taskDesign.addFrequencyModal.Minute": "分",
    "code.rightPanel.compName": "组件名",
    "companyManager.modalTitleInsert": "添加信息",
    "code.rightPanel.bindSheet": "绑定表",
    "orgUserManagement.tabState": "状态",
    "editorModule.insertEditIframe": "插入/编辑框架",
    "editorModule.purple": "紫色",
    "workFlow.WFDelegate.tabEntrusted": "被委托人",
    "mobileDev.functionDesignStepSeven.fixedFormDto": "表单页Dto",
    "editorModule.textDisplay": "显示文字",
    "forme.addModal.placeholderDefaultHight": "不填则使用默认高度",
    "code.codeStepThree.tabHight": "时间搜索框高度",
    "editorModule.rightToLeft": "从右到左",
    "language.languageCategory.sv-SE": "瑞典语",
    "code.codeStepEight.common": "公共",
    "orgUserManagement.addModal.placeholderJobNum": "请填写工号",
    "mobileDev.homeRightSide.labelOneIcon": "标签一图标",
    "code.rightPanel.setTableField": "设置表格字段",
    "editorModule.fontSize": "字号",
    interfaceEnabled: "该接口是启用状态",
    "editorModule.headersTwo": "标题2",
    "orgPostManagement.tabName": "岗位名称",
    "editorModule.focusElementPath": "移动焦点到元素路径",
    "workFlow.privateStampInfo.tabNum": "#",
    "forme.editModal.initiateApproval": "发起审批",
    btnSelectData: "按钮选择数据",
    "mobileDev.searchRightSide.labelTimeName": "自定义时间查询名称",
    "wechatAndDingTalk.departmentManagement.syncDingBtn":
        "同步到钉钉",
    "companyManager.titleBasicInformation": "基本信息",
    "mobileDev.formRightSide.optionString": "必须为字符串！",
    "databaseManage.dataLink.writeDatabaseIP": "请填写数据库IP",
    "mobileDev.tableSet.labelDatabase": "数据库",
    "workFlow.zh.upgrade": "升级",
    "mobileDev.formRightSide.optionOnlyDate": "仅日期",
    "workFlow.zh.hintEgTwo":
        "跟踪日期必须符合EL表达式，如： ${someDate} ,或者一个ISO标准日期，如：2015-06-26T09:54:00",
    "user.info.name": "姓名",
    sureToRestore: "是否确认恢复？",
    assignField: "赋值字段",
    "workFlow.processTasks.whetherRead": "是否已阅",
    "workFlow.Approver.roleBtn": "角色",
    "workFlow.WFMenu.tabNum": "#",
    "code.codeStepFive.tabNum": "#",
    "code.codeStepTwoListStructure.hintFounder": "请填写创建人",
    "workFlow.Process.radioNotInherited": "不继承",
    "orgRoleManagement.appSetAuthorizeBtn": "APP功能授权",
    "companyManager.tabCompanyAbbreviation": "公司简称",
    "Notice.dialogTitle.Add": "新增",
    "editorModule.darkPurple": "深紫色",
    "mobileDev.formRightSide.labelShowField": "显示字段",
    invalidVariableParametersUsedCurrentProcess:
        "当前过程处理中有使用无效的变量参数，请先修改再下一步",
    designPreview: "设计预览",
    variableEncodingSupportsOnlyEnglishAndUnderscores:
        "变量编码只支持英文和下划线",
    shortcutMenu: "快捷菜单",
    "crud.updateBtn": "修改",
    "code.leftScrollbar.component.currencyCapital": "货币大写",
    "BI.group.top.Preview": "预览",
    "workFlow.printCurrentPage.labelManuscript": "发文稿纸风格",
    nodeProperties: "节点属性",
    "language.dataDictionary.hintExecut": "执行中...",
    "editorModule.undo": "撤销",
    "taskScheduling.taskDesign.addModal.taskRestartThree":
        "分钟,执行一次;重启次数",
    "code.codeStepFour.tableHeaderAlignment": "对齐",
    "reportModule.reportRelease.labelIcon": "图标",
    "code.rightPanel.hintScoreMax":
        "评分最大值必须大于或者等于默认值",
    "workFlow.User.tabFormSet": "表单设置",
    pleaseFillInTheComponentCode: "请填写组件编码",
    "editorModule.capitalization": "大写",
    "code.codeStepOne.noSet": "不可设置",
    parmOps: "参数操作",
    "workFlow.printCurrentPage.hintNoPermission":
        "无表单权限，请检查数据格式",
    configured: "已配置",
    "code.codeStepFour.parentField": "父级字段",
    "menuManagement.tableUrlAddress": "URL地址",
    "workFlow.categoryList.editTitle": "编辑",
    "workFlow.userButtonSetting.radioScript": "脚本参数配置",
    "databaseManage.databaseTable.importLists.copyTableHeaderTitleRemarks":
        "表备注",
    "mobileDev.mobileSchema.titleSelected": "已选功能",
    "code.leftScrollbar.component.tabs": "选项卡",
    "code.leftScrollbar.component.title": "标题",
    "databaseManage.dataLink.writeNameDatabase": "请填写数据库名称",
    "taskScheduling.taskDesign.addModal.modalTitle": "新增任务",
    "code.rightPanel.verticalArrange": "垂直排列",
    "editorModule.showInvisibleCharacters": "显示不可见字符",
    "workFlow.addStamp.placeholderRemark": "请填写备注",
    desktopDesignsPublishedMenusRefresh:
        "桌面设计发布成菜单需要刷新页面",
    "language.languageType.searchPlaceholder":
        "输入语言名称进行查询",
    "code.codeStepSix.hintSameName":
        "当前功能类名已存在，相同功能类名会引起系统功能出错",
    "workFlow.roams.circulator": "传阅人：",
    "code.codeStepFour.alignRight": "右对齐",
    "editorModule.orientation": "方向",
    "BI.group.contentMenu.moveUp": "上移一层",
    upperFiveLevels: "上五级",
    "wel.welIndex.lastMonthDrugCons": "上月吨水药耗：",
    "workFlow.zh.initiator": "创建者",
    "workFlow.callActivity.variableSourceMain":
        "变量来源 ( 主流程 )",
    "editorModule.pasteText": "粘贴为文本",
    "workFlow.processTasks.placeholderInquire": "请输入要查询的",
    "topTheme.nameLightTheme": "浅色主题",
    "mobileDev.functionDesignStepTwo.Unsettable": "不可设置",
    "fileManagement.Fixed.Documents": "文档",
    "Log.tableResult": "执行结果",
    valueChangeEvent: "值改变事件",
    "language.translation.titleEditTra": "编辑翻译",
    "mobileDev.homeRightSide.stackBar": "堆叠条形图",
    "workFlow.processTasks.taskName": "任务名称",
    "codeRule.addModal.tableFormat": "格式",
    "workFlow.filedConfig.tabWidth": "宽度",
    originatorPostId: "发起人员岗位ID",
    "code.codeStepTwoListStructure.remark": "备注",
    "taskScheduling.taskDesign.addExpressionModal.expressionThirteen":
        "在2020,2021,2022年每个月的最后一个星期五的10:15分运行",
    "BI.components.table.labelBg": "背景",
    "workFlow.Step1.labelFOrder": "功能排序",
    "workFlow.User.optionAll": "全部",
    "editorModule.alignCenter": "中间对齐",
    "wel.welIndex.mouthEnergyCons": "月吨水能耗",
    "workFlow.WFChange.viewBtn": "查看",
    "deletePrompt.enableFailure": "启用失败!",
    "BI.components.table.labelShowHide": "开启显隐",
    "News.placeholderNewsTitle": "请填写新闻标题",
    "databaseManage.dataLink.Describe": "描述",
    successWithdrawStartNode: "成功撤回至开始节点",
    "mobileDev.homeRightSide.imgTitleField": "图片标题字段",
    unbound: "未绑定任何流程",
    "language.languageCategory.zh-CN": "简体中文",
    "code.rightPanel.whetherRead": "是否只读",
    "orgRoleManagement.addModal.placeholderRoleNum":
        "请填写角色编号",
    "mobileDev.functionDesignStepFive.Hint":
        "已显示到列表的字段可拖出列表区域进行删除",
    "editorModule.anchors": "锚点",
    "deletePrompt.successDeleted": "删除成功！",
    "buttonModule.enableBtn": "启动",
    "menuManagement.editModal.dialogTitle": "新增功能",
    "editorModule.formats": "格式",
    "wel.welIndex.unitTon": "吨",
    "mobileDev.homeRightSide.four": "四",
    thereAreDuplicateBindingsInTheComponent:
        "组件存在重复绑定,请更改",
    "workFlow.Circulate.labelOperate": "操作",
    "code.leftScrollbar.component.hintOpinionBook":
        "（此组件只用于接收工作流审批意见，不可手动编辑）意见簿",
    "code.codeStepThree.Eg400": "例如：400",
    "navbar.chilSys": "切换至子系统",
    formConfigError: "系统表单配置错误，没有组件地址",
    "workFlow.zh.connector": "连接器",
    "code.codeStepFour.hintFieldId": "请选择字段ID",
    "interfaceAPI.contactAfterSales":
        "如显示?红色表示出现问题，请联系售后服务",
    "code.rightPanel.whetherSearch": "能否搜索",
    "mobileDev.homeDesDescr": "进行移动端首页设计",
    "mobileDev.functionDesignStepEight.headTitle": "菜单信息配置",
    "editorModule.sharpen": "锐化",
    "user.info.newPassword": "新密码",
    "fileManagement.Hint.moveSuccess": "移动文件成功！",
    "Inclusive Gateway": "相容网关",
    "code.codeStepTwoListStructure.selectContent": "请选择内容",
    "workFlow.WFMonitor.finished": "已完成",
    "workFlow.historyList.previewBtn": "预览",
    "mobileDev.formRightSide.optionMobile": "必须为手机格式！",
    "workFlow.selectSql.hintProhibitUse":
        "禁止使用insert、update、delete、drop等关键字)",
    "taskScheduling.taskDesign.addFrequencyModal.hourError":
        "请填写0-23以内的数字",
    "mobileDev.loginRightSide.placeholderSelect": "请选择",
    "mobileDev.formRightSide.placeholderSelectFormat": "请选择格式",
    webTempClass: "web端模板分类",
    extend: "扩展应用",
    "databaseManage.databaseField.addModalName": "列名",
    "subSystemForm.labelName": "名称",
    "workFlow.Process.translationTag": "翻译标记",
    "code.rightPanel.strictStep": "严格步数",
    "mobileDev.homeRightSide.Content": "内容",
    "workFlow.User.optionPercent": "百分比",
    "editorModule.fullScreen": "全屏",
    exampleLineChart: "折线图示例",
    "taskScheduling.taskDesign.editModal.modalTitle": "编辑任务",
    "workFlow.printCurrentPage.titleUnderline": "标题是否带下划线",
    "language.languageType.tabCode": "语言编码",
    "editorModule.objects": "物件",
    "orgImport.downloadBtn": "下载模板",
    "workFlow.zh.extensions": "扩展",
    "workFlow.selectLaunch.hintLoading": "加载中...",
    apiParmValue: "API参数值",
    parameterNameCanOnlyEnterLetters:
        "参数名只能输入字母、数字、下划线和横杠且数字不能开头",
    "workFlow.WFChange.titleOutputInfor": "输出信息",
    parameterValue: "参数值(Value)",
    "databaseManage.databaseTable.addSheet.tableEnterColumnName":
        "请输入列名",
    "mobileDev.formRightSide.optionPhoneOrNull": "电话格式或者空！",
    search: "请输入搜索内容",
    "companyManager.titleRoleInformation": "角色信息",
    pleaseSelectAnAssignmentType: "请选择赋值类型",
    by: "通过",
    "apiOutputParameterAssignComp-ApiOutputParaNotSelect":
        "API出参赋值组件-API输出参数未选择",
    EnterCorrectFax: "请输入正确的传真",
    "codeSchema.tableClassification": "模板分类",
    "crud.tipStartTitle": "当前表格已选择",
    "mobileDev.functionDesignStepSix.placeholderFunctionN":
        "请填写功能类名",
    "BI.group.contentMenu.Bottom": "置底图层",
    "BI.group.contentMenu.titleFolder": "文件夹",
    "workFlow.createFLow.saveDraftBtn": "保 存 草 稿",
    "deletePrompt.batchDeleteFailed": "批量删除失败！",
    "mobileDev.loginRightSide.centerAlign": "居中",
    "databaseManage.databaseTable.addSheet.tableKey": "主键",
    "mobileDev.formRightSide.attachmentBox": "附件框",
    dimName: "维度名称",
    "code.codeStepFour.displayPerPage": "每页显示",
    "subSystemForm.labelUrl": "首页引用",
    "orgPostManagement.addModal.placeholderPostNum":
        "请填写岗位编号",
    "workFlow.zh.businessTask": "业务规则任务",
    "BI.group.customBind.hintVerifiedFailed": "验证失败",
    "workFlow.processTasks.hintTransferFailed": "转办失败",
    "workFlow.delegateForm.labelStartDate": "开始时间",
    "BI.components.table.labelShowLines": "显示行数",
    "BI.components.img.labelSWhirl": "开启旋转",
    "workFlow.processTasks.hintWithdrawSuccess": "撤回成功",
    "workFlow.searchConfig.tabWidth": "时间搜索框宽度",
    "editorModule.example": "示例",
    "user.info.linkPersonalSet": "个人设置",
    "editorModule.spellcheckLanguage": "Spell check language",
    "BI.Build.Hight": "高度",
    "databaseManage.dataSource.addModalSQLstatement": "sql语句",
    "importAndExport.importForm.hintSelectAType": "请选择关联类型",
    "mobileDev.homeRightSide.placeholderSelect": "请选择",
    "user.info.funcPermission": "查看功能授权",
    "databaseManage.databaseTable.addSheet.hintNoChinese":
        "表名请不要输入中文！",
    "PCDevGuide.dataSourceManagement": "数据源管理",
    "workFlow.formInitiationProcessDialog.hintNoSelectForm":
        "没有选择表单",
    "taskScheduling.taskLog.tableNumber": "#",
    "BI.group.customBind.seeDatasheet": "查看数据表",
    "taskScheduling.taskDesign.tableOver": "已结束",
    "mobileDev.homeRightSide.contTitleField": "内容标题字段",
    selectComponentSet: "请选中组件进行设置!",
    pleaseUploadTheAPKFile: "请上传APK文件",
    "BI.components.main.labelSubtitle": "副标题",
    "Log.tableDescription": "执行结果描述",
    "codeRule.addModal.addDialog.labelDescription": "说明",
    "menuManagement.editModal.tabCode": "编号",
    "code.leftScrollbar.component.defaultPerson": "系统默认(人员)",
    "databaseManage.dataLink.titleEditDatabase": "编辑数据库",
    "taskScheduling.taskDesign.addModal.addExpression":
        "添加预置表达式",
    "editorModule.headers": "标题",
    nameValue: "名称值",
    "workFlow.userButtonSetting.tableCode": "编码",
    "code.codeStepFour.fieldId": "字段ID",
    customNode: "自定义节点",
    "subSystemForm.hintAddSuccess": "新增成功",
    "workFlow.formInitiationProcessDialog.hintAddSuccess":
        "添加表单成功！",
    "fileManagement.dialogTitle.editFileTitle": "文件编辑",
    "workFlow.processTasks.approvalProcess": "审批流程",
    "mobileDev.functionDesignStepSeven.fixedSerLayer": "服务层",
    "editorModule.lowerRoman": "小写罗马字母",
    "code.codeIndex.stepNameNine": "表结构配置",
    "workFlow.delegateForm.hintEntrusted": "请填写被委托人",
    targetFormField: "目标表单字段",
    "BI.components.line.titleBrokeLineSet": "折线设置",
    piece: "个",
    interfaceSort: "接口分类",
    "code.rightPanel.hintSliderMin": "滑块最小值只能小于等于最大值",
    "workFlow.zh.divideTwo": "分割成两个道",
    "BI.echart.picture": "图表",
    "mobileDev.functionDesignStepFour.Sort": "排序",
    "mobileDev.formRightSide.placeholderDataOption":
        "请选择数据选项",
    "fileManagement.tabFileName": "文件名",
    "workFlow.WFMenu.tabMenuName": "专项菜单名称",
    "workFlow.printCurrentPage.pageStyle": "页面风格",
    "editorModule.newDocument": "新文件",
    "editorModule.youAreUsing": "你正在使用 {0}",
    "editorModule.rubleSign": "卢布符号",
    "editorModule.pesoSign": "比索符号",
    "workFlow.zh.externalScript": "外部脚本",
    "mobileDev.loginDesignStepOne.tabCreateDate": "创建时间",
    mustFillFieldName: "必须填写字段名",
    divide: "除",
    "databaseManage.databaseTable.openDataTableBtn": "打开数据表",
    processDesignAdditionFailed: "流程设计新增失败！",
    "workFlow.approvalFLow.labelDigitalStamp": "电子签章",
    "workFlow.Process.tabAssociatedTask": "关联任务",
    digital: "数字",
    originatorCompanyId: "发起人员公司ID",
    failedDeletePost: "删除岗位失败！",
    "mobileDev.homeRightSide.placeholderExplain": "请输入说明",
    "workFlow.zh.external": "外部",
    "orgDepartManagement.departmentFormDialog.placeholderInnerPhone":
        "请填写分机号",
    "databaseManage.databaseTable.addSheet.importDraftBtn":
        "导入草稿",
    "workFlow.historyList.tabVersion": "版本",
    specification: "规格型号",
    initiatorName: "发起人名称",
    "workFlow.Process.timeoutTime": "超时时间(小时)",
    userName: "用户名称",
    "workFlow.addStamp.hintError": "上传图片大小不能超过 5MB!",
    "workFlow.Approval.labelApprovalCon": "审批内容",
    fieldNameMustStartWidthLetterNumberUnderscores:
        "字段名必需以字母开头,只能包括字母、数字、下划线",
    "workFlow.userButtonSetting.tableOperate": "操作",
    "orgUserManagement.tabDepartment": "部门",
    "login.thirdLogin": "第三方登录",
    Schedule: "日程管理",
    initiatorInfor: "发起人信息",
    "mobileDev.formRightSide.placeholderSelectTable": "请选择表",
    specialPostThreeLevels: "上三级",
    dataPanel: "数据面板",
    "workFlow.Process.placeholderPushTimes": "请填写推送次数",
    "companyManager.modalTitleViewRoles": "查看角色",
    "mobileDev.listRightSide.optionItalic": "斜体",
    "forme.editModal.batchDeletionBtn": "批量删除",
    按钮信息: "按钮信息",
    "code.leftScrollbar.component.table": "表格",
    "editorModule.circle": "空心圆",
    fillPropertyName: "请填写属性名称",
    four: "四",
    "orgDepartManagement.departmentFormDialog.labelManager":
        "负责人",
    "code.codeStepSix.frontEndCode": "是否只生成前端源码",
    "custmerForm.tableFounder": "创建人",
    "workFlow.Process.placeholderRemark": "请输入备注",
    "workFlow.approvalFLow.hintWrongPassword": "签章密码错误",
    "workFlow.privateStampInfo.hintSetDefSuccess":
        "设置默认签章成功！",
    "formDesign.placeholderSelectSort": "请选择表单分类",
    "databaseManage.databaseTable.addSheet.HintWriteTableName":
        "请填写表名",
    "taskScheduling.taskDesign.addModal.stepTwo": "条件配置",
    "deletePrompt.hintFailure": "失败！",
    "editorModule.insertImage": "插入图片",
    "crud.delBtn": "删除",
    index: "首页",
    "databaseManage.dataSource.tableNumber": "#",
    "orgDepartManagement.roleConfiguration.RoleName": "角色名称",
    "BI.group.top.Revoke": "撤销",
    "databaseManage.databaseTable.addSheet.titleTableRemark":
        "表备注",
    "databaseManage.dataLink.tableTaye": "类型",
    "forme.addModal.placeholderFunctionIcon": "请填写功能图标",
    "workFlow.roams.endNode": "结束节点",
    "workFlow.selectSql.formField": "表单字段",
    "editorModule.darkBlue": "深蓝色",
    "editorModule.close": "关闭",
    "companyManager.tabCompanyName": "公司名称",
    menuType: "菜单类型",
    "workFlow.zh.errorEnd": "错误结束事件",
    "mobileDev.homeDesignStepTwo.dynamicChart": "动态图表",
    "workFlow.appointUser.titleAddApprover": "添加委托审批人",
    "workFlow.selectNodes.initiatorSuperior": "发起人上级领导",
    "editorModule.insertEditVideo": "插入/编辑视频",
    curPersonDeptId: "当前人员部门ID",
    "workFlow.selectNodes.restrictiveCondition": "限制条件",
    "custmerForm.tableRemark": "备注",
    "login.hintReenter": "密码不正确，请重新输入",
    "code.rightPanel.small": "较小",
    "workFlow.delegateForm.labelEntrusted": "被委托人",
    "wel.welIndex.unitPiece": "件",
    settlement: "结算号",
    "menuManagement.addModal.placeholderName": "请填写名称",
    processDataFailed: "获取流程数据失败",
    "BI.Build.alignMiddle": "中部对齐",
    "workFlow.WFMenu.hintSubmit": "提交中",
    "orgRoleManagement.tabRoleDescription": "角色描述",
    "workFlow.roams.approving": "正在审批",
    "areaManager.addModal.placeholderRemark": "请填写备注",
    jumpFunction: "跳转功能",
    "workFlow.processTasks.hintMissParameter":
        "缺失参数，无法进行编辑",
    deliveryDate: "交货日期",
    "workFlow.WFDesign.hintSuccess": "成功！",
    "mobileDev.homeRightSide.placeholderHigh": "请输入高度",
    "BI.group.customBind.labelDataOption": "数据选项:",
    "mobileDev.homeRightSide.labelWhetherShowImg": "是否显示图片",
    "reportList.modifyUser": "最后修改人",
    "editorModule.turquoise": "青绿色",
    "mobileDev.loginRightSide.rightAlign": "右对齐",
    "areaManager.tableRemark": "备注",
    "mobileDev.tableSet.placeholderSelect": "请选择",
    "mobileDev.homeRightSide.placeholderAmount": "请输入数量",
    "databaseManage.databaseTable.addSheet.promptNameAndDataType":
        "列名和数据类型不能为空!",
    "mobileDev.loginRightSide.placeholderHigh": "请输入高度",
    "editorModule.fonts": "字体",
    "workFlow.filedConfig.schemeName": "标题",
    "editorModule.paste": "粘贴",
    "forme.addModal.placeholderFunctionDescription":
        "请填写功能描述",
    complete: "请完成",
    cannotExceed10Characters: "不能超过10个字符",
    enterSortNumber: "请输入排序号",
    "code.codeStepOne.tabAssoField": "关联字段",
    "deletePrompt.yesBtn": "是",
    "forgetPass.forgetPWD": "忘记密码？",
    "Notice.placeholderSelectDate": "选择日期",
    "codeRule.addModal.placeholderDescription": "请填写编码说明",
    "messageIndex.viewMoreBtn": "查看更多 》",
    "taskScheduling.taskDesign.addModal.nextStepBtn": "下一步",
    inHiddenComponents: "隐藏组件中：",
    purchaseOrderNo: "采购单号",
    "mobileDev.homeRightSide.placeholderTitle": "请输入标题",
    "codeRule.addModal.placeholderName": "请填写编码名称",
    "databaseManage.databaseTable.importLists.commonFieldsCreateUserName":
        "创建人",
    "code.codeStepFour.createFlowBtn": "发起临时流程",
    "orgDepartManagement.tabPrincipal": "负责人",
    addInterfaceSort: "新增接口分类",
    plus: "加",
    "BI.Build.Angle": "角度",
    "workFlow.WFChange.tabGrade": "等级",
    reportReleaseModifiedSuccessfully: "报表发布修改成功！",
    "BI.listIndex.releaSuccess": "发布成功",
    "code.codeStepFive.headTitle":
        "合计配置(勾选配置的数据列，进行启用合计)",
    "editorModule.nairaSign": "奈拉符号",
    "areaManager.addModal.labelSort": "排序",
    "databaseManage.dataLink.testLinkBtn": "测试连接",
    "taskScheduling.taskDesign.addModal.placeholderStoredProcedure":
        "请填写存储过程",
    generatedNameIs:
        "生成名称为：请假审批单-研发部-张三-202006010001",
    "editorModule.templates": "模板",
    "reportList.createUser": "创建人",
    selectFunctionCategory: "请选择功能分类",
    "orgUserManagement.addModal.Hint.errorNumber": "请输入数字值",
    "taskScheduling.taskDesign.addFrequencyModal.November":
        "十一月",
    "forme.refreshPagePrompt": "表单发布需要刷新页面",
    "code.rightPanel.placeholderBtnIcon": "请输入按钮图标名称",
    "BI.listMap.hintAddSuccess": "新增成功",
    "wechatAndDingTalk.departmentManagement.tableNature":
        "部门性质",
    purchaseType: "采购类型",
    "workFlow.Process.addSuccess": "添加成功！",
    "workFlow.userButtonSetting.sqlConfigTitle": "SQL语句配置",
    "custmerForm.viewHistoryBtn": "历史记录",
    "taskScheduling.taskDesign.addModal.radioTaskTypeOne":
        "SQL语句",
    curPersonPostId: "当前人员岗位ID",
    "workFlow.processTasks.sponsor": "发起人",
    "workFlow.historyList.hintRenewfail": "更新到此版本失败",
    "companyManager.modalTitleEdit": "编辑信息",
    "code.codeStepEight.cache": "缓存",
    "companyManager.approvalRoleBtn": "审批角色",
    "BI.components.main.labelBMargin": "底边距(像素)",
    "wechatAndDingTalk.userManagement.Hint.syncFailure":
        "同步失败!",
    "wechatAndDingTalk.userManagement.Hint.syncSuccess":
        "同步成功!",
    "DeleteInterfaceCategoryDeletesSub-categoriesRegistered":
        "删除此接口分类会同步删除此分类所有子级分类以及已注册的所有接口。",
    "editorModule.dimensions": "大小",
    "editorModule.paragraph": "段落",
    "mobileDev.homeRightSide.labelField": "字段配置",
    "fileManagement.tabModifyTime": "修改时间",
    "user.authorizeInfor.titleFieAccess": "字段权限",
    "editorModule.characters": "字符",
    "workFlow.User.tabCountersign": "会签",
    "editorModule.extendedLatin": "拉丁语扩充",
    "editorModule.warn": "警告",
    cannotExceed4Characters: "不能超过4个字符",
    "workFlow.zh.timerCatch": "定时中间捕获事件",
    "workFlow.WFDesign.exportCommonBtn": "BPMN导出",
    iconColor: "图标颜色",
    "areaManager.addModal.modalTitle": "添加区域",
    "orgPostManagement.tabRemark": "备注",
    childIcon: "子级图标",
    "code.codeStepFour.hintAssocField": "请选择关联字段",
    "code.codeStepFour.alignLeft": "左对齐",
    "workFlow.zh.priority": "优先级",
    "user.setting.hintNetError": "网络出错,请重试",
    "code.codeStepThree.tabEnable": "启用",
    "taskScheduling.taskLog.tableContent": "执行内容",
    "BI.echart.swiper": "轮播图",
    "companyManager.companyFormDialog.labelBusinessScope":
        "经营范围",
    "brackets)": "括号)",
    "subSystem.tableNumber": "#",
    mustFillFormName: "必须填写表名",
    "workFlow.Approver.sqlBtn": "SQL语句指定人员",
    "BI.components.map.labelBorderColor": "边框颜色",
    "wel.welIndex.lastMonthComRate": "上月出水达标率：",
    "editorModule.darkTurquoise": "深蓝绿色",
    "deletePrompt.refreshSuccess": "刷新成功",
    taxIncl: "含税",
    "custmerForm.classifiedManagement.tableName": "表单分类名称",
    "workFlow.WFChange.lowestLevel": "最低级",
    "editorModule.cellType": "单元格类型",
    selectInterface: "选择接口",
    "workFlow.zh.appendCompensation": "追加补偿活动",
    "workFlow.Step3.assignMember": "指定成员",
    "taskScheduling.taskDesign.addFrequencyModal.February": "二月",
    "BI.components.flop.labelBgColor": "背景颜色",
    "crud.addTitle": "新增",
    "taskScheduling.taskDesign.addModal.labelTaskName": "任务名称",
    nodeViewed: "待查阅节点",
    "orgRoleManagement.indexAuthorizeBtn": "首页授权",
    "workFlow.publicStampInfo.maintainerUserBtn": "指定维护人员",
    "fileManagement.titleDownload": "下载",
    "workFlow.WFDesign.reject": "驳回",
    "code.leftScrollbar.component.editor": "编辑器",
    "mobileDev.homeRightSide.labelWhetherShowM": "是否显示更多",
    "dataItem.dialogInstall.modalTitle": "分类管理",
    "BI.components.main.labelGridLine": "轴网格线",
    "databaseManage.databaseTable.selectDataPrompt.promptContent":
        "请选择数据库表",
    "workFlow.WFDesign.hintGetFailed": "获取信息失败！",
    "code.rightPanel.maxRows": "最大行数",
    modifiedPostSuccessfully: "修改岗位成功！",
    "databaseManage.dataLink.writeDatabase": "请填写数据库",
    "mobileDev.homeRightSide.labelWhetherShowT": "是否显示列表标题",
    "language.languageType.hintlanguageType": "请选择语言类型",
    quoteSql: "引用SQL",
    parameterValidation: "参数验证",
    "code.leftScrollbar.hintNotAdd": "暂不能将标签页加入标签页",
    "companyManager.orgList.labelPost": "岗位",
    "code.rightPanel.placeholderCompName": "请输入组件名",
    "BI.Build.dynamicData": "动态数据",
    "menuManagement.tableCode": "编码",
    "editorModule.numberedList": "编号列表",
    "fileManagement.Fixed.Title": "文件类型",
    outputParameterCodeKey: "输出参数编码(KEY)",
    "code.leftScrollbar.page": "页面",
    "forme.addModal.stepOne": "基础信息",
    "interfaceManage.addModal.placeholderAddress": "请填写接口地址",
    minus: "减",
    "code.rightPanel.hintVeriFailed": "验证失败,没有查找到相关字段",
    "BI.components.main.labelTMargin": "顶边距(像素)",
    "orgRoleManagement.dataAuthorizeBtn": "数据授权",
    "dataItem.fixedTitle": "字典分类",
    parameterNameKey: "参数名(Key)",
    "workFlow.createFLow.hintError": "错误",
    "code.rightPanel.startOccupy": "开始占位",
    upperThreeLevels: "上三级",
    "editorModule.footer": "表尾",
    authorizationFailed: "授权失败！",
    "mobileDev.formRightSide.labelInforType": "信息类型",
    "deletePrompt.setFailure": "设置失败!",
    "code.codeForm.Hint.checkSameName":
        "当前功能类名已存在，相同功能类名会引起系统功能出错，是否继续？",
    one: "一",
    "mobileDev.formRightSide.labelSaveField": "保存字段",
    externalProcessNodeYouCannotUsePreviousNodeSpecifyApprover:
        "存在外部流程节点，不能使用上一节点指定审批人",
    "user.info.tip": "只能上传jpg/png用户头像，且不超过500kb",
    "user.info.changePassword": "修改密码",
    "code.rightPanel.cascadeDelimiter": "级联分隔符",
    "workFlow.WFChange.hintSelectRow": "请先选择一行，再进行操作。",
    "mobileDev.FunctionDesTitle": "功能设计",
    "workFlow.categoryList.labelRemark": "备注",
    clickLeftVariableAddVariable: "点击左侧变量到此处进行变量添加",
    taskContent: "任务内容",
    "mobileDev.homeDesignStepTwo.Prompt":
        "从左侧拖入组件进行首页设计",
    "menuManagement.addModal.placeholderTransTag": "请选择翻译标记",
    to: "交予",
    "workFlow.formInitiationProcessDialog.typeSysForm": "系统表单",
    "workFlow.filedConfig.placeholderSelect": "请选择",
    "BI.components.swiper.labelSwiperTime": "轮播时间",
    "code.rightPanel.placeholderIconName": "请输入图标名称",
    "editorModule.idFormat":
        "标识符应该以字母开头，后跟字母、数字、破折号、点、冒号或下划线。",
    "orgPostManagement.addModal.placeholderDepartID":
        "请选择所属部门",
    "workFlow.privateStampInfo.hintSetDefault":
        "确认将此签章设置为默认签章吗？",
    "importAndExport.importConfiguration.tabCreateDate": "创建时间",
    "workFlow.userButtonSetting.editBtnTitle": "编辑按钮",
    customOutParameter: "自定义出参",
    "topLock.titleSetPWD": "设置锁屏密码",
    "editorModule.currency": "货币",
    exampleBarChart: "柱状图示例",
    "editorModule.description": "描述",
    "workFlow.WFMenu.dialogTitle.viewShowField":
        "查看列表显示表单字段",
    "mobileDev.loginRightSide.labelBottomDistance":
        "输入框区域距底部距离",
    aboutToStart: "即将开始",
    "mobileDev.formRightSide.optionDataSource": "数据源",
    "wel.welIndex.tonCost": "吨水成本",
    "mobileDev.loginDesignForm.stepOne": "选择模板",
    "mobileDev.loginRightSide.labelInputHigh": "输入框高度",
    "editorModule.hryvniaSign": "格里夫尼亚符号",
    "code.rightPanel.medium": "中等",
    "code.codeIndex.stepNameFive": "合计配置",
    componentFields: "组件的表和字段",
    "workFlow.WFChange.titleHistoryRecord": "流程模板历史记录",
    "mobileDev.loginRightSide.labelFooter": "页脚",
    "code.leftScrollbar.labelFileName": "文件名",
    clickCustomizeConfigEditEg:
        "添加格式例如：例如：开始节点.报价单.报价金额-开始节点.报价单.成本金额",
    "mobileDev.homeRightSide.configWay": "配置方式",
    levelDataSource: "级数据源",
    "workFlow.WFChange.approval": "审批中",
    "companyManager.companyFormDialog.placeholderComAbbr":
        "请填写公司简称",
    "editorModule.pageBreak": "分页符",
    "taskScheduling.taskDesign.addModal.placeholderTaskName":
        "请填写任务名称",
    "dataItem.dialogInstall.placeholderSelectSuperior":
        "请选择所属上级",
    pageMark: "页面标识",
    "workFlow.printCurrentPage.labelNo": "否",
    "BI.Build.sysColorMatch": "系统配色",
    exitTheLoop: "退出循环",
    "formDesign.Hint.formCategory": "请填写表单分类",
    "code.rightPanel.allowHalfSelect": "允许半选",
    "importAndExport.importConfiguration.hintExcelNotNoll":
        "Excel列名不能为空！",
    "editorModule.headersSix": "标题6",
    searchBoxWidth: "搜索框宽度",
    "workFlow.zh.dueDate": "到期时间",
    enterCustomOutputCode: "请输入自定义出参编码",
    "taskScheduling.taskDesign.addModal.radioFrequencyThree":
        "明细频率设置",
    "wel.welIndex.monthMud": "月总排泥",
    "workFlow.zh.dataInputAsso": "使用数据输入关联连接",
    "custmerForm.classifiedManagement.addModal.placeholderName":
        "请填写名称",
    "importAndExport.importConfiguration.labelDataSource": "数据源",
    "companyManager.companyFormDialog.labelComName": "公司名称",
    "mobileDev.homeRightSide.link": "连接",
    "subSystemForm.placeholderUrl": "请输入首页引用",
    "editorModule.horizontalSpace": "水平边距",
    "workFlow.WFDesign.stopBtn": "停用流程",
    "deletePrompt.startSuccess": "启动成功!",
    "code.leftScrollbar.component.curCompany": "当前公司",
    "mobileDev.homeRightSide.line": "折线图",
    "orgUserManagement.Hint.userDisabled": "该用户是禁用状态！",
    "BI.components.main.titleXSet": "X轴设置",
    "code.rightPanel.fillCompConfig": "==请填写计算式配置==",
    "deletePrompt.startFailure": "启动失败!",
    "deletePrompt.noData": "暂无数据",
    "databaseManage.databaseTable.tableRemark": "表备注",
    "Schedule.hintCancelDelete": "取消删除",
    "importAndExport.excelImport.tableBtn": "绑定按钮",
    "workFlow.Step1.hintSTemplate": "必须选择一个模板",
    superior: "上级",
    "taskScheduling.taskDesign.addExpressionModal.expressionSix":
        "每天14点到15点每5分钟运行一次，此外每天18点到19点每5钟也运行一次",
    "workFlow.WFCard.cardCode": "编码",
    "editorModule.words": "单词",
    "BI.Build.dataType": "数据类型",
    "workFlow.selectSql.hintSqlStatement": "请填写sql语句",
    failedToAddReportRelease: "报表发布新增失败！",
    "mobileDev.listRightSide.rightAlignment": "右对齐",
    "taskScheduling.taskDesign.addModal.placeholderSQLstatement":
        "请填写SQL语句",
    "areaManager.tableLevel": "级别",
    "mobileDev.homeRightSide.labelOneField": "标签一字段",
    "login.phoneLogin": "手机号登录",
    "BI.components.main.labelRMargin": "右边距(像素)",
    componentFieldRepeated: "组件的表或字段重复绑定了",
    "BI.components.main.labelLMargin": "左边距(像素)",
    "BI.echart.scatter": "散点图",
    "workFlow.zh.signalCatch": "信号中间捕获事件",
    "editorModule.encoding": "编码",
    "databaseManage.databaseField.tableFounder": "创建人",
    "mobileDev.functionDesignForm.stepSeven": "代码预览",
    "workFlow.WFDesign.tabNum": "#",
    hintParameterAss: "参数赋值：在节点流转后将表单数据赋值给变量",
    "workFlow.privateStampInfo.placeholderState": "请选择状态",
    "taskScheduling.taskDesign.addModal.labelEndTime": "结束时间",
    "workFlow.WFMonitor.unfinished": "未完成",
    "mobileDev.loginRightSide.labelBorderColor": "边框颜色",
    "editorModule.language": "语言",
    "workFlow.Process.templateName": "模板名称",
    "code.leftScrollbar.exportBtn": "导出vue文件",
    "codeSchema.tableNumber": "#",
    "mobileDev.functionDesignStepOne.tabName": "功能设计名称",
    "code.rightPanel.styleType": "风格类型",
    "orgDepartManagement.tabNum": "#",
    enterInterfaceClassName: "请输入接口分类名称",
    "mobileDev.homeRightSide.oneCard": "单列卡片",
    "workFlow.printCurrentPage.printPageBtn": "打印当前页",
    "editorModule.alignRight": "右边对齐",
    pleaseFillInComponentAssignment: "请填写组件赋值",
    returnTheProcessApprovalState: "将此流程恢复审批状态",
    "workFlow.zh.timeCycle": "重试时间周期",
    addDimension: "添加维度",
    "orgUserManagement.resetPasswordBtn": "重置密码",
    "workFlow.zh.defaultValue": "默认值",
    "workFlow.searchConfig.tabEnable": "启用",
    "importAndExport.importForm.valueDataForm": "数据表",
    "reportList.address": "存储目的地",
    "taskScheduling.taskDesign.tableName": "名称",
    "deletePrompt.initiationProcessSuccessful": "发起流程成功！",
    "code.codeStepSix.labelFounder": "创建人",
    "code.rightPanel.mini": "迷你",
    "workFlow.Process.tabmenuSet": "菜单设置",
    "mobileDev.homeRightSide.codeConfig": "代码配置",
    apiInputParameterAssign: "API入参赋值",
    "editorModule.bulletList": "项目符号",
    "forme.addModal.placeholderColumnWidth":
        "请填写列宽,不填则自动分配",
    "menuManagement.addModal.placeholderIcon": "请填写图标",
    "workFlow.categoryList.labelName": "流程分类名称",
    "workFlow.WFDesign.hintWF": "流程吗？",
    "workFlow.formInitiationProcessDialog.titleFormSet": "表单设置",
    newVersion: "新增版本",
    "Create exclusive-gateway-event": "互斥网关",
    "workFlow.schemeFormIndex.tabFormType": "表单类型",
    "route.data": "数据展示",
    interfaceAuthorizationSucceeded: "接口授权成功！",
    "BI.Build.bindData": "绑定数据",
    "wel.welIndex.handledWarnings": "已处理预警",
    "wel.welIndex.monthDrugCons": "月吨水药耗",
    "mobileDev.homeRightSide.placeholderName": "请输入名称",
    whetherUpdateVersionContent:
        "更新到此版本，会将正在进行中的审批任务按照新版本执行，如果节点信息不同，流程审批状态会发生变化，是否继续更新？",
    processHang: "流程挂起",
    "workFlow.zh.candidateGroups": "候选组",
    "workFlow.Step1.labelFCode": "功能编码",
    populateComponentBindFields: "填充组件绑定字段",
    "editorModule.hintFieldCollision": "错误: 表单提交字段冲突。",
    "editorModule.visualAids": "网格线",
    "companyManager.modalDeleteCompanyPrompt":
        "确定要删除此公司吗？",
    "workFlow.delegateForm.hintStartDate": "请填写开始时间",
    "BI.components.text.labelOpenWay": "打开方式",
    "mobileDev.functionDesignStepSix.labelOutArea": "输出区域",
    "workFlow.zh.processAttributes": "流程属性",
    "mobileDev.formCenterContainer.placeholderText": "请填写文本",
    "workFlow.WFChange.addTitle": "新增",
    "workFlow.WFChange.tabCreateUser": "创建人",
    "mobileDev.tableSet.rightAlign": "右对齐",
    "editorModule.insertLinkActivated":
        "插入链接 (如果链接插件已激活)",
    "workFlow.appointUser.labelAssign": "【指派给】",
    "editorModule.orange": "橙色",
    parameterAssignReferSecondaryAssignParmProcessStart:
        "参数赋值是在过程处理开始之前，针对参数可以进行二次赋值，方便在各个环节调用中可以变更数据。",
    "code.leftScrollbar.organization": "组织机构",
    variableValueTypeParameterCannotNull:
        "变量类型为参数的变量值不能为空",
    "code.rightPanel.compWidth": "组件宽度",
    "code.codeStepFour.placeholderBtnId": "请填写按钮ID",
    "mobileDev.formRightSide.checkbox": "多选框",
    "code.codeStepFive.tabEnableTotal": "启用合计",
    "workFlow.callActivity.hint": "拖拽左侧到此处进行添加",
    "workFlow.Step1.placeholderFCode": "请填写功能编码",
    "code.rightPanel.alignTop": "顶部对齐",
    "workFlow.privateStampInfo.titleEditStamp": "编辑签章",
    "BI.Build.Content": "内容",
    "editorModule.lowerAlpha": "小写英文字母",
    "mobileDev.formRightSide.optionEmailOrNull": "E-mail格式或空！",
    "workFlow.filedConfig.serialNum": "流水号",
    "workFlow.zh.hintErrorD": "子道大于{count}",
    "workFlow.zh.hintErrorE": "元素不能为空",
    "workFlow.zh.hintErrorF": "流程图不符合bpmn规范",
    "workFlow.User.radioNeedPassword": "需要填写密码",
    "workFlow.zh.hintErrorG": "没有可展示的流程图",
    "workFlow.zh.hintErrorA": "在{parent}里，{element}没有父类",
    "workFlow.privateStampInfo.hintWhetherStop":
        "确认停用此签章吗？",
    "deletePrompt.savedSuccessfully": "保存成功!",
    "workFlow.zh.hintErrorB": "没有指定的形状类型",
    "editorModule.table": "表格",
    "workFlow.zh.hintErrorC": "流元素必须是池/参与者的子类",
    "workFlow.zh.hintErrorH": "没有可展示的流程/协作",
    "custmerForm.tableDisable": "禁用",
    "workFlow.zh.hintErrorI":
        "由{referenced}#{property}引用的{element}元素仍未绘制",
    "workFlow.Approver.titleSql": "SQL语句",
    systemTime: "系统时间",
    "workFlow.WFChange.highLevel": "高级",
    "workFlow.zh.hintErrorJ": "{element} 已被渲染",
    "Notice.hintRelease": "发布",
    "workFlow.zh.hintErrorK": "导入{element}失败",
    "interfaceAPI.interfaceService": "接口服务已开启",
    "editorModule.navyBlue": "海军蓝",
    "editorModule.switchFullscreen": "切换全屏模式",
    "taskScheduling.taskDesign.addModal.placeholderExpression":
        "请输入表达式",
    headerConfig: "表头配置",
    "workFlow.menuForm.titleBasicInfor": "基础信息",
    "BI.components.flop.labelPrefixCon": "前缀内容",
    "orgImport.Hint": "只能上传Excel文件，且不超过1G",
    "importAndExport.importForm.selectDataItem": "请选择数据源项",
    will: "将",
    "mobileDev.formRightSide.hintSaveField": "请先选择保存字段",
    "workFlow.approvalFLow.labelCircInfor": "传阅信息",
    "databaseManage.dataLink.databasePort": "数据库端口",
    "forme.addModal.formFrameWidth": "表单框宽",
    "editorModule.travelPlaces": "旅游和地点",
    "workFlow.zh.timerDefinitionType": "定时器定义类型",
    "workFlow.WFChange.updateBtn": "变更至此版本",
    "menuManagement.addModal.stepThree": "表格信息",
    "orgDepartManagement.staffingBtn": "人员配置",
    "workFlow.WFDesign.tabCategory": "分类",
    "code.codeStepTwoListStructure.hintFieldName": "请输入字段名",
    "code.leftScrollbar.inputModule": "输入型组件",
    "PCDevGuide.processTask": "流程任务",
    "BI.Build.titleEvent": "标题事件",
    asApprover: "作为审批人",
    "searchModule.rangeSeparator": "至",
    "companyManager.modalDeleteCompanyText": "删除公司",
    "workFlow.createFLow.labelAnnexSum": "附件汇总",
    "code.rightPanel.whetherFill": "是否必填",
    "codeRule.addModal.addDialog.hintFirstDate":
        "如果存在多个部门情况，默认选择第一部门数据",
    "companyManager.orgList.labelName": "姓名",
    "workFlow.WFDesign.viewHistoryBtn": "历史记录",
    "editorModule.select": "选择...",
    "code.codeStepOne.tabTableName": "表名",
    sortField: "排序字段",
    calculate: "亿",
    "mobileDev.homeRightSide.chartData": "图表数据",
    "Notice.Tab.viewBtn": "查看",
    "mobileDev.functionDesignStepSeven.fixedController": "控制器",
    "workFlow.Process.tabInitiationProcess": "表单发起流程",
    salesOrder: "销售订单",
    "workFlow.processTasks.recycleProcess": "回收站",
    "mobileDev.homeRightSide.labelRefreshT": "刷新时间(单位:分钟)",
    "workFlow.Step1.labelFName": "功能名称",
    "workFlow.printCurrentPage.labelKumon": "公文风格",
    "reportModule.reportRelease.placeholderRptFileId":
        "请选择报表文件",
    "mobileDev.homeRightSide.labelTwoField": "标签二字段",
    "BI.components.table.labelSTime": "滚动时间",
    "importAndExport.importForm.valueOperatorName": "操作人名字",
    "workFlow.processTasks.hintOperFailed": "操作失败",
    "Notice.placeholderAddress": "请填写来源地址",
    "BI.group.customBind.tabTitleOne": "数据源",
    隐藏组件: "隐藏组件",
    "mobileDev.formCenterContainer.placeholderTime": "请选择时间",
    "navbar.language": "中英文",
    "mobileDev.formRightSide.optionCompany": "当前公司",
    "workFlow.WFMonitor.hintNotAdd": "没有添加新的委托人",
    "editorModule.failedUploadImage": "图片上传失败: {0}",
    hangBack: "挂起恢复",
    interfaceModificationSucceeded: "修改接口成功",
    selectDataCategory: "请选择数据类别",
    "code.codeStepFour.deleteBtn": "删除",
    "mobileDev.loginRightSide.labelPhoneHintInfor":
        "手机号提示信息",
    "editorModule.update": "更新",
    "workFlow.approvalFLow.hintReject": "驳回未选择节点",
    "editorModule.plugins": "插件",
    "language.languageType.tabName": "语言名称",
    "mobileDev.homeRightSide.defaultData": "集前四条数据进行配置",
    "workFlow.selectSql.hintUnableApprove":
        "查询结果中必须包含 F_UserId字段(区分大小写)，否则人员将无法进行配置审批",
    "workFlow.zh.addLaneAbove": "在上面添加道",
    btnSelectDataContent:
        "按钮选择数据是指取消原本表格加载时自动加载所有的数据源数据，通过按钮点击弹窗选择的方式供用户进行预加载数据选择。",
    currentProgress: "当前进度",
    "login.hintIncorrectFormat": "手机号码格式不正确",
    "mobileDev.loginRightSide.labelVerifyIcon": "验证码图标",
    "wechatAndDingTalk.userManagement.syncBtn": "同步到系统",
    "fileManagement.tabFileType": "文件类型",
    "menuManagement.addModal.placeholderTarget": "请选择目标",
    "BI.components.flop.labelAddress": "图片地址",
    component: "组件",
    "mobileDev.homeRightSide.videoCard": "视频卡片",
    salesOverview: "销售总览",
    "Schedule.hintBigtime": "结束时间必须大于开始时间！",
    "editorModule.white": "白色",
    "workFlow.zh.jobPriority": "工作优先级",
    "login.msgSuccess": "秒后重发",
    "databaseManage.databaseField.addModalDateLength": "数据长度",
    "editorModule.nordicMarkSign": "北欧马克",
    BindMenu: "绑定菜单",
    "editorModule.insertVideo": "插入视频",
    "BI.components.map.labelCarousel": "开启轮播",
    "interfaceManage.addModal.editInterface": "编辑接口",
    "code.rightPanel.editTable": "编辑表格",
    "code.rightPanel.hintSubtable": "子表单的子组件才能使用副表！",
    buttonClickEvent: "按钮点击事件",
    "editorModule.header": "表头",
    "crud.emptyBtn": "清空",
    "codeSchema.titleOne":
        "在线代码生成器 并自动创建代码（自定义开发模板）",
    "forgetPass.hintLoginAgain": "重置成功，请重新登录",
    "forme.addModal.owningSystem": "所属系统",
    apiParmType: "API参数类型",
    "BI.listMap.addMapBtn": "添加更多地图",
    "code.codeStepTwoListStructure.text": "文本",
    "workFlow.WFLaunch.stampName": "模板名称",
    "mobileDev.formRightSide.optionMobileOrNull":
        "手机格式或者空！",
    "News.labelKeyword": "关键字",
    "code.codeStepSix.labelFunctionName": "功能类名",
    "mobileDev.homeRightSide.one": "一",
    "code.leftScrollbar.runBtn": "运行",
    "Create CallActivity-event": "外部流程",
    selectInterfaceClassSuperior: "请选择接口分类上级",
    interfaceClassSuperior: "接口分类上级",
    "mobileDev.formRightSide.optionNotNull": "不能为空！",
    "workFlow.delegateForm.selectDate": "选择日期",
    "BI.Build.clickEvent": "点击事件",
    "workFlow.printCurrentPage.hintLoad": "加载中...",
    "editorModule.livreTournoisSign": "里弗弗尔符号",
    "editorModule.findActivated": "查找(如果查找替换插件已激活)",
    "reportModule.reportRelease.placeholderFuncDesc":
        "请填写功能描述",
    "BI.components.pictorialbar.labelIcon": "图标",
    "importAndExport.importForm.labelSetField": "设置字段",
    selectWebOwnSystem: "请选择web端所属系统",
    "orgUserManagement.addModal.placeholderName": "请填写姓名",
    "code.rightPanel.upperSpace": "上间距",
    "mobileDev.functionDesignStepSix.labelOnlyFont":
        "是否只生成前端源码",
    "workFlow.createFLow.hintSubmit": "提交中",
    "Notice.placeholderReleaTime": "请选择发布时间",
    "Log.emptyModal.placeholderSelect": "请选择",
    submitForm: "提交表单",
    addProParaSuccess: "添加流程参数成功",
    StartEvent: "开始事件",
    "mobileDev.functionDesignStepEight.labelSort": "排序",
    databaseTableNotexist: "数据库不存在该表，按新增处理",
    dataCoordinate: "数据坐标",
    "workFlow.addStamp.placeholderPassword": "请填写密码",
    "taskScheduling.taskDesign.tableStartTime": "开始时间",
    "code.leftScrollbar.hintCopyCode":
        "代码已复制到剪切板，可粘贴。",
    "workFlow.zh.compensationBoundary": "补偿边界事件",
    "BI.components.main.titleLegendOpe": "图例操作",
    "language.translation.placeholderTagName": "请输入翻译标记名称",
    "code.codeStepSix.outputList": "输出目录",
    wheTitleWrap: "标题是否换行",
    "code.codeIndex.stepNameThree": "查询配置",
    "mobileDev.loginDesignForm.nextStepBtn": "下一步",
    "workFlow.zh.compensationEnd": "补偿结束事件",
    "Notice.dialogTitle.Edit": "编辑",
    "databaseManage.dataLink.databasePassword": "数据库密码",
    sixRandomDigits: "6位随机数",
    "mobileDev.homeRightSide.labelTwoIcon": "标签二图标",
    "messageIndex.titleCirculate": "流程传阅",
    "mobileDev.listRightSide.optionBold": "加粗",
    "editorModule.dateTime": "日期/时间",
    "BI.echart.funnel": "漏斗图",
    "selectPost.titleRole": "选择角色",
    newNone: "（新增无此操作）",
    mobileNumber: "请输入手机号码",
    hintSelectNodeWithdraw:
        "外部流程节点、子流程内部节点、会签节点都不支持撤回；撤回到开始节点需要二次确认！",
    "fileManagement.titleUpload": "上传",
    "workFlow.zh.conditionName": "条件名称",
    "editorModule.upperAlpha": "大写英文字母",
    "mobileDev.functionDesignStepSeven.databaseScript":
        "数据库脚本",
    variableAssignmentTableAllDataEmpty:
        "变量赋值表格所有数据不能为空！",
    "workFlow.zh.dataStore": "数据存储参考",
    "topTheme.iconPreview": "预览",
    optionalAnyLevel: "可选择至任意一级",
    "mobileDev.homeRightSide.slideplugin": "滑动插件",
    "workFlow.zh.sequentialMulti": "时序多重事件",
    "editorModule.insertRowAfter": "在下方插入",
    desktopDesign: "桌面设计",
    "BI.listIndex.viewIcon": "预览",
    "Notice.labelReleaTime": "发布时间",
    "orgRoleManagement.Hint.addSuccess": "添加人员成功!",
    "mobileDev.homeRightSide.Field": "字段",
    fillSqlStatementDropVariablesLeftAddVariables:
        "请填写SQL语句，可拖入左侧变量到此处进行变量添加（只支持查询语句），输入格式如：select * from table where CompanyID='接口入参.CompanyID'",
    outputParameterSourceCannotEmpty: "输出参数来源不能为空！",
    "workFlow.Process.selectTaskState": "请选择任务状态",
    interfacedesign: "界面设计",
    "subSystemForm.labelSort": "排序",
    "BI.Build.Subclass": "子类",
    "editorModule.lowerGreek": "小写希腊字母",
    "code.rightPanel.whetherRebind": "二次编辑或审批是否重新绑定",
    "editorModule.currentWindow": "当前窗口",
    modifyMenuSuccessfully: "修改菜单成功！",
    correctPhoneLandlineNumber: "请输入正确的电话号码或座机号码",
    "mobileDev.functionDesignStepSeven.fixedTitle":
        "列表左侧树形结构配置",
    componentsComponentCodeCannotBeEmpty: "个组件-组件编码不能为空",
    "orgRoleManagement.databaseAuth.radioSelfSubstaff":
        "仅查看本人及所有下属员工",
    hundred: "百",
    "BI.group.contentMenu.Top": "置顶图层",
    whetherRecordProcessInfor: "是否记录流程信息",
    "editorModule.justify": "两端对齐",
    switchCurrentVersionFailed: "切换当前版本失败",
    "BI.components.gauge.labelRoughness": "刻度线粗度(像素)",
    "BI.components.table.labelEvenColor": "偶行颜色",
    showCompBorder: "显示组件边框",
    "TestXZ.Testtranslation": "测试翻译333",
    "orgPostManagement.tabManager": "负责人",
    "user.authorizeInfor.titleBtnAccess": "按钮权限",
    "mobileDev.loginRightSide.labelTenantIcon": "租户码图标",
    "topLock.labelPWD": "锁屏密码",
    "editorModule.rowGroup": "行组",
    "code.rightPanel.bindField": "绑定字段",
    processDesignAddedSuccessfully: "流程设计新增成功！",
    "mobileDev.loginRightSide.labelTenantHintInfor":
        "租户码提示信息",
    "Log.emptyModal.modalTitle": "清空",
    "mobileDev.formRightSide.optionNumOrNull": "数字或空！",
    yAxis: "Y轴",
    "editorModule.yenCharacter": "日元字样",
    "mobileDev.homeDesignStepTwo.myBtn": "我的",
    "mobileDev.listRightSide.fontColor": "字体颜色",
    "buttonModule.emptyBtn": "清空",
    remarksTheDataReturnedByTheInterfaceParametersMustBeArrayType:
        '备注：接口出参返回数据请务必保证是数组类型，如果不为数组类型，赋值将失败，子流程将无法启动。举例：{"1","2","3"}',
    "code.rightPanel.fileSize": "文件大小",
    "areaManager.addModal.labelSimpleSpelling": "简拼",
    "workFlow.callActivity.calledElement": "被调用元素",
    "editorModule.tugrikSign": "图格里克符号",
    newMenuFailed: "新增菜单失败！",
    "BI.listIndex.publishIcon": "发布",
    "reportModule.reportManage.placeholderRName": "请填写报表名称",
    maxDimension: "维度最大值",
    "mobileDev.loginCenterContainer.passwordLogin": "帐号密码登录",
    "BI.components.pictorialbar.labelMargin": "间距",
    "workFlow.addStamp.hintAddFailure": "添加失败",
    "code.codeStepSix.addAreaBtn": "新增区域",
    "workFlow.zh.complexGateway": "复杂网关",
    "workFlow.zh.assignee": "代理人",
    "mobileDev.loginRightSide.accountLogin": "账号密码登录",
    "login.hintPhonLength": "手机号码长度不为11位",
    "reportModule.reportManage.hintRType": "请填写报表类型",
    deleteInterfaceInvalidateReferenceInterface:
        "删除接口会导致所有引用该接口功能失效！",
    "mobileDev.homeRightSide.list": "列表",
    "editorModule.width": "宽",
    interfaceDisabled: "该接口是禁用状态",
    "reportModule.reportRelease.dialogTitle.addTitle": "新增",
    "workFlow.zh.startEvent": "开始事件",
    initiatorId: "发起人员ID",
    "orgDepartManagement.departmentFormDialog.labelFax": "传真",
    "editorModule.insertEditImage": "插入/编辑图片",
    modifyCompany: "修改公司",
    "custmerForm.addBtn": "新增",
    "codeRule.addModal.addDialog.labelPrefix": "前缀",
    "editorModule.insert": "插入",
    "workFlow.WFDelegate.tabDescr": "委托说明",
    "editorModule.charactersNoSpaces": "字符(无空格)",
    "topTheme.titleSelectTheme": "选择主题",
    parameterNameInputParameterCannotEmpty:
        "输入参数的参数名不能为空",
    "workFlow.zh.endEvent": "结束事件",
    "workFlow.processTasks.startTime": "发起时间",
    "BI.listIndex.Modal.Index": "首页",
    "wel.welIndex.untreatedWarnings": "未处理预警",
    "editorModule.mathematical": "数学",
    "workFlow.selectSql.hintSelectData": "请选择数据库",
    "navbar.notice": "消息通知",
    orderStatus: "订单状态",
    "editorModule.userDefined": "自定义",
    originatorRoleId: "发起人员角色ID",
    "editorModule.cruzeiroSign": "克鲁赛罗币符号",
    "BI.group.modalTitle": "图库",
    "wel.welIndex.DrugCons": "药耗",
    "mobileDev.functionDesignStepSeven.fixedRenderLayer": "渲染层",
    design: "设计",
    "editorModule.notLoadEmoticons": "不能加载表情符号",
    "wel.welIndex.monthCapacity": "月处理量",
    "editorModule.constrainProportions": "保持纵横比",
    documentStatus: "单据状态",
    "mobileDev.formRightSide.editor": "编辑器",
    "dataItem.addModal.hintSort": "请填写排序",
    "workFlow.processTasks.reInitiate": "重新发起",
    currentInfor: "当前信息",
    selectWebOwnSuperior: "请选择web端所属上级",
    "forme.addModal.openDialogTitle.exportConfiguration":
        "快速导出配置",
    "code.codeStepThree.placeholderEg":
        "例如：创建时间、修改时间等",
    "taskScheduling.taskDesign.addModal.radioEndTimeTwo":
        "设定结束时间",
    "mobileDev.loginDesignStepOne.Hint.selectData":
        "请先选择要删除的数据项",
    "workFlow.zh.resultVariable": "结果变量",
    "code.rightPanel.hintEnsure":
        "请保证,存在一个或一个以上可联想绑定数据的组件",
    "databaseManage.dataLink.addModalLoadingText":
        "正在测试链接中，请稍等...",
    "BI.group.customBind.chartConfig": "图表配置",
    descriptionMustBeWithin1600Characters:
        "说明必需在1600个字符以内",
    "BI.components.main.titleValueSet": "数值设置",
    newDatabaseConnectionSuccessful: "新增数据库连接成功！",
    "language.dataDictionary.titleAddTraTag": "新增翻译标记",
    "workFlow.processTasks.placeholderTitleKey": "请输入标题关键字",
    "user.info.emailFormatEmpty": "邮箱格式不正确",
    "code.formList.setFunctionBtn": "设置功能",
    "workFlow.User.percent": "百分比 (不需要填写%)",
    "importAndExport.importForm.labelFixedValue": "固定数值",
    "mobileDev.tableSet.labelSQL": "SQL语句",
    "BI.components.main.labelLineColor": "轴线颜色",
    "workFlow.zh.connectorId": "连接器编号",
    "workFlow.Approver.tabType": "类型",
    "code.codeStepOne.tabDataName": "数据表名",
    "orgRoleManagement.addModal.labelRoleRemark": "备注",
    "BI.listIndex.Modal.screenHigh": "大屏高度",
    showBg: "显示背景",
    "workFlow.historyList.tabNum": "#",
    "BI.Build.labelNumber": "#",
    "workFlow.zh.start": "开始",
    "workFlow.addStamp.labelUpload": "上传图片",
    changeDetails: "变更详情",
    "orgRoleManagement.addModal.placeholderRoleName":
        "请填写角色名称",
    "workFlow.zh.signalName": "信号名称",
    "BI.group.customBind.SQLNotEmpty": "SQL语句不能为空",
    "databaseManage.dataSource.tableCreateUser": "创建用户",
    "forme.addModal.addTitle": "新增表单功能",
    "orgUserManagement.addModal.placeholEmail": "请填写邮箱",
    "codeSchema.tableDescription": "模板描述",
    "editorModule.brightness": "亮度",
    "workFlow.selectSql.hintSqlConfig":
        "请输入sql语句进行配置 只允许使用select查询关键字，",
    "mobileDev.formRightSide.optionDateOrTime": "日期和时间",
    "orgRoleManagement.tabNum": "#",
    "code.codeStepSix.placeholderFunctionName": "请填写功能类名",
    warehouse: "入库仓库",
    outputParameterDataCategory: "输出参数数据类别",
    "mobileDev.loginDesDescr": "进行移动端登录设计",
    moblieFileList: "移动端前端文件输出目录",
    "code.codeStepFour.noPage": "不分页",
    invalidVariableCustomParameterAssignment:
        "自定义出参赋值有使用无效的变量，请先修改再下一步",
    "workFlow.addStamp.labelSClassify": "印章分类",
    purchaseDate: "采购日期",
    "Log.tableType": "操作类型",
    "workFlow.categoryList.labelSort": "排序",
    "workFlow.WFDelegate.titleAddFlow": "新增流程委托",
    "menuManagement.addModal.checkboxEffective": "有效",
    paymentOverview: "付款总览",
    "BI.components.main.titleYSet": "Y轴设置",
    sureWantDisableInterface: "是否确定禁用该接口",
    "mobileDev.functionDesignStepSeven.fixedStoIntClass":
        "仓储接口类",
    "workFlow.WFDelegate.tabPrincipal": "委托人",
    "BI.echart.text": "文字",
    lessThan: "小于",
    "useSqlStatementToAssignSub-processInitiator":
        "使用SQL语句赋值子流程发起人",
    "mobileDev.functionDesignStepTwo.searchFName":
        "请输入要查询的表名",
    outOfFocusEvent: "失焦事件",
    "BI.components.main.titleCustomColor": "自定义配色",
    "editorModule.bottom": "底部对齐",
    "orgRoleManagement.databaseAuth.labelEnable": "启用配置",
    "editorModule.keyboardNavigation": "键盘指引",
    "importAndExport.importConfiguration.labelSelectCompany":
        "选择公司",
    "BI.components.datetime.labelAlignment": "对齐方式",
    "deletePrompt.successTitle": "成功",
    "custmerForm.generatedCodeBtn": "生成代码",
    "user.info.confirmPassword": "确认密码",
    "BI.Build.deleteBtn": "删除",
    "editorModule.codeSample": "示例代码...",
    "selectUser.selectPersonnel": "选择人员",
    entrust: "委托",
    "mobileDev.loginRightSide.placeholderRoundSize":
        "请输入圆角大小",
    "route.cache": "页面缓冲",
    showValue: "显示值",
    "workFlow.zh.timerStart": "定时开始事件",
    "searchModule.stateFailure": "失败",
    "mobileDev.functionDesignForm.hintTemName": "请填写模板名称",
    passwordLengthMustLeast6Characters:
        "密码长度最少为6位，最多为10位",
    "mobileDev.functionDesignStepThree.Explain":
        "已配置的元素可拖出展示区域进行删除",
    "workFlow.End.dingDing": "钉钉",
    "code.rightPanel.maxFill": "最多输入",
    "workFlow.zh.configuConnector": "配置连接器",
    changeState: "变更状态",
    "editorModule.left": "左对齐",
    enterFunctionAddress: "请输入功能地址",
    "workFlow.createFLow.labelFlowInfor": "流程信息",
    objectPropertyName: "对象属性名称",
    "BI.menuSortManagement": "分类管理",
    "editorModule.pasteRowAfter": "粘贴到下方",
    "workFlow.callActivity.targetVariableSub":
        "目标变量 ( 子流程 )",
    "mobileDev.loginRightSide.labelBorderRound": "边框圆角",
    unsoldAmount: "未销金额",
    defaultSort: "默认排序",
    asReviewer: "作为审核人",
    "forme.addModal.placeholderSelectForm": "请选择表单",
    "editorModule.alternativeSourceUrl": "替代来源网址",
    enterDimensionName: "请输入维度名称",
    "mobileDev.homeRightSide.Carousel": "轮播图",
    disappointed: "失望",
    lengthTenCharacter: "长度在10个字符以内",
    "code.rightPanel.companyName": "公司名称",
    afterSelectingBindingFieldTheFirstColumnOfDataInCorrespondingFieldOfQueryResultWillReturnedAsVariableData:
        "选择绑定字段后，会返回查询结果对应字段的第一列数据作为变量数据，例如UserID列有“1”、“2”两个数据，则会将数据形成数组后传递至子流程发起人",
    "taskScheduling.taskDesign.addFrequencyModal.executionMonth":
        "执行月",
    "PCDevGuide.dataDictionary": "数据字典",
    "code.rightPanel.hintSubform": "子表单不能绑定主表！",
    dataSourceConfig: "数据源配置",
    "BI.Build.editBtn": "编辑",
    "workFlow.zh.asynchronousAfter": "异步后",
    selectDataCategoryFirst: "请先选择数据类别",
    "databaseManage.databaseTable.addSheet.saveDraftBtn":
        "保存草稿",
    "mobileDev.homeRightSide.explain": "说明",
    "importAndExport.importConfiguration.tabSource": "来源",
    "code.rightPanel.middleScreen": "中",
    "workFlow.Start.subprocess": "子流程发起人",
    "BI.components.text.titleMarqueeSet": "跑马灯设置",
    "BI.components.pictorialbar.labelIconSize": "图标字号",
    "BI.components.map.labelMapScale": "地图比例",
    "workFlow.End.enterpriseWeChat": "企业微信",
    "code.rightPanel.left": "左侧",
    componentsComponentAssignmentCannotBeEmpty:
        "个组件-组件赋值不能为空",
    Not: "非",
    "editorModule.leftToRight": "从左到右",
    "formDesign.titleBasicInformation": "基础信息",
    "editorModule.editAreaShortcutKeys":
        "在编辑区按ALT-F9打开菜单，按ALT-F10打开工具栏，按ALT-0查看帮助",
    "BI.components.main.titleMarginSet": "坐标轴边距设置",
    "code.codeStepOne.hintSelectDatatable": "请选择数据表",
    "mobileDev.mobileSchema.hintMaxSet": "最多设置八个菜单",
    "mobileDev.formRightSide.hintSelectBindTab": "请先选择绑定表",
    haveTheSameFunctionClassName: "有相同的功能类名",
    "orgUserManagement.addModal.Hint.selectDepartment":
        "请选择部门",
    formData: "表单数据",
    objectCollectionConfig: "对象集合配置",
    "importAndExport.importForm.hintSelectSaveField":
        "请选择保存字段",
    "editorModule.titleCase": "首字母大写",
    "mobileDev.loginDesignForm.stepTwo": "界面设计",
    "mobileDev.listRightSide.whetherShowFName":
        "是否显示列表字段名",
    selectRequestType: "请选择请求类型",
    "mobileDev.homeRightSide.placeholderSelectF": "请选择字段",
    "mobileDev.formRightSide.optionDepartment": "当前部门",
    "mobileDev.loginRightSide.placeholderBorderSize":
        "请输入边框大小",
    "mobileDev.functionDesignStepTwo.tabLinkField":
        "关联表对应字段",
    "editorModule.people": "人类",
    "workFlow.launchList.placeholderQueryFlow":
        "请输入要查询的流程名称关键字",
    "mobileDev.homeRightSide.stackArea": "堆叠面积图",
    "editorModule.germanPennySymbol": "德国便士符号",
    "tagsView.closeAll": "关闭所有",
    dataRequestError: "数据请求错误！",
    "workFlow.categoryList.addTitle": "新增",
    "mobileDev.functionDesignStepSix.labelFunctionN": "功能类名",
    "workFlow.Approver.superiorsBtn": "上级领导",
    "editorModule.notSupport":
        "你的浏览器不支持打开剪贴板，请使用Ctrl+X/C/V等快捷键。",
    "workFlow.userButtonSetting.apiConfigTitle": "Api参数配置",
    "orgUserManagement.addModal.placeholderBirthday": "请选择生日",
    "workFlow.WFChange.viewProgress": "查看流程进度",
    areYouSureYouWantDeleteVersion: "确定删除此版本吗？",
    "code.leftScrollbar.component.option11": "选项1-1",
    "workFlow.WFChange.tabTime": "时间",
    "custmerForm.classifiedManagementBtn": "分类管理",
    "workFlow.sequenceFlow.calculatedValue": "运算值",
    "BI.components.flop.labelBorder": "边框",
    disableInterfaceAllFunctionReference:
        "禁用接口会导致所有引用该接口功能失效，并且无法在接口选择中查看到该接口。",
    "workFlow.zh.gateway": "网关",
    "code.rightPanel.disableForm": "禁用表单",
    "code.rightPanel.closePrompt": "关闭提示",
    "editorModule.documentProperties": "文档属性",
    "workFlow.zh.performMonitor": "执行监听",
    "editorModule.image": "图片",
    "workFlow.WFChange.generally": "一般",
    enterMaxDimension: "请输入维度最大值",
    "BI.group.customBind.fieldList": "字段列表",
    "companyManager.companyFormDialog.labelEmail": "邮箱号",
    "areaManager.addModal.placeholderSort": "请填写排序",
    variableHasBeenDeleted: "变量已被删除",
    "mobileDev.formRightSide.hintBindTab": "请先绑定表",
    "mobileDev.homeRightSide.textCarousel": "带文字轮播图",
    selectDataOptionFirst: "请先选择数据选项",
    inputParmConfig: "入参配置",
    "mobileDev.listRightSide.listLineSpace": "列表行距",
    "orgUserManagement.fixedTitle": "公司信息",
    clickEditCustomSqlStatementClickVariableLeftAddVariable:
        "点击进行自定义SQL语句编辑可点击左侧变量到此处进行变量添加,添加格式例如：update table_name set col_name = '%接口变量.CompanyID%' where col2_name = '%接口入参.RoleID%'",
    "language.menuFunction.placeholderFill": "请填写",
    "code.codeStepThree.tabWidth": "时间搜索框宽度",
    "workFlow.approvalFLow.placeholderStamp": "有电子签章必填",
    "editorModule.imgList": "图片列表",
    "taskScheduling.taskDesign.addModal.simpleRepetitionFour":
        "执行一次",
    "orgPostManagement.fixedTitle": "公司信息",
    "workFlow.zh.scriptTask": "脚本任务",
    "workFlow.userButtonSetting.tableName": "名称",
    slidingPluginTitle: "滑动插件标题",
    becauseEditFunctionWillGetDatabaseDataOverwriteFormComponentDataAssignmentWillInvalid:
        "备注：在“表单初始化”和“获取表单数据”过程中间添加的自定义节点，过程处理操作进行API出参赋值组件数据仅适用于“新增”功能，因为“编辑”功能会获取数据库数据后覆盖表单组件数据，赋值将失效。",
    "dataItem.tableInvalid": "无效",
    "workFlow.WFMenu.tabFieldShow": "表单字段显示",
    selectInterfaceAddress: "请选择接口地址",
    "mobileDev.formRightSide.labelEleTitle": "元素标题",
    "workFlow.Process.pushTimes": "推送次数",
    "BI.listMap.drawMapBtm": "画地图",
    "orgUserManagement.addModal.labelRemark": "备注",
    "subSystemForm.hintModifySuccess": "修改成功",
    "code.codeStepSix.hintFunctionName":
        "请填写功能类名，只能输入英文数字下划线，不大于20个字符",
    "route.tags": "标签",
    "codeRule.addModal.menuRightTitle": "规则设计",
    "workFlow.zh.poolParticipant": "创建池/参与者",
    "wel.welIndex.alarmsNum": "报警总数",
    "workFlow.zh.inputOutput": "输入/输出",
    "editorModule.sourceCode": "源码",
    "custmerForm.previewTitle": "预览",
    "BI.Build.refreshTime": "刷新时间",
    "workFlow.schemeFormIndex.addBtn": "添加",
    "workFlow.userButtonSetting.hintBtnName": "请输入按钮名称",
    "News.labelTagLabel": "Tag标签",
    "mobileDev.searchRightSide.placeholderSelectField":
        "请选择字段",
    "BI.echart.map": "地图",
    dataItem: "数据字典",
    "mobileDev.formRightSide.labelBindField": "绑定字段",
    "taskScheduling.taskDesign.addModal.labelDatabase": "数据库",
    pleaseEnterChangelog: "请输入更新日志",
    "tagsView.menu": "更多",
    finalApprovalNode: "最后审批节点",
    "workFlow.addStamp.labelSName": "印章名称",
    "workFlow.importFlow.hintUploadFailed": "上传失败",
    "mobileDev.loginRightSide.placeholderWordSize": "请输入字大小",
    successWithdrawPreviousNode: "成功撤回至上个节点",
    "wel.welIndex.tonPowerCons": "吨水电耗",
    "mobileDev.tableSet.placeholderColumnWidth": "请输入列宽",
    compCod: "组件编码",
    "code.codeStepOne.databaseList": "数据库列表",
    "user.info.hintOldPassword": "请输入原密码",
    "code.rightPanel.multipleSelectFiles": "多选文件",
    "reportModule.reportRelease.placeholderIcon": "请填写图标",
    "orgRoleManagement.tabEffective": "有效",
    "taskScheduling.taskDesign.addFrequencyModal.Week": "每周",
    "orgUserManagement.addModal.Hint.errorFormat":
        "手机号码格式不正确",
    "workFlow.callActivity.titleSelectTemplate": "选择流程模板",
    "databaseManage.databaseField.addModalDescribe": "描述",
    pleaseChooseEnterVersionName: "请选择输入版本名称",
    "BI.listIndex.Modal.fillHigh": "请输入高度",
    "Create user-task-event": "用户任务",
    "subSystemForm.placeholderName": "请输入名称",
    variableValue: "变量值",
    "editorModule.imageTitle": "图片标题",
    "greaterEqual ": "大于等于",
    "mobileDev.functionDesignStepFour.Sifting": "筛选",
    "language.languageType.Hint.setDefaultLanguage":
        "是否确定将此语言设为默认语言",
    "code.leftScrollbar.component.colorSelect": "颜色选择",
    "wel.welIndex.jinXing": "金星水务",
    "custmerForm.classifiedManagement.Hint.formCategory":
        "请填写表单分类",
    "crud.viewTitle": "查看",
    "code.leftScrollbar.component.clickUpload": "点击上传",
    "importAndExport.importConfiguration.hintDataDict":
        "请填写数据字典！",
    functionPath: "功能路径",
    selectWebFunctionIcon: "请选择web端功能图标",
    "fileManagement.tabNum": "#",
    "custmerForm.previewFormBtn": "预览表单",
    "code.rightPanel.fileFieldName": "文件字段名",
    "databaseManage.databaseTable.importLists.copyTableHeaderTitleName":
        "表名",
    "BI.group.contentMenu.hintWhetherCompose":
        "是否组合所选择的图层?",
    "workFlow.WFMonitor.tabInitiator": "发起者",
    "deletePrompt.editInitializing": "编辑器资源初始化中...",
    "editorModule.previous": "上一个",
    "workFlow.User.optionSingle": "单个",
    "workFlow.selectAuthority.tabName": "名称",
    "orgRoleManagement.viewMemberBtn": "查看成员",
    "mobileDev.formRightSide.dropDownBox": "下拉框",
    "orgDepartManagement.tabInnerPhone": "分机号",
    "orgDepartManagement.Hint.addDepart": "新增部门",
    "orgDepartManagement.departmentFormDialog.labelEmail": "邮箱号",
    "workFlow.userButtonSetting.addParameterBtn": "添加参数",
    "mobileDev.functionDesignForm.stepSix": "输出配置",
    "workFlow.WFMenu.tabFuncNum": "功能编号",
    numberDelivery: "出库单号",
    exampleAddVariables:
        "点击进行自定义SQL语句编辑可点击左侧变量到此处进行变量添加,添加格式例如：update table_name set col_name = '%模板信息.模板编号%' where col2_name = '%模板信息.模板名称%'",
    "fileManagement.Hint.returnSuccess": "还原文件成功！",
    "workFlow.appointUser.labelTask": "任务-",
    SaleNo: "销售单号",
    "mobileDev.homeRightSide.labelYField": "y轴对应字段",
    "orgDepartManagement.departmentFormDialog.placeholderDepCode":
        "请填写部门编码",
    "mobileDev.formRightSide.placeholderEleTitle": "请输入元素标题",
    "BI.Build.Width": "宽度",
    "mobileDev.formRightSide.placeholderVisualState":
        "请选择可视状态",
    "workFlow.WFChange.hintChange": "此操作不可逆！确定要变更吗？",
    "workFlow.zh.name": "姓名",
    apiParmValueType: "API参数值类型",
    viewAll: "查看所有",
    "messageIndex.hintMessageRead": "此条消息已读",
    "workFlow.User.radioUnrelated": "不与表单关联",
    "forme.addModal.openDialogTitle.selectIcon": "选择图标",
    "workFlow.formInitiationProcessDialog.hintSelectForm":
        "请选择表单后提交！",
    onlyAllowOneFileToUploaded: "仅允许上传一个文件",
    "workFlow.Process.radioInherited": "继承",
    "workFlow.Process.tabTimeoutAlert": "超时提醒",
    upperLevel: "上一级",
    becauseNewDoesNotGetFormData:
        "备注：在“获取表单数据”和“加载表单”中间添加的自定义节点，过程处理操作进行API出参赋值组件数据仅适用于“编辑”功能，因为“新增”功能不会获取表单数据。",
    "code.codeStepFive.tabFieldType": "字段类型",
    "orgPostManagement.addModal.placeholderRemark": "请填写备注",
    "editorModule.showCaption": "显示标题",
    "reportList.fileName": "文件名",
    "navbar.about": "关于",
    "orgDepartManagement.tabDescription": "备注",
    "editorModule.formatting": "格式化",
    "orgRoleManagement.databaseAuth.autConfig": "权限配置",
    "workFlow.WFChange.flowChangeBtn": "流程变更-",
    "reportModule.reportRelease.tabBouReport": "绑定报表",
    "BI.components.main.titleHintSet": "提示语设置",
    "databaseManage.dataLink.testLink.promptMessageFailure":
        "测试连接失败",
    imgType: "图片类型",
    "deletePrompt.emptySuccess": "清空成功!",
    "taskScheduling.taskDesign.addModal.radioTaskTypeThree":
        "接口地址",
    "editorModule.upperRoman": "大写罗马字母",
    "workFlow.callActivity.selectContent": "请选择内容",
    parameterType: "参数类型",
    "workFlow.WFDesign.placeholderSelectType": "==选择模板类型==",
    "BI.components.progress.labelPreFontCol": "前缀字体颜色",
    restore: "恢复",
    "editorModule.turkishLiraSign": "土耳其里拉",
    "workFlow.zh.attribute": "属性",
    "editorModule.yes": "是",
    "orgRoleManagement.addModal.modalTitle": "添加信息",
    "mobileDev.formRightSide.timeFrame": "时间框",
    "workFlow.zh.followUpDate": "跟踪日期",
    "BI.components.main.labelFontPosition": "字体位置",
    hiddenComponents: "隐藏式组件",
    enterInterfaceAddress: "请输入接口地址",
    "code.rightPanel.labelConfig": "标签配置项",
    upperLevelCannotChooseMyself: "上一级不能选自己",
    approve: "审批：",
    "BI.Build.Data": "数据",
    "editorModule.colonSign": "冒号",
    "code.rightPanel.characters": "个字符",
    "mobileDev.functionDesignStepSeven.fixedSerIntClass":
        "服务接口类",
    "code.leftScrollbar.component.company": "公司",
    setSystemDefaultHome: "设置为系统默认首页",
    "workFlow.zh.addConstraint": "添加约束",
    getFormData: "获取表单数据",
    fillInInterfaceName: "请填写接口名称",
    "codeRule.addModal.Hint.Prefix": "请填写前缀",
    "workFlow.zh.subflow": "子流程",
    "News.placeholderKeyword": "请填写关键字",
    "workFlow.printCurrentPage.titlePrintPreview": "打印预览",
    returnJsonFormatExampleMore:
        "success等于false的时候进行报错，value为取值对象，只允许string类型，不允许对象或者数值类型",
    "workFlow.zh.outputParameter": "输出参数",
    "BI.Build.Color": "颜色",
    outputParameterSource: "输出参数来源",
    "editorModule.keywords": "关键词",
    "workFlow.WFChange.tabStartUser": "发起者",
    purOverview: "采购总览",
    "workFlow.Process.number": "序号",
    "route.affix": "图钉",
    "taskScheduling.taskDesign.addModal.radioFrequencyOne":
        "只执行一次",
    "route.error": "异常页面",
    "BI.listIndex.hintCopyScr": "确认复制当前大屏?",
    selectMobileFunctionOrder: "请选择移动端功能排序",
    "menuManagement.addModal.labelTransTag": "翻译标记",
    newDatabaseConnectionFailed: "新增数据库连接失败！",
    "mobileDev.functionDesignStepSix.placeholderFounder":
        "请填写创建人",
    "editorModule.valid": "有效",
    "companyManager.companyFormDialog.placeholderComCode":
        "请填写公司编码",
    "editorModule.rotateCounterclockwise": "逆时针旋转",
    "code.leftScrollbar.hintExportFile": "导出文件",
    "deletePrompt.Submit": "提交",
    webOwnSystem: "web端所属系统",
    "workFlow.processTasks.drafts": "草稿箱",
    "BI.components.pie.labelNoshowZero": "不展示零",
    interfaceClassCode: "接口分类编码",
    "orgRoleManagement.databaseAuth.hintNoPermiss":
        "无功能权限,请先功能授权。",
    "orgDepartManagement.addModal.modalTitle": "添加信息",
    "forme.addModal.functionDescription": "功能描述",
    "code.rightPanel.showPrompt": "显示提示",
    upperFourLevels: "上四级",
    "editorModule.linkList": "链接列表",
    "code.rightPanel.formName": "表单名",
    "orgDepartManagement.addModal.roleOfInformation.roleInfor":
        "角色信息",
    salesSituationTable: "2019年上半年销售情况表",
    "editorModule.border": "边框",
    "mobileDev.homeRightSide.uploadBtn": "上传",
    "mobileDev.formRightSide.placeholderShowField":
        "请选择显示字段",
    "taskScheduling.taskDesign.addExpressionModal.expressionFive":
        "每天14点到15点每5分钟运行一次，开始于14:00，结束于14:55",
    "orgRoleManagement.databaseAuth.radioNotEnable": "不启用",
    "wechatAndDingTalk.departmentManagement.syncWeChatBtn":
        "同步到微信",
    addProParaParaValueVar: "添加流程参数参数值变量",
    databaseConnectionModifiedSuccessfully: "修改数据库连接成功！",
    "reportList.modifyTime": "最后修改时间",
    "Log.emptyModal.optionFour": "不保留，全部删除",
    hasBeen: "已将",
    "BI.Build.colMatchSelect": "配色选择",
    "language.languageType.Hint.deletedData":
        "删除此语言类型会同步删除配置好的语言数据。",
    "fileManagement.Hint.clearFailed": "清空回收站失败！",
    "workFlow.Process.placeholderTTag": "请选择翻译标记",
    "workFlow.Process.mobile": "移动端",
    "taskScheduling.taskDesign.addModal.simpleRepetitionTwo":
        "请填写时间",
    invalidInputParameterCurrentVariableAssignment:
        "当前变量赋值中有使用无效的入参参数，请先修改再下一步",
    "route.more": "更多",
    "route.crud": "模板",
    "BI.listIndex.Modal.fillScrName": "请输入大屏名称",
    "orgRoleManagement.setAuthorizeModal.modalTitle": "功能授权",
    "editorModule.redo": "重做",
    "orgUserManagement.addModal.labelSex": "性别",
    "code.leftScrollbar.titleSelectType": "选择生成类型",
    "apiOutputParameterAssignComp-FormCompNotSelect":
        "API出参赋值组件-表单组件未选择",
    interfaceCode: "接口编码",
    "code.codeStepTwoListStructure.decimal": "小数",
    "workFlow.filedConfig.taskName": "任务",
    "workFlow.WFDelegate.titleAddDelegate": "添加被委托人",
    "editorModule.cellPadding": "单元格内边距",
    "codeRule.addModal.Hint.initialValueFormat":
        "初始值不能从零开始",
    "BI.Build.alignTop": "顶对齐",
    "orgDepartManagement.Hint.fetchFailed": "获取人员失败!",
    "workFlow.zh.conditionalStart": "条件开始事件",
    "editorModule.square": "方块",
    "code.rightPanel.expression": "表达式",
    "workFlow.createFLow.hintCheckForm":
        "请检查表单数据是否填写完整",
    interfaceConfig: "接口配置",
    "interfaceAPI.supportHotline": "咨询热线：0731-85570563",
    "editorModule.borderWidth": "边框宽度",
    "mobileDev.mobileSchema.placeholderSeclectIcon": "请选择图标",
    "mobileDev.mobileSchema.tabDesName": "功能设计名称",
    "workFlow.zh.intermediateEvent": "中间事件",
    "workFlow.roams.startNode": "开始节点",
    selectWebMenuOption: "请选择web端菜单选项",
    topic1: "主题1",
    topic2: "主题2",
    "tableOperationModule.tabNum": "#",
    "workFlow.publicStampInfo.hintAssignSuccess":
        "指定维护人员成功!",
    "workFlow.zh.task": "任务",
    topic3: "主题3",
    "wel.welIndex.yDuration": "时长",
    topic4: "主题4",
    enterParamterName: "请输入参数名(Key)",
    "databaseManage.dataSource.addModalWriteCode": "请填写代码",
    InterfaceInputParameters: "接口入参",
    "editorModule.mediaPoster": "封面(图片地址)",
    "deletePrompt.promptContent": "确定要删除此项吗？",
    "code.rightPanel.openPrompt": "开启提示",
    "orgUserManagement.Hint.setAuthorization": "功能授权",
    "companyManager.orgList.labelAccount": "账户",
    operationClearOldTableData: "（此操作会清空旧表数据）",
    useApiAssignObjectCollectionTypeParameter:
        "使用API赋值对象集合类型出参",
    "databaseManage.databaseTable.addSheet.launchFailed":
        "发布失败！",
    "custmerForm.classifiedManagement.addModal.Name":
        "表单分类名称",
    "workFlow.Step4.hintMustSelect": "必须选择",
    "workFlow.delegateForm.labelDescr": "委托说明",
    refreshApiDataSource: "刷新API数据源",
    "orgRoleManagement.Hint.modifyRole": "修改角色",
    "orgRoleManagement.addModal.labelRoleName": "角色名称",
    "orgPostManagement.addModal.labelRemark": "备注",
    "orgRoleManagement.Hint.whetherDeleteRole":
        "确定要删除此角色吗?",
    "mobileDev.functionDesignStepSix.labelFrontEndFile":
        "前端文件输出目录",
    "orgDepartManagement.roleConfiguration.approvalRoleDep":
        "维护审批角色（部门）信息",
    "BI.components.main.labelTextAngle": "文字角度",
    "workFlow.Bpmn.downloadSvgBtn": "下载svg",
    "orgRoleManagement.addMemberModal.modalTitle": "添加角色成员",
    "workFlow.User.addSubtract": "加签或减签",
    "workFlow.delegateForm.placeholderDescr": "请填写委托说明",
    "navbar.switchedSys": "切换系统",
    "deletePrompt.Error": "错误",
    enterParameterValueDefaultValue:
        "请输入参数值(Value),此处为默认值,不填则无默认值",
    "forme.addModal.functionNumber": "功能编号",
    "editorModule.body": "表体",
    interfaceLog: "接口日志",
    "workFlow.WFChange.tabVersion": "版本编号",
    "databaseManage.databaseField.tableFieldLength": "字段长度",
    receiptNumber: "收款编号",
    selectMobileOwnClassify: "请选择移动端所属分类",
    "orgUserManagement.addModal.placeholOICQ": "请填写QQ",
    "workFlow.Approval.labelApprovalResult": "审批结果",
    "orgDepartManagement.approvalRoleBtn": "审批角色",
    "custmerForm.viewHistory.tableVersion": "版本",
    "companyManager.companyFormDialog.placeholderBusinessScope":
        "请填写经营范围",
    "mobileDev.tableSet.labelField": "字段配置",
    "reportModule.reportRelease.placeholderMenuNum":
        "请填写菜单编号",
    userTab: "用户",
    "code.rightPanel.configData": "配置数据源",
    "custmerForm.viewHistory.tableDraft": "草稿",
    "workFlow.privateStampInfo.tabRemark": "备注",
    "mobileDev.homeRightSide.placeholderConfig": "请点击配置",
    "workFlow.Bpmn.hintTemplateSort": "请填写模板分类!",
    titleNotFilledInTitleComponent: "标题组件中标题未填写",
    "mobileDev.homeRightSide.placeholderLink": "请输入链接",
    "orgPostManagement.addModal.placeholderParentId":
        "请选择上级岗位",
    "editorModule.insertLink": "插入连接",
    "crud.saveBtn": "保存",
    "BI.Build.inteParameter": "接口参数",
    "BI.Build.layerName": "图层名称",
    "deletePrompt.selectDeleteData": "请先选择要删除的数据项",
    "code.codeStepFour.placeholderColumnWidth":
        "请填写列宽,不填则自动分配",
    "user.setting.hintNoTemplate":
        "无模板,请到BI设计页面,配置并发布模板",
    "BI.listCategory.labelMName": "模块名",
    sponsorCompany: "发起人所属公司",
    "BI.components.progress.labelType": "类型",
    "mobileDev.homeRightSide.carouselText": "轮播文字",
    "editorModule.more": "更多...",
    "BI.listIndex.Modal.nonIndex": "非首页",
    "editorModule.styles": "样式",
    "workFlow.WFChange.tabTask": "任务",
    "language.translation.labelTraTag": "翻译标记",
    "code.leftScrollbar.financeModule": "财务组件",
    "workFlow.sequenceFlow.variableSource": "变量来源",
    "databaseManage.dataSource.addModalCode": "编码",
    "importAndExport.importForm.tabCode": "编码",
    "language.languageType.Hint.setRemind":
        "默认语言只允许存在一个，设置之后首次登录用户将按照新的默认语言进行界面显示。",
    "companyManager.tabFoundedTime": "成立时间",
    "code.leftScrollbar.component.image": "图片",
    "workFlow.WFDelegate.titleEditFlow": "编辑流程委托",
    "workFlow.Process.ownSystem": "所属系统",
    "workFlow.zh.sequenceMessageAss": "使用顺序/消息流或者关联连接",
    "interfaceAPI.versionNum": "当前版本",
    "Notice.placeholderContent": "请填写内容",
    "PCDevGuide.codeTemplate": "代码模板",
    "workFlow.zh.escalationStartUnblock": "升级开始事件（非中断）",
    unpublished: "未发布",
    APIConfigDataOptionNotSelected: "API配置数据选项未选择",
    "custmerForm.classifiedManagement.tableSequence": "排序",
    "workFlow.zh.candidateUsers": "候选用户",
    "code.rightPanel.placeholderValidationModel": "请输入校验模型",
    webFunctionIcon: "web端功能图标",
    "mobileDev.homeRightSide.moreLink": "详情链接",
    "workFlow.zh.intermediateBoundary": "创建中间/边界事件",
    "mobileDev.functionDesignForm.hintSelectData": "请选择数据表",
    "mobileDev.loginRightSide.labelGradientOne": "按钮背景渐变色1",
    "databaseManage.databaseField.tableCreationTime": "创建时间",
    "mobileDev.loginDesignForm.completeBtn": "完成",
    "mobileDev.tableSet.tabWidth": "列宽",
    "deletePrompt.submitFailure": "提交失败!",
    "mobileDev.homeRightSide.hight": "高度",
    "code.rightPanel.showNoSelected": "显示未选中组件边框",
    "editorModule.spellCheck": "拼写检查",
    "workFlow.Process.noteTwo":
        "2. “表单发起审批”功能会针对“系统表单”、“自定义表单”的列表页生成“发起审批”按钮。",
    "code.codeStepFour.page": "分页",
    "mobileDev.homeRightSide.clearBtn": "清除",
    invalidInputParamerterUsedCurrentProcess:
        "当前过程处理中有使用无效的入参参数，请先修改再下一步",
    "taskScheduling.taskDesign.addModal.labelTaskType": "任务类型",
    "dataItem.dialogInstall.labelCode": "分类编码",
    "workFlow.sequenceFlow.cirCondition": "流转条件",
    "companyManager.companyFormDialog.placeholderSelect": "请选择",
    "menuManagement.addModal.placeholderDescription": "请填写描述",
    "workFlow.zh.parallelMulti": "并行多重事件",
    "importAndExport.excelImport.fixedTitle": "功能目录",
    "databaseManage.databaseField.addModalTitle": "添加常用字段",
    eight: "八",
    "mobileDev.loginDesignForm.stepThree": "代码预览",
    "workFlow.Process.placeholderSelect": "请选择",
    pageType: "页面类型",
    formEvents: "表单事件",
    "orgRoleManagement.setAuthorizeModal.fieAuthority": "字段权限",
    "databaseManage.databaseTable.fixedTitle": "数据库目录",
    updateDataSource: "修改数据源",
    "orgRoleManagement.databaseAuth.radioViewCom": "仅查看本公司",
    mobileRenderLayer: "移动端渲染层",
    "orgUserManagement.addModal.placeholMobile": "请填写手机号",
    "code.codeForm.nextStepBtn": "下一步",
    "workFlow.zh.scriptType": "脚本类型",
    outputParameterCodeCanOnlyEnterLettersNumbersUnderscoresHorizontal:
        "输出参数编码只能输入字母、数字、下划线和横杠且数字不能开头",
    "PCDevGuide.userManagement": "用户管理",
    "editorModule.colorPicker": "选色器",
    "route.website": "官网",
    "mobileDev.listRightSide.ListField": "列表字段值",
    "code.rightPanel.fillPlaceholderPrompt": "请输入占位提示",
    "workFlow.WFDesign.tabName": "名称",
    "code.codeStepThree.tabName": "字段项名称",
    "BI.Build.vertiWay": "垂直方式",
    "workFlow.zh.escalationBoundary": "升级边界事件",
    "mobileDev.homeRightSide.completeBtn": "完成",
    "workFlow.Process.radioAllow": "允许发起",
    "BI.components.main.labelTitle": "标题",
    "menuManagement.addModal.optionLabelParentMenu": "父级菜单",
    "Notice.labelNotTyle": "公告类别",
    "importAndExport.excelExport.placeholderID": "请填写表格ID",
    "mobileDev.functionDesignStepFour.Hint":
        "从左侧拖入组件配置列表页查询条件",
    "code.codeStepFour.leftTitle": "列表左侧树形结构配置",
    "code.rightPanel.configCascadeData": "配置级联数据源",
    "code.rightPanel.placeholderOpenValue": "请输入开启值",
    "editorModule.cellProperties": "单元格属性",
    "reportModule.reportRelease.placeholderSelectSuper":
        "请选择上级",
    "code.rightPanel.addRule": "添加规则",
    "orgUserManagement.Hint.whetherEnable": "确定启用该账户？",
    "mobileDev.formRightSide.hintShowField": "请先选择显示字段",
    "mobileDev.homeRightSide.pie": "饼图",
    "codeRule.tableDescription": "说明",
    "workFlow.End.mailbox": "邮箱",
    "workFlow.Step4.hintSelectColumn": "必须选择一个列",
    "mobileDev.formRightSide.placeholderDefault": "请输入默认值",
    "workFlow.schemeFormIndex.tabOperate": "操作",
    "messageIndex.hintEmpty": "消息为空",
    "code.rightPanel.hintActiveNode": "请指定活动节点",
    "taskScheduling.taskDesign.addFrequencyModal.executionDay":
        "执行日",
    "orgRoleManagement.indexAuth.placeholderName": "输入首页名称",
    "code.leftScrollbar.component.hintEnter": "请输入",
    "code.rightPanel.card": "卡片化",
    "mobileDev.homeRightSide.graphicCard": "图文卡片",
    "BI.components.tabs.labelIconSpace": "图标间距",
    "mobileDev.homeRightSide.hintMin": "请至少设置一个标签",
    "dataItem.tableDescription": "备注",
    "editorModule.liraSign": "里拉符号",
    "wel.welIndex.juShangGe": "居上阁水务",
    "workFlow.User.tabCommentBox": "关联意见框",
    "language.languageType.defaultLanguageBtn": "设为默认语言",
    "editorModule.findReplace": "查找和替换",
    "wechatAndDingTalk.userManagement.tableStatus": "同步状态",
    "workFlow.zh.moreChangeEvent": "多个变量事件以逗号隔开",
    "dataItem.addModal.hintItemValue": "请填写项目值",
    "topTheme.nameDefault": "默认主题",
    cannotExceed100Characters: "不能超过100个字符",
    "formDesign.addFormTitle": "添加/修改表单",
    "databaseManage.databaseField.addModalWriteDateLength":
        "请填写数据长度",
    "orgUserManagement.addModal.modalTitle": "用户信息",
    "editorModule.crop": "裁剪",
    "editorModule.name": "名称",
    "workFlow.WFDesign.disagree": "拒绝",
    "workFlow.Approver.nodeApproverBtn": "指定节点审批人",
    "PCDevGuide.titleDevelopmentDuide": "开发向导",
    "tagsView.search": "搜索",
    "wechatAndDingTalk.userManagement.tableName": "名称",
    "formDesign.Hint.tableStructureNext":
        "未包含主表字段组件，有引起数据库报错的风险，请确认是否进行下一步？",
    "databaseManage.databaseTable.addSheet.promptKey":
        "主键需唯一!",
    "workFlow.zh.errorStart": "错误开始事件",
    "editorModule.view": "视图",
    startExecuteInterface: "开始执行接口",
    "editorModule.loadEmoticons": "加载表情符号...",
    "workFlow.WFMonitor.tabTask": "任务",
    parameterAssignmentAssDataVariableNodeFlowAccordCategory:
        "参数赋值：在节点流转后根据赋值类别、赋值配置将数据赋值给变量；执行顺序为添加顺序",
    "mobileDev.functionDesignForm.stepFour": "移动端查询",
    "workFlow.filedConfig.startUser": "发起者",
    showFormBorder: "显示表单边框",
    "mobileDev.formRightSide.placeholderSelectDefault":
        "请选择默认值",
    "mobileDev.formRightSide.placeholderSelectTime": "选择时间",
    "workFlow.Process.labelLimitedTemplate":
        "限发起人发起的此模板任务",
    "login.hintNotEmpty": "手机号码不能为空",
    "menuManagement.hintAddFailed": "新增失败",
    "menuManagement.addModal.labelOptions": "选项",
    "language.translation.placeholderRemarks": "请输入备注信息",
    "workFlow.roams.nodeName": "节点名称：",
    "login.wechat": "微信",
    "user.info.remark": "备注",
    "dataItem.tableItemValue": "项目值",
    "importAndExport.importForm.selectContent": "请选择内容",
    "orgDepartManagement.editTitle": "编辑信息",
    "code.rightPanel.height": "高度",
    "orgPostManagement.addModal.placeholderPostName":
        "请填写岗位名称",
    "editorModule.bold": "粗体",
    "workFlow.Step1.labelSupFun": "上级功能",
    "databaseManage.databaseTable.addSheet.draftSavedFailure":
        "草稿保存失败！",
    "workFlow.zh.inlineScript": "内联脚本",
    "BI.group.top.Reduce": "还原",
    "importAndExport.importForm.valueDataDic": "数据字典",
    loadingForm: "加载表单",
    parameterNameCannotEmpty: "参数名(Key)不能为空！",
    "editorModule.currencySign": "货币符号",
    "fileManagement.titleEdit": "在线编辑",
    "editorModule.selectAll": "全选",
    "PCDevGuide.databaseConfiguration": "数据库配置",
    "deletePrompt.disableFailure": "禁用失败!",
    pleaseSelectComp: "请选择组件",
    ongoing: "正在进行",
    "Create end-event": "结束",
    paymentMgt: "付款管理",
    veryBad: "极差",
    "BI.group.contentMenu.hintWhetherDelete": "是否删除所选图层?",
    "taskScheduling.taskDesign.addFrequencyModal.May": "五月",
    "orgUserManagement.tabEnableDisable": "启用/禁用",
    "code.codeStepSix.placeholderFunctionDesc": "请填写功能描述",
    "editorModule.tableContents": "内容列表",
    "workFlow.selectAuthority.roleBtn": "角色",
    "code.codeIndex.stepNameTwo": "表单页面",
    "workFlow.privateStampInfo.hintStopFailed": "停用失败！",
    "workFlow.zh.exclude": "排除",
    "mobileDev.loginRightSide.labelTextSpace": "按钮距文本间距",
    applicationPlatform: "应用平台",
    "workFlow.WFCard.cardClassify": "分类",
    "forme.editModal.editBtn": "编辑",
    "user.setting.hintNoData": "暂无相关数据.",
    "BI.echart.iframe": "Iframe",
    tableNotEquippedDataSourceDataCannotSelected:
        "该表格没有配数据源，无法选择数据！",
    "Schedule.placeholderStartTime": "请选择开始时间",
    "editorModule.deleteRow": "删除行",
    processing: "过程处理",
    validateInterfaceParameter: "验证接口参数",
    "code.rightPanel.tabLocation": "选项卡位置",
    "mobileDev.homeRightSide.textCarouselImg": "文字轮播图",
    "orgRoleManagement.addModal.placeholderRemark": "请填写备注",
    "mobileDev.formRightSide.labelEditSubform": "编辑子表单选项",
    "mobileDev.homeRightSide.placeholderSeConfType":
        "请选择配置方式",
    "mobileDev.homeRightSide.placeholderSQL": "请输入SQL语句",
    "workFlow.createFLow.titleAssocTasks": "关联前置任务",
    "formDesign.Hint.tableStructureComplete":
        "未包含主表字段组件，有引起数据库报错的风险，请确认是否进行完成操作？",
    "language.languageType.tabDefaultLanguage": "默认语言",
    "workFlow.privateStampInfo.enableBtn": "启动",
    "databaseManage.databaseField.addModalWriteName": "请填写列名",
    "editorModule.tableProperties": "表格属性",
    "menuManagement.addModal.placeholderSort": "请填写排序",
    "BI.echart.flop": "翻牌器",
    "code.codeStepFour.Centered": "居中",
    "code.codeStepFour.sqlStatement": "sql语句",
    "mobileDev.loginRightSide.placeholderInputHigh":
        "请输入输入框高度",
    "editorModule.headersFour": "标题4",
    "workFlow.processTasks.title": "标题",
    "taskScheduling.taskDesign.addExpressionModal.expressionNine":
        "每周一，二，三，四，五的10:15分运行",
    listInfor: "列表信息",
    "code.codeStepFour.treeTitle": "树型标题",
    "workFlow.userButtonSetting.hintEditSuccess": "编辑成功！",
    selectParameterSourceFirst: "请先选择参数来源",
    "editorModule.frenchFrancSign": "法郎符号",
    "orgRoleManagement.Hint.addRole": "添加角色",
    "language.languageCategory.ug-CN": "维吾尔语",
    "workFlow.createFLow.hintDataError": "数据出错",
    "editorModule.needAddMilto":
        "你所填写的URL地址为邮件地址，需要加上mailto:前缀吗？",
    "taskScheduling.taskDesign.addExpressionModal.expressionSeven":
        "每天14:00点到14:05，每分钟运行一次",
    "orgPostManagement.addModal.modalTitle": "添加信息",
    "BI.configBI.colorOne": "颜色1",
    "mobileDev.formRightSide.placeholderSelectType": "请选择类型",
    "mobileDev.homeDesignStepTwo.newsBtn": "消息",
    addFormAssSuccee: "添加表单赋值成功",
    "taskScheduling.taskDesign.tablePaused": "暂停中",
    pleaseSelectADelegate: "请选择被委托人",
    "databaseManage.databaseTable.importLists.promptSelectData":
        "请选择导入的数据!",
    "mobileDev.functionDesignStepTwo.hintSelectForm":
        "请先选择关联表",
    "workFlow.userButtonSetting.tablePValue": "参数值",
    "deletePrompt.operationHint": "请选择一行再操作!",
    calculation: "计算方式",
    "workFlow.WFMonitor.tabTime": "时间",
    languageTypeMaintenanceAndModificationSuccessfully:
        "语言类型维护修改成功！",
    "menuManagement.tableMenu": "菜单",
    "editorModule.comments": "备注",
    "dataItem.addModal.labelValue": "项目值",
    "messageIndex.labelNotice": "通知公告",
    versionName: "版本名称",
    "deletePrompt.dataAcquisitionFailed": "获取数据失败!",
    "orgRoleManagement.databaseAuth.radioViewSelf": "仅查看本人",
    "workFlow.Process.functionIcon": "功能图标",
    "dataItem.tableNumber": "#",
    "code.codeStepOne.tabDescription": "说明",
    "workFlow.createFLow.hintSaveSuccess": "保存草稿成功",
    "menuManagement.addModal.optionLabelFunctionMenu": "功能菜单",
    "workFlow.processTasks.timeRange": "时间范围",
    five: "五",
    "editorModule.openHelpDialog": "打开帮助对话框",
    "user.info.emailEmpty": "邮箱不能为空",
    "databaseManage.databaseField.addModalWriteDescribe":
        "请填写描述",
    "menuManagement.tableNumber": "#",
    "code.leftScrollbar.component.optionTwo": "选项二",
    "code.leftScrollbar.component.currency": "货币组件",
    enterNumber: "请输入数字",
    "menuManagement.tableEffective": "有效",
    "topTheme.hintSwitchTheme": "切换主题中...",
    "taskScheduling.taskDesign.addModal.taskRestartFour":
        "请填写次数",
    "fileManagement.dialogTitle.moveFileTitle": "移动文件",
    compTrigEvent: "组件触发事件",
    fillMobileFunctionOrder: "请填写移动端功能排序",
    "reportModule.reportRelease.placeholderTransTag":
        "请选择翻译标记",
    "mobileDev.functionDesignStepTwo.tabParentName": "主表",
    "custmerForm.classifiedManagement.Hint.formCategoryCode":
        "请填写表单分类编码",
    "workFlow.zh.details": "详情",
    "mobileDev.homeRightSide.hintMax": "最大标签数不能超过6个",
    hintSetDefaultHomepagecontent:
        "默认首页有且仅有一个，并且默认首页不参与“角色管理”中的“首页授权”，默认所有用户第一次登录系统均显示系统默认首页，用户自定义选择其他首页后，以自定义选择为准。",
    "BI.echart.defualt": "通用型",
    "BI.listIndex.addSuccess": "新增成功",
    "PCDevGuide.reportDelease": "报表发布",
    "BI.configBI.postion": "位置",
    "workFlow.searchConfig.tabBoundField": "绑定字段",
    "code.codeForm.saveTemplateModal.labelDescription": "模板描述",
    "workFlow.WFDesign.titleEditFlow": "编辑流程设计",
    "fileManagement.Hint.completeDeleteFailed": "彻底删除失败！",
    suspendProcess: "将此流程进行挂起",
    "mobileDev.mobileSchema.tabType": "类型",
    "custmerForm.classifiedManagement.tableEffective": "有效",
    addDataSource: "添加数据源",
    approvalComments: "审批意见为：",
    "forme.addModal.superiorFunction": "上级功能",
    "Log.tableTime": "操作时间",
    stockManage: "入库管理",
    "editorModule.rowProperties": "行属性",
    "orgUserManagement.Hint.whetherResetPassword":
        "确定重置密码？重置后，密码为000000",
    "menuManagement.fixedTitle": "功能目录",
    "workFlow.privateStampInfo.tabImg": "图片",
    "importAndExport.importForm.labelDataOption": "数据选项",
    "mobileDev.homeRightSide.circular": "环形图",
    "BI.components.map.labelAHighlightC": "区域高亮颜色",
    "workFlow.WFDesign.titleImportCommon": "BPMN导入",
    "workFlow.zh.asynchronousContinu": "持续异步",
    "code.codeStepSix.titleInfoConfig": "功能信息配置",
    "language.menuFunction.titleEditDataTra": "编辑数据字典翻译",
    "BI.components.main.labelAxisReverse": "轴反转",
    "orgRoleManagement.databaseAuth.radioViewDate": "查看所有数据",
    curPersonId: "当前人员ID",
    "interfaceManage.addModal.tableFieldPostil": "字段注释",
    "workFlow.createFLow.hintSaveDraft": "保存草稿",
    selectDataTypeThenConfigOutputEncoding:
        "请先选择数据类别后再进行输出编码配置",
    "code.rightPanel.preloadedData": "预加载数据源",
    "workFlow.privateStampInfo.titleInfor": "信息",
    "mobileDev.formRightSide.optionMustNum": "必须为数字！",
    "editorModule.metadataDocument": "元数据和文档属性",
    "workFlow.WFChange.testBtn": "测试",
    yValue: "Y轴值",
    "wechatAndDingTalk.userManagement.Hint.syncSure":
        "确定要同步吗？",
    "tableNameMustStartWith LetterIncludeNumbersUnderscores":
        "表名必需以字母开头,只能包括字母、数字、下划线",
    "editorModule.column": "列",
    "workFlow.zh.waitCompletion": "等待完成",
    "orgDepartManagement.departmentFormDialog.labelOuterPhone":
        "电话号",
    "code.codeStepFive.tabColName": "列名",
    "sub-processNodeYouCannotUsePreviousNodeSpecifyApprover":
        "存在子流程节点，不能使用上一节点指定审批人",
    "importAndExport.importForm.titleImportConfigArea":
        "导入配置区域",
    "code.codeStepTwoListStructure.datetime": "时间日期",
    dataColumn: "数据列",
    notDesigned: "未设计",
    pleaseSelectCompletionCriteria: "请选择完成条件",
    "mobileDev.functionDesignStepSix.labelFunctionDesc": "功能描述",
    "mobileDev.functionDesignForm.hintTemClassif": "请选择模板分类",
    "mobileDev.functionDesignStepTwo.tabDescription": "说明",
    "code.rightPanel.showAll": "显示全部结果",
    pleaseFillInTheComponentName: "请填写组件名称",
    "taskScheduling.taskDesign.tableNumber": "#",
    "taskScheduling.taskLog.tableName": "任务名称",
    "mobileDev.loginRightSide.labelWordColor": "按钮名称字颜色",
    "News.labelWriter": "作者",
    "mobileDev.homeRightSide.labelHighlightTextC": "高亮文字颜色",
    "workFlow.zh.field": "字段",
    "workFlow.searchConfig.tabQSort": "查询类别",
    "forme.addModal.formSelection": "表单选择",
    indexTitle: "首页标题表头",
    "Schedule.labelStartTime": "开始时间",
    "deletePrompt.processDesignFailed": "流程设计失败！",
    "editorModule.permanentPenTwo": "永久笔属性...",
    characterType: "字符类型",
    "editorModule.foodDrink": "食物和饮品",
    "code.leftScrollbar.layoutModule": "布局型组件",
    "BI.listMap.mapName": "地图名称",
    "orgDepartManagement.roleConfiguration.approvalRoleCom":
        "维护审批角色（公司）信息",
    "code.rightPanel.whetherDisable": "是否禁用",
    "workFlow.Approver.titleNode": "节点",
    pleaseTickTheDataToExport: "请勾选要导出的数据",
    stateDetails: "状态详情",
    "mobileDev.listRightSide.Example": "示例：",
    useEnglishNumbersUnderscore: "请使用英文、数字或下划线命名",
    "importAndExport.excelExport.labelID": "表格ID",
    "BI.components.swiper.labelSelectors": "选择器",
    "orgDepartManagement.addModal.roleOfInformation.Counterpart":
        "对应人员",
    headerName: "表头名称",
    "companyManager.companyFormDialog.placeholderManager":
        "请填写负责人",
    "editorModule.insertEditMedia": "插入/编辑媒体",
    "BI.components.main.labelReverse": "反转",
    "companyManager.companyFormDialog.placeholderEmail":
        "请填写邮箱号",
    "code.rightPanel.placeholderCompanyName": "请输入公司名称",
    "editorModule.defa": "默认",
    "workFlow.WFDesign.previewBtn": "预览流程",
    "BI.components.progress.labelBorderSize": "边框大小",
    "mobileDev.functionDesignStepSeven.fixedApi": "Api层",
    "BI.components.flop.labelBColor": "边框颜色",
    "editorModule.pasteRowBefore": "粘贴到上方",
    "editorModule.midnightBlue": "深蓝色",
    "Notice.placeholderNotTitle": "请填写公告标题",
    "importAndExport.importForm.labelSaveField": "保存字段",
    "BI.components.main.labelPostion": "位置",
    "editorModule.insertCodeSample": "插入/编辑代码示例",
    "workFlow.printCurrentPage.borderColor": "边框颜色",
    "to-do": "待办",
    "code.leftScrollbar.hintSaveTab": "至少请保留一个选项卡。",
    "BI.echart.target": "指标",
    processTaskName: "流程任务名称",
    "companyManager.tabNum": "#",
    "custmerForm.tableCreateTime": "创建时间",
    "BI.listIndex.editSuccess": "修改成功",
    "codeSchema.fixedTitle": "模板分类",
    "BI.components.text.labelContent": "文本内容",
    published: "已发布",
    "mobileDev.homeRightSide.five": "五",
    "user.aboutDialog.versionNum": "当前版本",
    superAdministratorNotAllowAuthorization: "超级管理员不允许授权",
    "workFlow.WFDesign.tabRemarks": "备注",
    "code.rightPanel.startColor": "开启颜色",
    "code.rightPanel.compHight": "组件高度",
    "forme.editModal.quickExportBtn": "快速导出",
    sureSetDesktopDefaultHome: "确认将此桌面模板设为系统默认首页？",
    publisher: "发布人",
    "topTheme.nameEveningTheme": "暗色主题",
    "editorModule.block": "块",
    "mobileDev.formRightSide.singleBox": "单选框",
    "codeRule.tableSerialNumber": "当前流水号",
    "wel.welIndex.yaYun": "雅韵水务",
    "workFlow.Process.hintRule": "==请填写流程任务命名规则配置==",
    "mobileDev.loginDesignStepTwo.Title": "属性设置",
    "workFlow.userButtonSetting.tableApiAddress": "API地址",
    "taskScheduling.taskDesign.addModal.radioStartTimeTwo":
        "设置开始时间",
    "workFlow.Process.noteFour":
        "4. 流程进入审批状态后，隐藏“发起审批”按钮，并使用流程状态覆盖进行显示，状态包括“审批中”、“审批完成”。",
    "mobileDev.functionDesignForm.labelTemClassif": "模板分类",
    "BI.Build.Event": "事件",
    "workFlow.zh.subflowCollapsed": "子流程（折叠的）",
    "workFlow.zh.activityRef": "活动参考",
    "editorModule.splitCell": "拆分单元格",
    "workFlow.selectSql.hintCanNotNotPass":
        "如果您的SQL语句里添加了字段侧无法通过查询测试SQL语句返回结果列表，因为当在设计界面状态下表单没有任何值。",
    "mobileDev.formRightSide.dateBox": "日期框",
    "workFlow.WFDesign.titleHistoryRecord": "历史记录-",
    "editorModule.increaseIndent": "增加缩进",
    "workFlow.zh.messageCatch": "消息中间捕获事件",
    selectBindField: "请选择绑定字段",
    "workFlow.zh.variableName": "变量名称",
    "editorModule.addDictionary": "添加到字典",
    "orgRoleManagement.databaseAuth.radioViewDep": "仅查看本部门",
    "workFlow.schemeFormIndex.tabView": "查看",
    "companyManager.tabBusinessScope": "经营范围",
    "language.translation.hintSelectData": "请选中一条数据！",
    "Notice.placeholderInforSou": "请填写信息来源",
    "crud.refreshBtn": "刷新",
    "BI.components.wordCloud.labelMinFont": "最小字体",
    processFailed: "获取流程失败",
    "Create script-task-event": "脚本任务",
    "navbar.color": "换色",
    "workFlow.processTasks.hintReturnStart":
        "确定要撤回至开始节点吗？",
    "editorModule.headerCell": "表头单元格",
    "form.submit": "提交",
    curPersonCoId: "当前人员公司ID",
    "code.rightPanel.selectSheet": "请选择表",
    "BI.listIndex.Modal.fillFunName": "请输入功能名称",
    "code.leftScrollbar.component.opinionComonent": "意见簿",
    "editorModule.removeColor": "移除颜色",
    "code.rightPanel.labelAlignment": "标签对齐",
    "workFlow.User.tabBtnSet": "按钮设置",
    "wel.welIndex.qingyun": "青云水务",
    determineWhetherDeleteInterface: "是否确定删除该接口",
    "editorModule.yuanCharacter": "人民币元字样",
    "orgRoleManagement.tabCreateTime": "创建时间",
    "workFlow.Process.optionPreviousNode":
        "由上一节点审批人指定审批人",
    "selectUser.selectedList": "已选列表",
    "editorModule.zeroWords": "{0} 字",
    "workFlow.Process.appendPusher": "追加消息推送人",
    "companyManager.companyFormDialog.labelComNature": "公司性质",
    "deletePrompt.updateSuccessful": "更新成功!",
    "workFlow.addStamp.placeholderSClassify": "请选择印章分类",
    processDesignModificationSuccessful: "流程设计修改成功！",
    "orgRoleManagement.databaseAuth.selectSysFun": "请选择系统功能",
    "forme.addModal.tableHeaderColumnName": "列名",
    "BI.Build.dataProcess": "数据处理",
    "code.codeStepTwoListStructure.hintCloseBtn": "关闭按钮等待",
    "workFlow.zh.addLaneBelow": "在下面添加道",
    "code.rightPanel.propertySet": "属性设置",
    "code.leftScrollbar.seeBtn": "查看json",
    "code.codeIndex.stepNameFour": "列表配置",
    "code.leftScrollbar.component.placeholderSelect": "请选择",
    outParmConfig: "出参配置",
    "workFlow.privateStampInfo.fixedTitle": "印章分类",
    "code.codeForm.completeBtn": "完成",
    "workFlow.addStamp.labelPassword": "密码",
    "orgUserManagement.addModal.placeholderEnterPassword":
        "请输入密码",
    "workFlow.menuForm.titleFieldDeploy": "表单字段配置",
    "code.leftScrollbar.hintNoSelect": "父表单还未选择绑定表!",
    "workFlow.addStamp.labelHandwrit": "手写签名",
    "companyManager.tabCompanyCode": "公司编码",
    addedInterfaceSuccessfully: "新增接口成功",
    "workFlow.historyList.tabFounder": "创建人",
    "BI.listIndex.Unpublished": "未发布",
    "BI.listIndex.Modal.SuperFunction": "上级功能",
    "code.rightPanel.dataShowFormat": "数据显示格式",
    "workFlow.formInitiationProcessDialog.typeCusForm":
        "自定义表单",
    "code.codeStepFour.placeholderBtnName": "请填写按钮名称",
    "BI.Build.scrHigh": "大屏高度",
    "reportModule.reportRelease.labelTransTag": "翻译标记",
    "workFlow.zh.messageStart": "消息开始事件",
    "language.dataDictionary.tagNameCodeSearch":
        "输入翻译标记名称或编码进行查询",
    "code.leftScrollbar.exportJsonBtn": "导出JSON文件",
    "BI.components.map.placeholderMapSelect": "请选择地图",
    "workFlow.Step1.placeholderSupFun": "请选择上级功能",
    selectInterfaceVariableOutputParamter:
        "请选择一个接口变量作为输出参数",
    productCode: "商品编码",
    "workFlow.WFMonitor.hintSelectRow":
        "请先选择一行，再进行操作。",
    "mobileDev.mobileSchema.tabSort": "分类",
    "mobileDev.homeRightSide.hintMaxSlidePlug":
        "滑动插件最大显示数量建议设置8条以下，否则显示错乱!",
    "PCDevGuide.formDesign": "表单设计",
    selectOperteType: "请选择操作类型",
    "editorModule.specialCharacter": "特殊符号",
    fillInHeight: "请填写高度",
    "subSystemForm.placeholderSort": "请输入排序",
    nine: "九",
    "importAndExport.importForm.valueOperatorTime": "操作时间",
    "code.codeStepTwoListStructure.hintNetworkRequest":
        "模拟网络请求",
    "workFlow.zh.messageBoundary": "消息边界事件",
    "BI.components.progress.labelPreFontSiz": "前缀字体大小",
    "workFlow.userButtonSetting.optionOnlyAllowed":
        "只允许驳回至上一节点",
    "BI.components.flop.labelYSpace": "Y间距",
    "editorModule.hintNoForm": "错误: 没有表单控件。",
    "workFlow.selectSql.sqlStatement": "SQL语句",
    "importAndExport.importConfiguration.labelOperCompany":
        "操作人公司",
    "importAndExport.excelExport.placeholderBtn": "请选择",
    "wechatAndDingTalk.userManagement.tableNumber": "#",
    "wel.welIndex.xTime": "时间",
    curApprNode: "当前审批节点",
    "mobileDev.appDevIndex.functionSort": "模板功能",
    "interfaceManage.addModal.labelAddress": "接口地址",
    sureWamtEnableInterface: "确定要启用该接口吗?",
    "mobileDev.loginRightSide.labelWordSpace": "按钮名称字间距",
    "BI.Build.inteAddress": "接口地址",
    add: "添加",
    "workFlow.zh.sendTask": "发送任务",
    "code.codeStepTwoListStructure.hintFormat":
        "* 表名、字段名不能以数字，特殊字符串开头，不能有汉字。",
    "BI.components.map.labelTime": "轮播时间",
    "Log.tableIPAddress": "IP地址",
    billDate: "单据日期",
    restorePrompt: "恢复提示",
    roleNumber: "角色人数",
    "orgUserManagement.addModal.labelOICQ": "QQ",
    "user.info.oldPassword": "原密码",
    "BI.group.customBind.hintDataSQL":
        "请先选择数据源且添加正确SQL语句",
    "workFlow.Step1.labelSystemId": "所属系统",
    "route.permission": "权限",
    noDataFieldSelect: "没有选择数据字段",
    "BI.listMap.hintForeveDel": "此操作将永久删除, 是否继续?",
    "workFlow.Process.functionName": "功能名称",
    switchCurrentVersionSuccessful: "切换当前版本成功",
    "areaManager.tableAreaCode": "编号",
    "workFlow.zh.verify": "校验",
    "BI.components.flop.labelBorderWidth": "边框宽度",
    "databaseManage.databaseTable.importLists.copyTableHeaderTitleRecords":
        "记录数",
    "code.rightPanel.horiArrange": "水平排列",
    personnelSelection: "人员选择",
    "mobileDev.homeRightSide.Subtitle": "副标题",
    "language.languageType.languageTypeSelect": "语言类型",
    "importAndExport.importConfiguration.labelSelectID":
        "选择人员ID",
    "BI.listIndex.Modal.functionNum": "功能编号",
    "taskScheduling.taskLog.hintSDeleteData":
        "请先选择要删除的数据项",
    "workFlow.filedConfig.timeQuery": "时间查询",
    selectInterfaceSort: "请选择接口分类",
    "menuManagement.addModal.labelSystem": "所属系统",
    "workFlow.addStamp.loadingSignature": "加载签章中",
    "editorModule.gamma": "伽马值",
    "orgUserManagement.tabSex": "性别",
    "code.rightPanel.selectHoriArrange": "请选择水平排列",
    shortText: "短文本",
    "code.rightPanel.titleDataConfig": "级联动选择-数据源配置",
    "wechatAndDingTalk.departmentManagement.tableName": "部门名称",
    "BI.group.codeEditTitle": "代码编辑",
    "workFlow.zh.number": "编号",
    interfaceClassName: "接口分类名称",
    "code.leftScrollbar.component.department": "部门",
    "BI.components.tabs.labelIconSize": "图标大小",
    "mobileDev.searchRightSide.labelBoundField": "绑定字段",
    "BI.components.main.labelShow": "显示",
    "custmerForm.titleFormCodeConfig": "表单生成代码配置",
    "mobileDev.homeRightSide.carolTextField": "轮播文字字段",
    "taskScheduling.taskDesign.addExpressionModal.expressionTour":
        "每天14点到15点之间每分钟运行一次，开始于14:00，结束于14:59",
    "orgRoleManagement.tabRoleNumber": "角色编号",
    "mobileDev.listRightSide.setListField": "列表字段值设置",
    "crud.cancelBtn": "取消",
    "workFlow.User.radioAssociate": "关联表单组件",
    "Notice.labelAddress": "来源地址",
    noApiAddrEnter: "没有填写API地址",
    "databaseManage.databaseTable.importLists.copyTableHeaderTitleSize":
        "使用大小",
    "editorModule.insertTable": "插入表格",
    "mobileDev.mobileSchema.deleteBtn": "删除",
    "orgPostManagement.addModal.labelPostName": "岗位名称",
    webFunctionOrder: "web端功能排序",
    "orgUserManagement.Hint.resetPassword": "重置密码",
    "mobileDev.homeRightSide.coclor": "颜色",
    "workFlow.privateStampInfo.hintStartSuccess": "启动成功！",
    fillInterfaceConfig: "请填写接口配置",
    "editorModule.insertTemplateMore": "插入模板...",
    "editorModule.systemFont": "系统字体",
    "workFlow.Process.noteOne":
        "1. 一个表单仅允许关联一个流程模板，一个流程模板也仅允许关联一个表单。",
    "mobileDev.formCenterContainer.hintSetField":
        "请先设置子表单字段",
    "orgDepartManagement.departmentFormDialog.placeholderSelect":
        "请选择",
    "databaseManage.databaseTable.addSheet.tableLength": "长度",
    "fileManagement.titlePreview": "预览",
    formEventLog: "表单日志",
    "workFlow.zh.messageStartUnblock": "消息开始事件（非中断）",
    "editorModule.template": "模板",
    "workFlow.WFMonitor.hintSuspendPrompt": "挂起提示",
    "fileManagement.dialogTitle.newFolderTitle": "新建文件夹",
    "orgDepartManagement.Hint.modifyRole": "修改角色信息",
    hintFlowInvalid: "流程配置不合法，请确认后再发起流程",
    procedureProcessTableDataCannotEmpty:
        "过程处理表格所有数据不能为空！",
    "databaseManage.dataLink.titleAddDatabase": "添加数据库",
    "workFlow.zh.escalationThrow": "升级中间抛出事件",
    "workFlow.Process.optionAdmin": "由超级管理员处理",
    "BI.components.flop.labelBgImg": "背景图片",
    "workFlow.Start.tabSet": "表单设置",
    "orgRoleManagement.databaseAuth.hintLoading": "数据加载中...",
    "orgDepartManagement.departmentFormDialog.placeholderFax":
        "请填写传真",
    fillComponent: "填充组件",
    "workFlow.Step1.hintSelect": "请选择",
    "fileManagement.labelFileName": "文件名",
    "workFlow.processTasks.hintNoDelete": "没有删除操作",
    cannotExceed50Characters: "不能超过50个字符",
    "editorModule.insertTemplate": "插入模板",
    "editorModule.error": "错误",
    "editorModule.mediumBlue": "中蓝色",
    formCategory: "表单类别",
    "workFlow.WFDesign.importFlowBtn": "导入流程",
    "editorModule.drachmaSign": "德拉克马符号",
    "code.rightPanel.atLeast": "至少应选",
    "mobileDev.formRightSide.placeholderSelect": "请选择",
    "menuManagement.addModal.checkboxOpen": "展开",
    "workFlow.addStamp.labelRemark": "备注",
    fillInVariableCode: "请填写变量编码",
    "workFlow.WFDelegate.addOrSubtract": "加签或减签",
    "taskScheduling.taskDesign.addFrequencyModal.unitDay": "天",
    "mobileDev.loginRightSide.labelBgImg": "背景图片",
    "menuManagement.addModal.labelTarget": "目标",
    "interfaceManage.addModal.hintFieldName": "请输入字段名称",
    "BI.components.map.labelAreaLine": "区域线",
    "editorModule.print": "打印",
    "workFlow.processTasks.myForwarder": "我的传阅",
    "crud.menu": "操作",
    "editorModule.hAlign": "水平对齐",
    "editorModule.borderColor": "边框颜色",
    "code.rightPanel.placeholderOpenPrompt": "请输入开启提示",
    "BI.echart.link": "超链接",
    "workFlow.processTasks.titleAudit": "审核",
    "menuManagement.addModal.stepOne": "基础信息",
    "workFlow.selectNodes.designatedNode": "指定节点审批人上级领导",
    "BI.echart.line": "折线图",
    "mobileDev.formRightSide.SetSubformBtn": "设置子表单字段",
    failedToModifyMobileMenu: "修改移动端菜单失败！",
    "mobileDev.homeDesTitle": "首页设计",
    "orgDepartManagement.Hint.deleteDepart": "删除部门",
    "importAndExport.excelImport.tableName": "模板名称",
    parameterNameCanOnlyLettersUnderscoresDashes:
        "参数名只能输入字母、下划线和横杠",
    "selectPost.titleCompany": "公司",
    "code.rightPanel.top": "顶部",
    "editorModule.lightPurple": "浅紫色",
    "workFlow.zh.parGatEvent": "并行网关",
    "workFlow.processTasks.serialNum": "流水号",
    dataSheetProcessing: "数据表处理",
    "mobileDev.listRightSide.labelColor": "标签色",
    "workFlow.zh.receiveTask": "接收任务",
    "BI.components.main.labelName": "名称",
    "code.codeStepTwoListStructure.fieldName": "字段名",
    "code.rightPanel.frontIcon": "前图标",
    "taskScheduling.taskDesign.addFrequencyModal.placeholderSelect":
        "请选择",
    "editorModule.columnGroup": "列组",
    "importAndExport.importForm.valueOperatorID": "操作人ID",
    "workFlow.roams.createProcess": "创建流程",
    outboundDate: "出库日期",
    APKUpload: "APK上传",
    "workFlow.zh.variable": "变量",
    "workFlow.End.appPush": "App推送",
    "BI.components.img.labelImgAddress": "图片地址",
    "code.rightPanel.openValue": "开启值",
    "workFlow.WFDesign.titleFlowManage": "流程分类管理",
    cannotExceed5Characters: "不能超过5个字符",
    "workFlow.createFLow.submitBtn": "提 交",
    "BI.listIndex.Modal.passWorld": "密码",
    "subSystemForm.labelCode": "编码",
    "messageIndex.hintNoMore": "没有更多消息需要设置已读了",
    "code.rightPanel.layoutTree": "布局结构树",
    "mobileDev.homeRightSide.wfBacklog": "工作流待办",
    "workFlow.zh.signalEnd": "信号结束事件",
    "Schedule.placeholderEndTime": "请选择结束时间",
    "menuManagement.addModal.labelName": "名称",
    "code.leftScrollbar.component.upload": "上传",
    "workFlow.roams.scriptNode": "脚本节点",
    "workFlow.userButtonSetting.addBtn": "新建按钮",
    "code.codeStepTwoListStructure.explain":
        "为主表，字段名双击进行名称修改，数据格式默认为 varchar",
    "companyManager.orgList.textDisabled": "禁选",
    unit: "单位",
    "workFlow.zh.versionTag": "版本标签",
    "orgDepartManagement.departmentFormDialog.placeholderParentDep":
        "请选择上级部门",
    "databaseManage.databaseField.tableNumber": "#",
    "editorModule.pasteEmbedCodeBelow": "将内嵌代码粘贴在下面:",
    apiOutputParameterSelect: "API输出参数选择",
    "databaseManage.dataLink.libraryType": "库类型",
    pleaseWaitPatiently: "请耐心等待...",
    "BI.components.main.labelFontColor": "字体颜色",
    "code.codeStepSix.sqlFile": "是否生成Sql文件",
    "mobileDev.functionDesignStepEight.functionName": "功能名称",
    "dataItem.tableEffective": "有效",
    "BI.listCategory.hintMName": "请输入模块名",
    "importAndExport.excelImport.tableNumber": "#",
    "workFlow.Process.designatedApprover":
        "是否由上一用户节点审批人指定下一用户节点审批人（会签流程不可用）",
    "BI.components.datetime.labelTime": "时间格式",
    "workFlow.zh.script": "脚本",
    "workFlow.Process.whetherEnable": "是否启用",
    "workFlow.User.radioShowResult": "显示最终结果",
    and: "与",
    "editorModule.guaraniSign": "瓜拉尼符号",
    "editorModule.richTextArea": "编辑区。按Alt+0键打开帮助。",
    "menuManagement.addModal.labelDescription": "描述",
    packageName: "package名",
    "companyManager.fixedTitle": "公司信息",
    "reportModule.reportRelease.labelSystemId": "所属系统",
    "route.top": "返回顶部",
    "workFlow.Bpmn.textNew": "新建",
    "workFlow.Process.labelAllTemplate": "所有此模板发起的任务",
    "BI.group.top.hintSaving": "正在保存配置，请稍后",
    "wel.welIndex.yEnergyCons": "能耗kw.h",
    processInitiationTime: "流程发起时间",
    "code.rightPanel.hintRegular":
        "正则表达式不合法，提醒：是否表达式前后带上了/",
    "workFlow.zh.escalationBoundaryUnblock":
        "升级边界事件（非中断）",
    "taskScheduling.taskDesign.addModal.radioTaskTypeTwo":
        "存储过程",
    application: "申请用途",
    "workFlow.importFlow.hintUpload": "上传中",
    "importAndExport.excelExport.placeholderName": "请填写导出名称",
    "companyManager.companyFormDialog.placeholderInnerPhone":
        "请填写分机号",
    "databaseManage.dataLink.writeDatabasePassword":
        "请填写数据库密码",
    systemFormMiss: "哦噢，你的系统表单不见了",
    receiptNum: "单据编号",
    "workFlow.messagePusherPeople.departRole": "部门角色",
    mobileOwnClassify: "移动端所属分类",
    "taskScheduling.taskDesign.addExpressionModal.modalTitle":
        "添加预置表达式",
    "BI.components.text.labelScrollSpeed": "滚动速度",
    "mobileDev.formCenterContainer.deleteLine": "删除行",
    "workFlow.zh.messageBoundaryUnblock": "消息边界事件（非中断）",
    returnJsonFormatExample: "返回的Json格式示例",
    "mobileDev.homeRightSide.placeholderSubtitle": "请输入副标题",
    "workFlow.WFMenu.None": "无（非单模板）",
    "mobileDev.homeRightSide.labelKeyField":
        "主键字段(详情页链外网请不要配置)",
    menuTip: "没有发现菜单",
    onlyImageUpload: "只能上传图片格式!",
    "navbar.lock": "锁屏",
    "BI.listIndex.loadingDes": "拼命加载中...",
    "workFlow.userButtonSetting.tableRequestWay": "请求方式",
    "workFlow.sequenceFlow.Operator": "运算符",
    "workFlow.zh.conditionalStartUnblock": "条件开始事件（非中断）",
    addLevel: "添加级",
    "orgRoleManagement.databaseAuth.areaTitle": "数据配置",
    initiatorConfiguration: "发起人配置：",
    "editorModule.count": "计数",
    customerName: "客户名称",
    "mobileDev.loginRightSide.placeholderFooter": "请输入页脚内容",
    "wel.welIndex.titleUnderTime": "未达标时间",
    "mobileDev.homeRightSide.hintSQL": "请填写SQL语句",
    "editorModule.pasteTypeLink": "粘贴或输入链接",
    selectParameterDataCategory: "请选择参数数据类别",
    "editorModule.all": "全部",
    "reportModule.reportRelease.placeholderSort": "请填写排序",
    "components - ComponentNameCannotBeEmpty":
        "个组件-组件名称不能为空",
    "databaseManage.databaseTable.addSheet.titleTableName": "表名",
    "custmerForm.classifiedManagement.addModal.placeholderCode":
        "请填写编码",
    "user.info.passWorldSuccess": "密码修改成功",
    executeApi: "执行API",
    firstScreen: "首屏",
    fillDescription: "请填写描述",
    "workFlow.End.noticeStrategy": "通知策略",
    "deletePrompt.enableSuccessful": "启用成功!",
    "editorModule.emoticons": "表情符号...",
    "BI.listIndex.Modal.fillFunNum": "请输入功能编号",
    "editorModule.deleteColumn": "删除列",
    "wechatAndDingTalk.departmentManagement.tablePrincipal":
        "负责人",
    "editorModule.nonbreakSpace": "不间断空格",
    "importAndExport.importConfiguration.labelSelectDepart":
        "选择部门",
    "language.translation.labelTagName": "翻译标记名称",
    "workFlow.roams.signApproval": "当前节点审批类型：会签审批",
    "code.codeStepFour.verifyStatement": "验证语句",
    "code.codeIndex.stepNameSeven": "代码预览",
    "Parallel Gateway": "并行网关",
    "workFlow.privateStampInfo.labelAllStatus": "所有状态",
    "BI.components.line.labelAreaAcc": "面积堆积",
    originatorBelongs: "发起人所属",
    "taskScheduling.taskDesign.addFrequencyModal.Month": "每月",
    "BI.components.datetime.labelSpace": "字体间距",
    "workFlow.zh.errorBoundary": "错误边界事件",
    pleaseConfigApi: "请配置API",
    "language.translation.labelSuperiorTag": "上级标记",
    "editorModule.ignore": "忽略",
    "workFlow.User.tabApprover": "审批人",
    "mobileDev.loginDesignStepOne.Hint.whetherDelete":
        "确定要删除吗？",
    xValue: "X轴值",
    "workFlow.WFDesign.hintSure": "确定要",
    webRenderLayer: "web端渲染层",
    interfaceId: "接口id",
    "orgDepartManagement.addModal.roleOfInformation.roleName":
        "角色名称",
    invalidOutputParameterEncodingInterfaceInputParameter:
        "接口入参中有使用无效的输出参数编码，请先修改再下一步",
    CodePreview: "代码预览",
    onlySupportsUploadingAPKFormat: "仅支持上传APK格式",
    "BI.group.echartsError": "请先配置好相关字段,展示完整图表",
    "code.rightPanel.addLable": "添加标签",
    "codeRule.addModal.addDialog.dialogTitle": "添加",
    "editorModule.insertEditLink": "插入/编辑链接",
    "mobileDev.listRightSide.leftAlignment": "左对齐",
    "code.codeForm.saveTemplateModal.labelClassification":
        "模板分类",
    "editorModule.editImage": "编辑图片",
    "orgDepartManagement.departmentFormDialog.placeholderOuterPhone":
        "请填写电话号",
    cannotExceed1000Characters: "不能超过1000个字符",
    "editorModule.failedLoadPluginZero": "插件加载失败 链接: {0}",
    "tip.select": "请选择",
    "Log.emptyModal.optionOne": "保留近一周",
    "workFlow.Process.remark": "备注",
    "workFlow.Bpmn.downloadXmlBtn": "下载xml",
    "editorModule.customColor": "自定义颜色",
    "News.labelNewsTitle": "新闻标题",
    "orgUserManagement.setAuthorizeBtn": "功能授权",
    "workFlow.processTasks.selectApprover": "选择转办审批人",
    "companyManager.companyFormDialog.labelRemark": "备注",
    "custmerForm.tableSort": "分类",
    "BI.Build.waterMark": "水印(预览有效)",
    "mobileDev.appDevIndex.loginDesignTitle": "移动应用-登录设计",
    "taskScheduling.taskDesign.startBtn": "启动任务",
    "editorModule.eurocurrencySign": "欧元符号",
    outputParameterCode: "输出参数编码",
    "custmerForm.classifiedManagement.addModal.placeholderRemark":
        "请填写备注",
    "mobileDev.loginRightSide.labelBtnName": "按钮名称",
    "code.codeStepFour.dataSource": "数据来源",
    "subSystemForm.submitBtn": "提交",
    "menuManagement.addModal.labelNumber": "编号",
    "custmerForm.classifiedManagement.addModal.placeholderSequence":
        "请填写排序",
    "subSystem.tableSort": "排序",
    "workFlow.Process.pointsNote": "注意事项",
    "workFlow.zh.manualTask": "手工任务",
    "Log.fixedAccess": "访问日志",
    "workFlow.zh.forms": "表单",
    "orgDepartManagement.Hint.confirmWhetherDelete":
        "确定要删除此部门吗？",
    "editorModule.textColor": "文字颜色",
    APIConfigShowsFieldNotSelected: "API配置显示字段未选择",
    "workFlow.createFLow.hintSelectHandler":
        "请选择下一节点对应处理人",
    ongoingTwo: "进行中",
    "workFlow.Approval.placeholderOverruled": "==驳回至指定节点==",
    "workFlow.WFDesign.fixedTitle": "流程分类",
    "workFlow.User.radioShowAll": "显示所有审批",
    "workFlow.zh.subflowExpanded": "子流程（展开的）",
    "mobileDev.formRightSide.hintBindField": "请给列表项绑定字段",
    "custmerForm.male": "男",
    selectVariableTypeBeforeManipulatingVariableValue:
        "请先选择变量类型后再操作变量值",
    "mobileDev.homeRightSide.dialogTitle.setMenuFunction":
        "菜单功能配置",
    "code.rightPanel.showLable": "显示标签",
    "BI.listIndex.Modal.scrSize": "大屏尺寸",
    "code.leftScrollbar.component.singleLineText": "单行文本",
    "workFlow.WFMenu.fixedTitle": "专项菜单类别",
    "code.rightPanel.selectCodeRules": "请选择编码规则",
    "taskScheduling.taskDesign.addModal.stepOne": "基础信息",
    "mobileDev.loginRightSide.labelSpace": "输入框间距",
    "menuManagement.addModal.modalTitle": "新增功能",
    "code.codeStepOne.placeholderSelect": "请选择",
    "workFlow.zh.end": "结束",
    failedToModifyMenu: "修改菜单失败！",
    "mobileDev.functionDesignStepEight.placeholderSort":
        "请填写排序",
    "editorModule.row": "行",
    appVersion: "APP版本",
    "code.codeStepFour.exportBtn": "快速导出",
    columnNamesMustBeWithin100Characters: "列名必需在100个字符以内",
    counterCannotGreaterThanMax: "计数器默认值不能大于最大值",
    "importAndExport.excelImport.tableStatus": "状态",
    pleaseSelectAnAssignmentField: "请选择赋值字段",
    "login.username": "请输入账号",
    "mobileDev.formRightSide.optionUser": "当前用户",
    "mobileDev.loginDesignForm.returnBtn": "返回选择记录",
    "searchModule.stateSuccess": "成功",
    "BI.Build.Mutual": "交互",
    "editorModule.cell": "单元格",
    "workFlow.launchList.headTitle": "模板列表",
    "dataItem.dialogInstall.labelTree": "树形",
    greater: "大于",
    "orgUserManagement.enUserBtn": "启用账户",
    "importAndExport.importForm.optionEnd": "终止",
    "code.rightPanel.labelWidth": "标签宽度",
    "tableOperationModule.viewBtn": "查看",
    inforClass: "信息类",
    "workFlow.zh.signalBoundary": "信号边界事件",
    paymentWay: "付款方式",
    "editorModule.black": "黑色",
    "code.codeStepOne.tabMainTable": "主表",
    dataOptionPreloadDataSourceNotSelected:
        "预加载数据源中数据选项未选择",
    "code.codeStepEight.selectIcon1": "选择图标1",
    "mobileDev.homeRightSide.labelNonhighlightTextC":
        "非高亮文字颜色",
    "databaseManage.dataSource.tableCreationTime": "创建时间",
    "code.codeStepTwoListStructure.databaseSelect": "数据库选择",
    "importAndExport.importForm.tabOnlyOne": "唯一性",
    reset: "重置",
    appVersionNumber: "APP版本编号",
    "areaManager.tableNumber": "#",
    "deletePrompt.noSelected": "未选择项目！",
    mobileFunctionIcon: "移动端功能图标",
    "mobileDev.functionDesignStepSix.placeholderFunctionDesc":
        "请填写功能描述",
    reverseOrder: "降序",
    "forgetPass.loginAgainBtn": "重新登录",
    "orgDepartManagement.viewRoleBtn": "查看角色",
    "editorModule.lightYellow": "浅黄色",
    "codeRule.addModal.placeholderFormat": "请按所选格式填写",
    indexList: "首页列表类型",
    "workFlow.createFLow.labelCirRecord": "流转记录",
    "mobileDev.homeRightSide.table": "表格",
    "codeRule.addModal.Hint.Format": "请填写格式",
    "mobileDev.searchRightSide.placeholderTime": "自定义时间查询",
    "mobileDev.tableSet.centerAlign": "居中",
    "subSystemForm.labelDescription": "描述",
    "BI.listCategory.hintMValue": "请输入模块值",
    "workFlow.selectSql.database": "数据库",
    "workFlow.privateStampInfo.tabStampName": "印章名称",
    "importAndExport.importConfiguration.labelOperDepart":
        "操作人部门",
    "BI.components.bar.labelVertical": "竖展示",
    "language.languageType.placeholderSelect": "请选择",
    "selectPost.selectedRole": "已选角色",
    "workFlow.processTasks.hintRetract": "撤回提示",
    "menuManagement.tableName": "名称",
    "orgUserManagement.addModal.placeholWeChat": "请填写微信",
    "databaseManage.databaseTable.importLists.commonFieldsRemark":
        "描述",
    "BI.group.customBind.labelSQL": "SQL语句:",
    "reportModule.reportManage.labelRName": "报表名称",
    "fileManagement.Hint.clearSuccess": "清空回收站成功！",
    "workFlow.zh.topic": "主题",
    "workFlow.processTasks.hintSelectRow":
        "请先选择一行，再进行操作。",
    "editorModule.browseImage": "浏览图像",
    "deletePrompt.initiationProcessFailed": "发起流程失败！",
    paymentNum: "付款单号",
    "code.leftScrollbar.component.multilineText": "多行文本",
    clickConginObjectCollectionInfor: "点击配置对象集合信息",
    "Log.emptyModal.optionThree": "保留近三个月",
    "companyManager.companyFormDialog.labelFoundedTime": "成立时间",
    "mobileDev.formRightSide.labelMaxImg": "最多可选图片数",
    "editorModule.animalsNature": "动物和自然",
    "dataItem.dialogInstall.labelSuperior": "所属上级",
    "editorModule.colorLevels": "颜色层次",
    "taskScheduling.taskDesign.addModal.previousBtn": "上一步",
    "databaseManage.databaseTable.addSheet.releaseBtn": "发布",
    "databaseManage.databaseTable.tableName": "表名",
    "code.rightPanel.errorPrompt": "错误提示",
    "code.rightPanel.showScore": "显示分数",
    "custmerForm.classifiedManagement.addModal.titleAddForm":
        "新增表单分类",
    "codeRule.addModal.placeholderPositiveInteger": "请输入正整数",
    "workFlow.WFChange.refreshBtn": "刷新",
    "BI.components.table.titleTableSet": "表格设置",
    "BI.components.flop.titleInterSet": "内部设置",
    "selectUser.placeholderSelectUser": "请选择人员",
    "BI.components.gauge.labelFSize": "刻度字号",
    "workFlow.categoryList.labelCode": "流程分类编码",
    "databaseManage.dataSource.addModalSelectDatabase":
        "请选择数据库",
    "custmerForm.tableNumber": "#",
    "code.rightPanel.showSub": "显示最子级结果",
    "menuManagement.addModal.labelIcon": "图标",
    enterInterfaceClassCode: "请输入接口分类编码",
    fillNumber: "请填写编号",
    "fileManagement.Hint.uploadedSuccess": "上传成功！",
    pleaseConfigSqlStatement: "请配置SQL语句",
    "selectPost.selectTitle": "全选",
    "workFlow.zh.addProperty": "添加属性",
    "code.rightPanel.placeholderPrefix": "请输入前缀",
    selectVariableType: "请选择变量类型",
    codeFirst: "界面优先",
    "code.rightPanel.auxiliaryText": "辅助文字",
    "mobileDev.formRightSide.textBox": "文本框",
    transfer: "转办",
    "BI.Build.scrIntro": "大屏简介",
    "workFlow.zh.delegateExpress": "代理表达式",
    "messageIndex.labelSchedule": "日程",
    "BI.Build.reminderEvent": "提示事件",
    "importAndExport.importForm.labelEMechanism": "错误机制",
    determineWhetherDeleteInterfaceClass: "是否确定删除该接口分类",
    "orgDepartManagement.departmentFormDialog.placeholderShortName":
        "请填写部门简称",
    "orgDepartManagement.departmentFormDialog.placeholderEmail":
        "请填写邮箱号",
    "code.leftScrollbar.hintNotUse":
        "该组件正在兼容中，暂不能于子表单中使用",
    "fileManagement.titleMove": "移动",
    "mobileDev.functionDesignStepEight.placeholderFunctionIcon":
        "请填写功能图标",
    variableCalculaByCalculationFormula:
        "变量之间可通过计算公式进行运算 ( 例: 销售单价 * 销售数量 )",
    "workFlow.zh.timerBoundaryUnblock": "定时边界事件（非中断）",
    "workFlow.selectLaunch.templateSelect": "模板选择",
    "deletePrompt.emptyFailure": "清空失败!",
    "databaseManage.dataLink.testLink.promptMessageSuccess":
        "测试连接成功",
    "workFlow.processTasks.completedTask": "已办任务",
    lengthSixCharacter: "长度在6个字符以内",
    "forgetPass.submitCodeBtn": "提交验证码",
    "workFlow.WFDesign.importCommonBtn": "BPMN导入",
    "mobileDev.functionDesignStepEight.functionIcon": "功能图标",
    "orgDepartManagement.addModal.roleOfInformation.addPeopleBtn":
        "添加人员",
    "taskScheduling.taskDesign.addModal.labelFunctionDescription":
        "功能描述",
    "deletePrompt.Disable": "禁用",
    noSponsorSelectedByExternalProcess: "外部流程没有选择发起人",
    "BI.listIndex.Modal.postStatus": "发布状态",
    "databaseManage.databaseTable.addSheet.HintWriteTableRemark":
        "请填写表备注",
    "BI.components.text.labelTurnOn": "开启",
    "workFlow.zh.signalStartUnblock": "信号开始事件（非中断）",
    "workFlow.createFLow.labelFormInfor": "表单信息",
    "code.codeStepSix.dataList": "数据库列表",
    "workFlow.Process.member": "成员",
    keepOldTable: "沿用旧表",
    "language.translation.addTra": "新增翻译",
    "workFlow.filedConfig.tabAlign": "对齐",
    "searchModule.searchPlaceholder": "请输入要查询的关键字",
    "mobileDev.custom": "自定义",
    "reportModule.reportRelease.labelMenuNum": "菜单编号",
    "mobileDev.mobileSchema.fixedTitle": "模板分类",
    "editorModule.superScript": "上标",
    "mobileDev.homeRightSide.setMenuFunction": "菜单功能配置",
    "workFlow.User.tableSelect": "选择",
    "BI.group.customBind.headerTitle": "基础配置",
    "mobileDev.formRightSide.labelFieldVal": "字段验证",
    "forme.editModal.title": "编辑表单功能",
    "workFlow.userButtonSetting.addPValueBtn": "添加参数值",
    "language.translation.labelRemarks": "备注",
    "forme.editModal.viewBtn": "查看",
    "workFlow.addStamp.labelSort": "排序",
    "mobileDev.mobileSchema.templateList": "模板列表",
    "companyManager.checkRole": "查看角色",
    "areaManager.fixedTitle": "目录信息",
    "editorModule.version": "版本",
    "editorModule.lightRed": "浅红色",
    "reportModule.reportRelease.hintRptFileId": "请填写报表文件",
    "workFlow.filedConfig.centered": "居中",
    "orgUserManagement.addModal.Hint.errorMobile": "请填写手机号码",
    noFormAuth: "但是您没有表单项权限",
    "deletePrompt.noBtn": "否",
    "BI.group.customBind.hintVerifiedSuccess":
        "验证成功,没有查找到相关字段",
    "wel.welIndex.allWarnings": "所有预警",
    "formDesign.labelFunctionDescription": "功能描述",
    "workFlow.addStamp.selectSignature": "请选择电子签章",
    "workFlow.zh.incGatEvent": "相容网关",
    "reportModule.reportRelease.labelSuperMenu": "上级菜单",
    "mobileDev.formRightSide.optionStringOrNull": "字符串或空！",
    "mobileDev.homeRightSide.labelSQL": "SQL语句",
    "editorModule.verticalSpace": "垂直边距",
    "reportModule.reportRelease.dialogTitle.editorTitle": "编辑",
    enterInterfaceName: "请输入接口名称",
    "workFlow.Step1.labelFDesc": "功能描述",
    "code.leftScrollbar.component.divider": "分割线",
    "language.languageCategory.af-ZA": "南非荷兰语",
    "companyManager.companyFormDialog.labelOuterPhone": "电话号",
    "editorModule.pesetaSign": "比塞塔符号",
    "mobileDev.formRightSide.labelTipContent": "提示内容",
    "mobileDev.functionDesignForm.stepEight": "绑定菜单",
    "workFlow.WFLaunch.stampCode": "模板编码",
    saveFieldDataSourceNotSelected: "数据源的保存字段未选择",
    loadingTranslation: "正在加载翻译",
    "code.codeStepFour.labelBtnId": "按钮ID",
    "orgUserManagement.addModal.labelDepartment": "部门",
    "editorModule.media": "媒体",
    "orgRoleManagement.Hint.deleteCompany": "删除公司",
    "workFlow.Step1.labelMName": "菜单名称",
    "editorModule.focusContextualToolbar": "移动焦点到上下文菜单",
    compAss: "组件赋值",
    creditMgt: "收款管理",
    "workFlow.zh.signal": "信号",
    "code.rightPanel.placeholderFileFieldName":
        "请输入上传文件字段名",
    "editorModule.color": "颜色",
    whetherShowTag: "是否显示标签",
    "BI.components.text.labelLinkAddress": "超链地址",
    "editorModule.green": "绿色",
    "workFlow.zh.compensationThrow": "补偿中间抛出事件",
    "BI.Build.parName": "参数名称",
    "reportModule.reportManage.placeholderRCode": "请填写报表编码",
    "importAndExport.excelExport.hintBtn": "请选择绑定按钮",
    "workFlow.zh.asynchronousBefore": "异步前",
    "workFlow.selectLaunch.fixedTitle": "流程分类",
    "workFlow.Process.placeholderInforInterval":
        "请填写消息间隔(小时)",
    "code.codeStepFour.tableHeaderColumnName": "列名",
    viewInterfaceCategories: "查看接口分类",
    "workFlow.Process.tabConfig": "基础配置",
    "custmerForm.tableEnable": "启用",
    "BI.Build.titleOperate": "操作",
    "workFlow.WFMonitor.titleAssignApprover": "指派审批人",
    "BI.Build.envAdreess": "环境地址",
    "mobileDev.homeRightSide.Video": "视频",
    "code.codeStepFour.hintParentField": "请选择父级字段",
    "editorModule.invert": "反转",
    "reportModule.reportRelease.labelRptFileId": "报表文件",
    portalMgt: "门户管理",
    onlyAlphanumericsUnderscoresEnteredNumbersCannotStart:
        "只能输入字母数字和下划线且数字不能开头",
    "code.rightPanel.placeholderCompWidth": "请输入组件宽度",
    "code.rightPanel.select": "选择",
    "BI.group.customBind.tabTitleTwo": "SQL语句",
    "code.leftScrollbar.component.lenovoLayer": "联想弹层",
    "code.rightPanel.selectField": "请选择字段",
    variableCodeCannotNull: "变量编码不能为空！",
    "mobileDev.homeRightSide.labelCardType": "卡片类型",
    "forme.addModal.functionIcon": "功能图标",
    "navbar.screenfullF": "退出全屏",
    "code.codeStepSix.labelFunctionDesc": "功能描述",
    collOverview: "收款总览",
    "mobileDev.mobileSchema.compDemo": "组件演示",
    "workFlow.userButtonSetting.btnCode": "按钮编码",
    outboundWhse: "出库仓库",
    "menuManagement.addModal.labelSort": "排序",
    "formDesign.titleFormDesign": "表单设计",
    "taskScheduling.taskDesign.addModal.labelFrequency": "执行频率",
    "forme.editModal.deleteBtn": "删除",
    "code.codeForm.Hint.bindSubformSheet": "请绑定子表单组件的表",
    "workFlow.privateStampInfo.hintDefFailed": "指定默认失败！",
    orderDate: "订单日期",
    "workFlow.roams.transferTo": "流转到",
    "workFlow.userButtonSetting.executeScript": "执行脚本",
    "code.leftScrollbar.refreshBtn": "刷新",
    "orgRoleManagement.addMemberBtn": "添加成员",
    "user.info.personalInfor": "个人信息",
    "interfaceManage.addModal.menuRight": "数据权限过滤字段维护",
    "menuManagement.addModal.placeholderNumber": "请填写编号",
    "BI.components.line.labelVerDisplay": "竖展示",
    "editorModule.img": "图片...",
    "wel.welIndex.energyCons": "能耗",
    "workFlow.zh.externalProcess": "外部流程",
    "navbar.mainSys": "切换至开发平台",
    "workFlow.filedConfig.pagination": "分页",
    "BI.listIndex.Modal.kanbanRelease": "看板发布",
    "orgDepartManagement.tabCode": "部门编码",
    "BI.Build.alignLeft": "左对齐",
    "BI.components.table.labelOddColor": "奇行颜色",
    "code.rightPanel.compConfig": "计算式配置",
    "BI.group.contentMenu.Delete": "删除图层",
    "workFlow.WFChange.unread": "未阅",
    "workFlow.callActivity.tabSubflow": "子流程",
    "editorModule.headersFive": "标题5",
    "mobileDev.functionDesignStepTwo.tabField": "关联字段",
    "BI.group.customBind.placeholderContent": "请输入内容",
    six: "六",
    "BI.components.imgBorder.labelImgAddress": "图片地址",
    "databaseManage.databaseField.addModalDateType": "数据类型",
    "workFlow.Step1.hintFNum": "请填写功能编号",
    "mobileDev.formRightSide.optionDateOrNull": "日期格式或空！",
    "PCDevGuide.dataSheetManagement": "数据表管理",
    "databaseManage.databaseTable.addSheet.tableColumnName": "列名",
    "workFlow.Process.optionOne": "候选审批人包含流程任务发起人",
    "Schedule.hintEndTime": "请填写结束时间",
    "editorModule.save": "保存",
    "crud.show": "显示",
    "mobileDev.homeRightSide.placeholderCarouselType":
        "请选择轮播图类型",
    "BI.echart.bar": "柱形图",
    "menuManagement.addModal.completeBtn": "完成",
    "BI.components.progress.labelPreFontThi": "前缀文字粗细",
    "orgDepartManagement.tabAbbreviation": "部门简称",
    "workFlow.WFChange.previewBtn": "预览模板",
    "code.rightPanel.selectTimeType": "请选择时间类型",
    "workFlow.selectAuthority.tabType": "类型",
    "forme.addModal.placeholderFunctionOrder": "请填写功能排序",
    "orgDepartManagement.tabApproveRole": "审批角色（部门）",
    "forme.addModal.placeholderDefaultWidth": "不填则使用默认宽度",
    operationInfor: "操作信息：",
    "workFlow.selectSql.hintPrecautions":
        "查询结果集展示 注意事项：",
    "mobileDev.functionDesignForm.stepTwo": "数据表设置",
    "mobileDev.FunctionDesDescr": "进行移动端功能设计",
    "wechatAndDingTalk.userManagement.dingSynBtn": "同步到系统",
    "code.rightPanel.bottomSpace": "下间距",
    "editorModule.red": "红色",
    "BI.Build.horizontalWay": "水平方式",
    "selectUser.selectedUser": "已选人员",
    "route.table": "表格",
    "editorModule.cancel": "取消",
    "login.info": "LEARUNSOFT通用管理系统快速开发框架",
    "PCDevGuide.codeGenerator": "代码生成器",
    "editorModule.pluginsInstalled": "已安装插件 ({0}):",
    languageTypeMaintenanceAddedSuccessfully:
        "语言类型维护新增成功！",
    "buttonModule.modalCancelBtn": "取消",
    "taskScheduling.taskDesign.addFrequencyModal.April": "四月",
    "language.dataDictionary.titleEditTraTag": "修改翻译标记",
    "code.codeStepFour.showField": "显示字段",
    "codeRule.addModal.Hint.DocumentName": "请填写单据名称",
    "editorModule.upload": "上传",
    "BI.listIndex.Modal.ownSystem": "所属系统",
    "workFlow.selectLaunch.selectType": "请选择类别",
    "workFlow.Process.selectNoCorrespond": "==请选择无对应处理人==",
    "workFlow.zh.implementation": "实现方式",
    "editorModule.insertColumnBefore": "在左侧插入",
    "orgRoleManagement.databaseAuth.labelChildFun":
        "子级功能沿用父级配置:",
    "BI.components.flop.labelOverall": "整体",
    "editorModule.decreaseIndent": "减少缩进",
    "editorModule.target": "打开方式",
    areYouSureYouWantToRestoreThisFile: "确定要还原该文件吗？",
    "workFlow.WFDesign.enableBtn": "启用流程",
    "BI.components.main.labelLabelSpace": "标签间距",
    "databaseManage.dataLink.nameDatabase": "数据库名称",
    "codeRule.addModal.tableInitValue": "初始值",
    "editorModule.focusMenubar": "移动焦点到菜单栏",
    whseMgt: "出库管理",
    "subSystem.tableNCode": "编码",
    "workFlow.printCurrentPage.hintNotFinished": "系统表单未加载完",
    "code.codeStepSix.controlOutputList": "控制器层输出目录",
    "editorModule.failedInitializePlugin": "插件初始化失败: {0}",
    btnSelDataHeaderConfig: "按钮选择数据-表头配置",
    "Schedule.hintContent": "请填写内容",
    "mobileDev.appDevIndex.setFunctionBtn": "设置功能",
    "mobileDev.formRightSide.subform": "子表单",
    "importAndExport.importForm.tabRemark": "备注",
    "editorModule.yellow": "黄色",
    "databaseManage.dataLink.loadingText":
        "正在测试链接中，请稍等...",
    "BI.components.main.labelTextColor": "文字颜色",
    "BI.components.main.labelFontWeight": "字体粗细",
    "workFlow.WFCard.cardName": "名称",
    "workFlow.selectNodes.roleSelect": "角色选择",
    "mobileDev.homeRightSide.labelCorField": "分类对应字段",
    "Schedule.hintNoPerm": "您没有新增权限!",
    "workFlow.roams.by": "由",
    "orgImport.dragFile": "将文件拖到此处，或",
    "BI.components.pie.titlePieSet": "饼图设置",
    appDataAuthorization: "APP数据授权",
    sponsorsCompanyId: "发起人所属公司ID",
    "code.codeStepFour.printBtn": "打印",
    salesType: "销售类型",
    "custmerForm.classifiedManagement.tableCode": "表单分类编码",
    "language.dataDictionary.hintDelTraTag":
        "是否确定删除该翻译标记",
    pleaseSelectVariable: "请选择变量",
    "code.leftScrollbar.component.slider": "滑块",
    "workFlow.selectNodes.nodeSelection": "节点选择",
    clickCustomizeSqlEdit:
        "点击进行自定义SQL语句编辑可点击左侧变量到此处进行变量添加，",
    "workFlow.Step3.allMember": "所有成员",
    "BI.listIndex.Modal.functionName": "功能名称",
    "mobileDev.loginRightSide.placeholderWordSpace": "请输入字间距",
    "BI.components.main.labelTextSize": "字号",
    "workFlow.Approval.labelOverruled": "驳回节点",
    "code.rightPanel.max": "最大值",
    "mobileDev.formRightSide.labelDataSource": "数据来源",
    "code.rightPanel.timeType": "时间类型",
    "PCDevGuide.formRelease": "表单发布",
    selectSelectSet: "请选择选择设置",
    "orgRoleManagement.indexAuth.tabIndexList": "首页列表",
    "BI.listIndex.copyIcon": "复制",
    "workFlow.approvalFLow.hintApprovedSuccess": "审批流程成功",
    "language.languageType.hintRule":
        "提示：语言类型需遵循国际通用编码",
    "workFlow.categoryList.tabEnabledMark": "是否有效",
    initiatorConfigurationMode: "发起人配置方式：",
    "workFlow.privateStampInfo.hintStartFailed": "启动失败！",
    "code.codeIndex.stepNameSix": "输出配置",
    "Log.fixedAbnormal": "异常日志",
    "wel.welIndex.monthAlarmNum": "月总报警数量",
    addParameterAssSuccee: "添加参数赋值成功",
    "mobileDev.loginDesignForm.Hint.saveSuccess": "保存模板成功！",
    "workFlow.userButtonSetting.tabFlowBtn": "流转按钮",
    "BI.components.imgBorder.labelBgColor": "背景色",
    "menuManagement.addModal.stepFour": "表单信息",
    "workFlow.WFMenu.tabBelTem": "所属模板",
    "workFlow.zh.userTask": "用户任务",
    "editorModule.rotateClockwise": "顺时针旋转",
    "BI.Build.titleLayer": "图层",
    "code.codeStepFour.hintVerifySuccess": "验证成功",
    "reportModule.reportRelease.fixedTitle": "报表分类",
    "workFlow.Process.noCorrespond": "无对应处理人",
    "Schedule.hintStartTime": "请填写开始时间",
    selectCustomOutputCategory: "请选择自定义出参类别",
    "reportModule.reportManage.placeholderRemark": "请填写备注",
    "buttonModule.deactivateBtn": "停用",
    "route.setting": "个人设置",
    "BI.components.bar.titleSet": "柱体设置",
    "BI.components.map.labelFHighlightC": "字体高亮颜色",
    "editorModule.zeroCharacters": "{0} 个字符",
    "orgPostManagement.editInforTitle": "编辑信息",
    "editorModule.embed": "内嵌",
    "searchModule.searchBtn": "搜索",
    "editorModule.replace": "替换",
    reqType: "请求类型",
    areYouSureYouWantToEmptyTheRecycleBin: "确定要清空回收站吗？",
    "BI.components.flop.labelRows": "行数",
    "editorModule.tools": "工具",
    "importAndExport.importForm.labelAType": "关联类型",
    "language.translation.placeholderSuperiorTag":
        "请选择上级标记，可不选，不选择自动作为顶级翻译标记",
    fillWebFunctionOrder: "请填写web端功能排序",
    pleaseEnterVersionName: "请输入版本名称",
    "editorModule.flags": "旗帜",
    "workFlow.processTasks.hintTransferSuccess": "转办成功",
    "deletePrompt.failureTitle": "失败",
    total: "总和",
    "forme.editModal.initiationProcessBtn": "发起流程",
    "workFlow.Process.tabAuthoritySet": "权限设置",
    "navbar.screenfull": "全屏",
    "importAndExport.excelImport.tableFunction": "绑定功能",
    tagsView: "更多下拉框",
    "deletePrompt.noCounterpart":
        "没有下一节点对应处理人，流程发起失败！",
    setParameterValue: "设置参数值",
    "BI.menuMapManagement": "地图管理",
    "code.codeStepFour.rowData": "行数据",
    "BI.menuBIManagement": "大屏管理",
    "BI.components.flop.titleSuffixSet": "后缀设置",
    "mobileDev.loginDesignForm.Hint.reviseSuccess":
        "修改模板成功！",
    "break-word": "内容换行",
    "BI.components.line.labelLineWidth": "线条宽度",
    "taskScheduling.taskDesign.addModal.addFrequencyBtn":
        "添加明细频率",
    "BI.listIndex.Modal.setIndex": "设置为首页",
    "workFlow.userButtonSetting.Sql": "SQL语句",
    uploadTime: "上传时间",
    "fileManagement.tabSize": "大小",
    "mobileDev.loginRightSide.uploadBtn": "上传",
    processEntrust: "流程委托",
    updateStatus: "更新状态",
    "wel.welIndex.lastMonthAlarmNum": "上月总报警数量：",
    "workFlow.selectSql.placeholderSelect": "请选择",
    "orgUserManagement.tabRemark": "备注",
    "editorModule.underline": "下划线",
    "orgUserManagement.addModal.labelTelephone": "电话",
    "code.leftScrollbar.component.count": "计算组件",
    hintOutputParameterTargetLocation:
        "输出参数目标位置：此项需填写目标属性或集合在json中所处位置，举例：data.CompanyInfo.CompanyID，代表在获取接口返回值后，将进行解析查找data属性下的CompanyInfo下的CompanyID属性作为返回值。",
    "forme.addModal.openDialogTitle.importConfiguration":
        "快速导入配置",
    "mobileDev.formCenterContainer.placeholderTextHint":
        "文本区提示",
    handler: "经办人员",
    "orgUserManagement.addModal.placeholRemark": "请填写备注",
    "mobileDev.listRightSide.Center": "居中",
    "formDesign.placeholderWriteFunctionDescription":
        "请填写功能描述",
    inboundDate: "入库日期",
    clickVariableAddVariables: "可点击左侧变量到此处进行变量添加",
    "BI.components.table.labelRank": "开启排名",
    "Notice.hintReleaTime": "请填写发布时间",
    hintPackageNameContant: "请填写Package名",
    "custmerForm.fixedTitle": "表单分类",
    "code.leftScrollbar.component.personnel": "人员",
    variableType: "变量类型",
    "language.languageType.Hint.deletedLanguage":
        "是否确定删除该语言类型",
    "workFlow.WFMenu.hintRefreshPage": "专项菜单需要刷新页面",
    "workFlow.WFMonitor.tabNum": "#",
    "fileManagement.clearFileBtn": "清空回收站",
    variBleCarriedNumbers: "变量之间通过号进行- 隔开 + 号进行合并",
    "workFlow.Approver.formFieldBtn": "表单字段",
    "BI.Build.inteWay": "接口方式",
    "workFlow.Approver.postBtn": "岗位",
    inforList: "信息列表",
    "route.store": "本地存储",
    "code.leftScrollbar.component.dropdownSelect": "下拉选择",
    "workFlow.Process.radioNo": "否",
    "workFlow.Step1.labelFIcon": "功能图标",
    "codeRule.addModal.Hint.DocumentNumber": "请填写单据编号",
    selectVerification: "请选择参验证",
    "wel.welIndex.waterIngress": "进水",
    "deletePrompt.batchDeleteSuccess": "批量删除成功！",
    "wel.welIndex.indexLoading": "首页配置加载中...",
    "orgPostManagement.addModal.labelPostNum": "岗位编号",
    "code.codeStepOne.tabNum": "#",
    "forme.addModal.placeholderOwningSystem": "请选择所属系统",
    "workFlow.processTasks.hintReturnPrevious":
        "确定要撤回至上个节点吗？",
    "code.rightPanel.tabs": "选项卡",
    "mobileDev.homeRightSide.placeholderCardType": "请选择卡片类型",
    executeSql: "执行SQL",
    "code.rightPanel.placeholderbtnText": "请输入按钮文字",
    "companyManager.companyFormDialog.placeholderHigherCom":
        "请选择上级公司",
    "Schedule.addModalTitle": "新增",
    "taskScheduling.taskDesign.addExpressionModal.expressionFourteen":
        "每月第三个星期五的10:15分运行",
    "language.languageCategory.pt-br": "巴西葡萄牙语",
    "workFlow.Step1.placeholderFDesc": "请填写功能描述",
    "language.dataDictionary.hintDelAll":
        "删除该翻译标记会同步删除所有子级翻译标记",
    "login.qq": "QQ",
    "editorModule.inline": "文本",
    "subSystem.notSelectedError": "未选择项目",
    "workFlow.zh.escalationStart": "升级开始事件",
    surprised: "惊喜",
    "taskScheduling.taskDesign.addModal.simpleRepetitionThree":
        "请选择时间单位",
    "code.codeForm.saveTemplateModal.placeholderClassification":
        "请选择模板分类",
    "taskScheduling.taskDesign.addFrequencyModal.selectMonthError":
        "请选择执行月份",
    "code.rightPanel.min": "最小值",
    "code.rightPanel.placeholderCloseValue": "请输入关闭值",
    "code.codeStepFour.placeholderSql": "请输入SQL",
    "code.leftScrollbar.hintFileName": "文件名:",
    "mobileDev.homeDesignStepTwo.leftTitle": "界面元素",
    "custmerForm.enableFormBtn": "启用表单",
    "workFlow.Process.templateClassify": "模板分类",
    "workFlow.Process.selectTaskAuthority": "请选择任务权限",
    "orgDepartManagement.departmentFormDialog.labelDepName":
        "部门名称",
    "importAndExport.excelExport.labelName": "导出名称",
    "workFlow.Step1.stepBackBtn": "上一步",
    "workFlow.zh.listenerType": "监听器类型",
    "workFlow.zh.executableFile": "可执行文件",
    "workFlow.Process.placeholderFName": "请填写功能名称",
    "BI.components.flop.labelBorderHigh": "边框高度",
    selectInterfaceType: "请选择接口类型",
    "workFlow.userButtonSetting.tablePName": "参数名称",
    "custmerForm.viewHistory.updateBtn": "更新到此版本",
    "mobileDev.formRightSide.placeholderModuleHeight":
        "请输入组件的高度",
    componentList: "组件列表",
    unequal: "不等于",
    "code.rightPanel.mostSelect": "最多可选",
    "companyManager.companyFormDialog.placeholderFax": "请填写传真",
    "BI.components.pie.labelRoseType": "南丁格尔玫瑰",
    "workFlow.delegateForm.labelEndDate": "结束时间",
    "mobileDev.formCenterContainer.addLine": "添加一行",
    zero: "零",
    "editorModule.mediaMore": "多媒体...",
    "editorModule.arrows": "箭头",
    DatasheetSet: "表结构配置",
    differentTableStructures: "表结构不同",
    "mobileDev.loginRightSide.placeholderBtnName": "请输入按钮名称",
    "workFlow.Process.radioDesignatedMembers": "指定成员",
    "workFlow.Circulate.postBtn": "岗位",
    "language.languageType.addModal.editTitle": "修改语言类型",
    "workFlow.zh.expandedPool": "展开池",
    "editorModule.manatSign": "马纳特符号",
    "workFlow.categoryList.stateInvalid": "无效",
    "workFlow.Process.functionDescr": "功能描述",
    "forme.addModal.functionName": "功能名称",
    "workFlow.Step1.placeholderMName": "请填写菜单名称",
    "editorModule.middle": "垂直居中",
    "orgRoleManagement.indexAuth.hintLoading": "加载中...",
    "workFlow.processTasks.myProcess": "我的流程",
    exampleStackAreaDiagram: "堆叠区域图示例",
    "taskScheduling.taskDesign.addFrequencyModal.October": "十月",
    "mobileDev.homeRightSide.placeholderUploadImg": "请上传图片",
    processData: "流程数据",
    "workFlow.zh.javaClass": "Java类",
    "deletePrompt.hintSelectData": "请选择一条数据!",
    mobilePreview: "手机端预览",
    "workFlow.Process.appProcessBtn": "添加流程",
    "menuManagement.addModal.placeholderSystem": "请选择所属系统",
    "code.rightPanel.placeholderClosePrompt": "请输入关闭提示",
    "workFlow.zh.cancelBoundary": "取消边界事件",
    "code.formList.temFunction": "模板功能",
    "selectUser.labelAccount": "账户",
    "custmerForm.tableStatus": "状态",
    selectParentIcon: "请选择父级图标",
    "user.setting.hintLoading": "加载中...",
    "code.codeStepThree.tabScale": "所占行比例",
    "interfaceManage.addModal.tableFieldName": "字段名称",
    "mobileDev.functionDesignStepSeven.fixedList": "列表页",
    "code.rightPanel.compType": "组件类型",
    "mobileDev.formRightSide.labelDefault": "默认值",
    "workFlow.roams.approvalEnd": "审批结束",
    "editorModule.headersThree": "标题3",
    "editorModule.rowType": "行类型",
    "mobileDev.loginDesignForm.saveTemplateModal.modalTitle":
        "保存模板",
    "workFlow.zh.date": "日期",
    cancelledDelete: "已取消删除",
    useDefaultSort: "使用默认排序",
    "code.leftScrollbar.component.codes": "编码",
    "code.leftScrollbar.component.inforBody": "信息体",
    "reportModule.reportManage.placeholderRType": "请选择报表类型",
    "Log.fixedOperating": "操作日志",
    turnover: "成交金额",
    "Log.emptyModal.labelTime": "保留时间",
    formatExample:
        "格式例如：模板名称-发起人所属部门-发起人名称-时间(yyyy-MM-dd)+四位随机数",
    "workFlow.zh.messageThrow": "消息中间抛出事件",
    "workFlow.zh.compensationStart": "补偿开始事件",
    "mobileDev.functionDesignForm.placeholderSelect": "请选择",
    "mobileDev.loginRightSide.labelInputSpace": "按钮距输入框间距",
    "BI.listIndex.Modal.screenName": "大屏名称",
    overwriteOldTable: "覆盖旧表",
    "workFlow.addStamp.clickSignBtn": "点击签名",
    externalProcessDidNotSelectCallingElement:
        "外部流程没有选择调用元素",
    "BI.components.radar.labelAreaTra": "区域透明度",
    "BI.components.wordCloud.labelMaxFont": "最大字体",
    "mobileDev.loginRightSide.leftAlign": "左对齐",
    "language.languageCategory.nb-NO": "挪威语",
    "custmerForm.classifiedManagement.tableInvalid": "无效",
    "user.info.headPortrait": "头像",
    "taskScheduling.taskLog.tableTime": "执行时间",
    "workFlow.zh.timerStartUnblock": "定时开始事件（非中断）",
    "workFlow.callActivity.targetVariableMain":
        "目标变量 ( 主流程 )",
    assignmentCategory: "赋值类别",
    "code.rightPanel.whetherBorder": "是否带边框",
    "BI.components.img.labelAddress": "地址",
    "forme.tableHeaderFormName": "表单名称",
    "deletePrompt.saving": "保存中",
    "editorModule.preview": "预览",
    "language.languageCategory.ru-RU": "俄语",
    "editorModule.darkYellow": "暗黄色",
    "databaseManage.databaseTable.addSheet.hintNoEmpty":
        "表名请不能为空！",
    parameterAssEmpty: "参数赋值为空",
    feedback: "意见反馈",
    "code.codeStepFour.allDeleteBtn": "批量删除",
    "workFlow.Process.radioYes": "是",
    "editorModule.indentation": "缩进",
    "route.dashboard": "首页",
    initiatorDepartment: "发起人所属部门",
    objectCollection: "对象集合",
    "code.rightPanel.whetherEmpty": "能否清空",
    "mobileDev.homeRightSide.placeholderSelectIcon": "请选择图标",
    addColumn: "添加列",
    "code.leftScrollbar.component.lenovoDropdown": "联想下拉",
    pleaseSelectTheInitiatorConfigurationMethod:
        "请选择发起人配置方式",
    "areaManager.addModal.labelRemark": "备注",
    "editorModule.custom": "自定义...",
    "databaseManage.dataLink.tableDatabaseIP": "数据库IP",
    "Log.fixedTitle": "日志类型",
    "editorModule.formatPainter": "格式刷",
    "editorModule.text": "文字",
    "editorModule.failedLoadPluginOne":
        "插件加载失败: {0} 来自链接 {1}",
    "editorModule.alignment": "对齐方式",
    abnormalOperation: "表单非正常操作",
    "workFlow.callActivity.radioAsynchronous": "异步",
    "Notice.Tab.releaseBtn": "发布",
    lessThanOrEqual: "小于等于",
    logging: "日志记录",
    "codeRule.tableObjectNumber": "对象编号",
    "Schedule.labelEndTime": "结束时间",
    "mobileDev.formCenterContainer.placeholderSelect": "点击选择",
    "mobileDev.functionDesignForm.stepFive": "移动端列表",
    "importAndExport.importForm.tabDatabase": "数据库",
    outputParameterEncodingCannotNull: "输出参数编码不能为空！",
    "menuManagement.addModal.previousBtn": "上一步",
    "codeRule.addModal.addDialog.labelInitial": "初始",
    "codeSchema.titleThree": "在线代码生成器 并自动创建代码",
    "mobileDev.formRightSide.placeholderSaveField":
        "请选择保存字段",
    originatorDepartmentId: "发起人员部门ID",
    "menuManagement.addModal.placeholderSuperior": "请选择上级",
    "fileManagement.dialogTitle.previewFileTitle": "文件预览",
    "BI.components.gauge.labelNSize": "指标名称字号",
    "BI.echart.ring": "环形图",
    "workFlow.WFChange.tabSerialNum": "流水号",
    "language.menuFunction.fixedTitle": "功能目录",
    "editorModule.center": "居中",
    "editorModule.headersOne": "标题1",
    "reportModule.reportRelease.placeholderMenuName":
        "请填写菜单名称",
    "workFlow.sequenceFlow.andUnconditional": "与或非条件",
    "workFlow.Process.radioProhibit": "禁止发起",
    "editorModule.australSign": "澳元符号",
    "editorModule.documents": "文档",
    "workFlow.userButtonSetting.scriptFormat": "脚本格式",
    "language.languageType.Hint.noDeleted": "默认语言不允许删除!",
    "BI.components.flop.labelColor": "颜色",
    "editorModule.zoomIn": "放大",
    "workFlow.selectAuthority.postBtn": "岗位",
    "searchModule.endPlaceholder": "结束时间",
    "BI.components.img.labelWTime": "旋转时间",
    "editorModule.blocks": "基块",
    "areaManager.addModal.placeholderNumber": "请填写编号",
    InterfaceExecuteEnd: "接口执行结束",
    "taskScheduling.taskDesign.addExpressionModal.expressionOne":
        "每天12点运行",
    "code.rightPanel.placeholderTimeFormat": "请输入时间格式",
    "workFlow.User.completeCondition": "完成条件(多实例)",
    taxRateNotFilled: "税率未填写",
    "BI.Build.customData": "自定义数据",
    "workFlow.zh.type": "类型",
    "code.rightPanel.btnIcon": "按钮图标",
    "orgUserManagement.Hint.whetherDisabled": "确定禁用该账户？",
    "mobileDev.loginRightSide.labelBtnHigh": "按钮高度",
    Testfybj: "测试翻译标记",
    selectParameterValueType: "请选择参数值类型",
    "importAndExport.importForm.placeholderFixedValue":
        "请填写固定数值",
    "editorModule.selection": "选择",
    "databaseManage.databaseTable.importLists.copyTableTitleTwo":
        "数据表信息",
    fillInUnit: "请填写单位",
    "workFlow.userButtonSetting.hintBtnCode": "请输入按钮编码",
    "code.codeStepThree.placeholderSelect": "请选择",
    "editorModule.back": "后退",
    "user.authorizeInfor.titleFormAccess": "表单权限",
    "code.leftScrollbar.buildType": "生成类型",
    "databaseManage.databaseTable.addSheet.copyBtn": "复制",
    "custmerForm.tableName": "名称",
    "orgDepartManagement.roleConfiguration.RemarkDescrip":
        "备注描述",
    "companyManager.companyFormDialog.Modal.Title": "添加人员",
    "code.leftScrollbar.component.dateRange": "日期范围",
    "workFlow.importFlow.imgMiss": "图片缺失",
    "code.codeStepFour.titleAddBtn": "新增按钮",
    "code.leftScrollbar.closeBtn": "关闭",
    "mobileDev.tableSet.labelTabTitle": "表格标题",
    "workFlow.processTasks.initiateTask": "发起流程",
    "workFlow.WFMenu.tabMenuCode": "专项菜单编码",
    "editorModule.whetherLeave": "你还有文档尚未保存，确定要离开？",
    "importAndExport.importForm.tabCreateUser": "创建用户",
    "importAndExport.editQuickExport": "编辑快速导出",
    selectParameterAssignmentVariables: "选择参数赋值变量",
    selectOutputParamterSource: "请选择输出参数来源",
    selectInterfaceParameterFieldAssignVariable:
        "请选择接口出参字段赋值给变量",
    "mobileDev.functionDesignStepTwo.tabDataName": "数据表名",
    "messageIndex.hintReadFailed": "设置消息已读失败",
    "BI.components.bar.labelRound": "圆角",
    curPersonRoleId: "当前人员角色ID",
    "workFlow.processTasks.hintMovedSuccess": "已成功移入回收站",
    "BI.components.table.labelScroll": "开启滚动",
    "orgRoleManagement.databaseAuth.basConfig": "基本配置",
    "code.codeStepFour.listFieldConfig": "列表字段配置",
    "code.leftScrollbar.hintEmpty": "确定要清空所有组件吗？",
    "mobileDev.formRightSide.labelBindTable": "绑定表",
    "workFlow.zh.sequenceFlow": "流程线",
    "fileManagement.titleCompleteDelete": "彻底删除",
    "taskScheduling.taskDesign.addFrequencyModal.modalTitle":
        "添加明细频率",
    "mobileDev.homeRightSide.pileBar": "堆叠柱状图",
    submitFailureByNull: "有表单必填项未填写，无法保存",
    satisfy: "满意",
    interfaceOutputInfor: "接口输出信息",
    "codeRule.addModal.labelNumber": "编码编号",
    "BI.Build.groupBtn": "成组按钮",
    "workFlow.zh.callActivity": "调用活动",
    "dataItem.dialogInstall.hintEditSuccess": "修改成功！",
    "BI.components.datetime.labelColor": "字体颜色",
    publishMobile: "发布到移动端",
    "workFlow.User.multiInstanceType": "多实例类型",
    "mobileDev.loginRightSide.labelPhoneIcon": "手机号图标",
    "areaManager.addModal.placeholderName": "请填写名称",
    "dataItem.tableSort": "排序",
    "orgUserManagement.tabName": "姓名",
    "taskScheduling.taskLog.tableResult": "执行结果",
    "workFlow.privateStampInfo.titleAddStamp": "添加签章",
    reportReleaseModificationFailed: "报表发布修改失败！",
    fillInAtLeastOneSubmit: "请至少填写一个提交",
    "BI.components.table.titleRowSet": "表格列设置",
    "workFlow.zh.provideValue": "必须提供一个值",
    "taskScheduling.taskDesign.addModal.radioStartTimeTwoplaceholder":
        "选择日期时间",
    "mobileDev.functionDesignStepSix.hintOutArea": "请选择输出区域",
    "orgDepartManagement.tabOuterPhone": "电话号",
    el: {
        colorpicker: {
            confirm: "确定",
            clear: "清空",
        },
        datepicker: {
            now: "此刻",
            today: "今天",
            cancel: "取消",
            clear: "清空",
            confirm: "确定",
            selectDate: "选择日期",
            selectTime: "选择时间",
            startDate: "开始日期",
            startTime: "开始时间",
            endDate: "结束日期",
            endTime: "结束时间",
            prevYear: "前一年",
            nextYear: "后一年",
            prevMonth: "上个月",
            nextMonth: "下个月",
            year: "年",
            month1: "1 月",
            month2: "2 月",
            month3: "3 月",
            month4: "4 月",
            month5: "5 月",
            month6: "6 月",
            month7: "7 月",
            month8: "8 月",
            month9: "9 月",
            month10: "10 月",
            month11: "11 月",
            month12: "12 月",
            weeks: {
                sun: "日",
                mon: "一",
                tue: "二",
                wed: "三",
                thu: "四",
                fri: "五",
                sat: "六",
            },
            months: {
                jan: "一月",
                feb: "二月",
                mar: "三月",
                apr: "四月",
                may: "五月",
                jun: "六月",
                jul: "七月",
                aug: "八月",
                sep: "九月",
                oct: "十月",
                nov: "十一月",
                dec: "十二月",
            },
        },
        select: {
            loading: "加载中",
            noMatch: "无匹配数据",
            noData: "无数据",
            placeholder: "请选择",
        },
        cascader: {
            noMatch: "无匹配数据",
            loading: "加载中",
            placeholder: "请选择",
            noData: "暂无数据",
        },
        pagination: {
            goto: "前往",
            pagesize: "条/页",
            total: "共 {total} 条",
            pageClassifier: "页",
        },
        messagebox: {
            title: "提示",
            confirm: "确定",
            cancel: "取消",
            error: "输入的数据不合法!",
        },
        upload: {
            deleteTip: "按 delete 键可删除",
            delete: "删除",
            preview: "查看图片",
            continue: "继续上传",
        },
        table: {
            emptyText: "暂无数据",
            confirmFilter: "筛选",
            resetFilter: "重置",
            clearFilter: "全部",
            sumText: "合计",
        },
        tree: {
            emptyText: "暂无数据",
        },
        transfer: {
            noMatch: "无匹配数据",
            noData: "无数据",
            titles: ["列表 1", "列表 2"],
            filterPlaceholder: "请输入搜索内容",
            noCheckedFormat: "共 {total} 项",
            hasCheckedFormat: "已选 {checked}/{total} 项",
        },
        image: {
            error: "加载失败",
        },
        pageHeader: {
            title: "返回",
        },
        popconfirm: {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
        },
        empty: {
            description: "暂无数据",
        },
    },
    login: {
		slogan: '高性能 / 精致 / 优雅',
		describe: '基于Vue3 + Element-Plus 的中后台前端解决方案。',
		signInTitle: '用户登录',
		accountLogin: '账号登录',
		mobileLogin: '手机号登录',
		rememberMe: '24小时免登录',
		forgetPassword: '忘记密码',
		signIn: '登录',
		signInOther: '其他登录方式',
		userPlaceholder: '用户名 / 手机 / 邮箱',
		userError: '请输入用户名',
		PWPlaceholder: '请输入密码',
		PWError: '请输入密码',
		admin: '管理员',
		user: '用户',
		mobilePlaceholder: '手机号码',
		mobileError: '请输入手机号码',
		smsPlaceholder: '短信验证码',
		smsError: '请输入短信验证码',
		smsGet: '获取验证码',
		smsSent: '已发送短信至手机号码',
		noAccount: '还没有账号?',
		createAccount: '创建新账号',
		wechatLoginTitle: '二维码登录',
		wechatLoginMsg: '请使用微信扫一扫登录 | 模拟3秒后自动扫描',
		wechatLoginResult: '已扫描 | 请在设备中点击授权登录'
	},
	user: {
		dynamic: '近期动态',
		info: '个人信息',
		settings: '设置',
		nightmode: '黑夜模式',
		nightmode_msg: '适合光线较弱的环境，当前黑暗模式为beta版本',
		language: '语言',
		language_msg: '翻译进行中，暂翻译了本视图的文本',
	}
};
export default translations